import { isEmpty as xa, cloneDeep as dt, clone as Ha, groupBy as Wa, isObject as Ka, isArray as ja, map as Ya, mapValues as Za, omitBy as Ja, pick as qa, omit as za, uniq as xe, truncate as Qa, values as Xa, capitalize as en } from "lodash-es";
import { DateTime as w } from "luxon";
import A from "moment-timezone";
import { InterviewRequestSourceEnum as R, MIN_THRESHOLD_MONTHS as tn, ReportRequestTypeCodeBackwardCompatEnum as h } from "@rooster/types";
import dn from "axios";
import an from "password-validator";
import { parsePhoneNumber as Qt, parsePhoneNumberFromString as nn } from "libphonenumber-js";
import Ut from "moment-duration-format";
const rn = (e, t) => {
  if (!e) return !1;
  if ("items" in e && e.type === t && e.items?.length > 0)
    return !0;
  if ("groups" in e && Array.isArray(e.groups)) {
    for (const d of e.groups)
      if (rn(d, t))
        return !0;
  }
  return !1;
}, wd = (e) => {
  switch (e) {
    case "email":
      return "Interviewers";
    case "tag":
      return "Tags";
    case "role":
      return "Roles";
  }
}, Ud = (e) => e?.groups?.reduce((t, d) => "items" in d ? t + d.items.length : t + Ud(d), 0) ?? 0, Bd = (e) => {
  const t = /* @__PURE__ */ new Set();
  for (const d of e.groups)
    "items" in d ? t.add(wd(d.type)) : Bd(d).forEach(
      (a) => t.add(a)
    );
  return Array.from(t);
}, Xt = (e) => {
  switch (e) {
    case "AND":
      return "Must have";
    case "OR":
      return "Any";
    case "NOTIN":
      return "Exclude";
    default:
      return String(e);
  }
}, P2 = (e, t) => {
  if (e.groups.length === 0 && (!t || t.length === 0))
    return "No filters selected";
  let d = "";
  t && t.length > 0 && (d = `Required: ${t.length > 3 ? `${t.slice(0, 3).map((r) => r.value.split(" ")[0]).join(", ")}... (${t.length})` : t.map((r) => r.displayName).join(", ")}`);
  const a = e.groups.map((n) => {
    if ("items" in n) {
      if (n.items.length === 0) return "";
      const l = wd(n.type), i = n.items.length > 4 ? `${n.items.slice(0, 4).map((c) => c.value).join(", ")}... (${n.items.length})` : n.items.map((c) => c.value).join(", ");
      return `(${l} ${Xt(n.operation)} (${i}))`;
    }
    const r = Ud(n), o = Bd(n);
    return r > 0 ? `[${o.join(", ")} - ${r} items]` : "";
  }).filter((n) => n !== "");
  return a.length > 0 && (d && (d += " | "), d += `Filters: ${a.join(` ${Xt(e.operation)} `)}`), d;
}, w2 = ({
  interviewersAndRoles: e,
  selectedInterviewers: t,
  selectedRoles: d
}) => {
  if (!e)
    return {
      requiredInterviewers: [],
      compositeFilter: {
        id: "root",
        operation: "OR",
        groups: [],
        isRoot: !0
      }
    };
  const a = {
    requiredInterviewers: [],
    compositeFilter: {
      id: "root",
      operation: "OR",
      groups: [],
      isRoot: !0
    }
  }, n = () => `id-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
  if (t?.length > 0) {
    const r = t.map((o) => ({
      id: o?.key,
      type: "email",
      value: o.email,
      displayName: `${o.firstName} ${o.lastName} (${o.email})`
    }));
    a.requiredInterviewers = r;
  }
  if (d?.length > 0) {
    const r = {
      id: n(),
      type: "role",
      operation: "OR",
      items: d.map((o) => ({
        id: o?.key,
        type: "role",
        value: o?.name,
        displayName: o?.name
      }))
    };
    a?.compositeFilter?.groups.push(r);
  }
  return a;
}, U2 = (e) => {
  if (!e || !Array.isArray(e) || e.length === 0)
    return null;
  const t = e.map((d) => {
    const a = d?.requestDate;
    if (!a)
      return null;
    const n = a._seconds ?? a.seconds;
    return n ? n * 1e3 : null;
  }).filter((d) => d !== null && !isNaN(d));
  return t.length === 0 ? null : Math.max(...t);
}, on = (e) => Object.keys(e).reduce(
  (t, d) => (e[d].locked && (t[d] = { ...Ha(e[d]) }), t),
  {}
), B2 = ({
  interviewRules: e,
  tenantRules: t,
  userRules: d
}) => {
  const a = on(t);
  return e ? dt(e) : !d || xa(d) ? dt(t) : { ...dt(d), ...dt(a) };
}, ln = /^[=+\-@]/, cn = /^[\t\r\n]/;
function sn(e) {
  return Number.isFinite(Number(e)) && e === String(Number(e));
}
function un(e) {
  return cn.test(e) ? !0 : ln.test(e.trimStart());
}
function mn(e, t = "spreadsheet") {
  if (e == null) return "";
  const d = String(e);
  return t === "machine" || d.length === 0 || !un(d) || sn(d) ? d : `'${d}`;
}
function G2(e, t = "spreadsheet") {
  const d = {};
  for (const [a, n] of Object.entries(e))
    d[a] = typeof n == "string" ? mn(n, t) : n;
  return d;
}
function F(e, t) {
  if (e == null || e === "")
    return null;
  let d;
  if (e instanceof Date)
    d = w.fromJSDate(e);
  else if (typeof e == "string")
    d = w.fromISO(e), d.isValid || (d = w.fromJSDate(new Date(e)));
  else if (typeof e == "number")
    d = w.fromMillis(e);
  else
    return null;
  return t && d.isValid && (d = d.setZone(t)), d.isValid ? d : null;
}
function Gd(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("MMM d, yyyy") : "";
}
function le(e, t, d = !1) {
  const a = F(e, t);
  return a ? a.toFormat(d ? "HH:mm" : "h:mm a") : "";
}
function He(e, t, d = !1) {
  const a = F(e, t);
  return a ? a.toFormat(`MMM d, yyyy ${d ? "HH:mm" : "h:mm a"}`) : "";
}
function k2(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("MMM d, yyyy h:mm:ss a") : "";
}
function gn(e, t, d) {
  const a = F(e, d), n = F(t, d);
  return !a || !n ? "" : a.hasSame(n, "day") ? `${a.toFormat("MMM d, yyyy h:mm a")} - ${n.toFormat("h:mm a")}` : `${a.toFormat("MMM d, yyyy h:mm a")} - ${n.toFormat("MMM d, yyyy h:mm a")}`;
}
function V2(e, t, d) {
  const a = F(e, d);
  if (!a) return "";
  const n = a.plus({ minutes: t });
  return gn(
    a.toJSDate(),
    n.toJSDate(),
    d
  );
}
function x2(e, t, d) {
  const a = F(e, d);
  if (!a) return { start: "", end: "" };
  const n = a.plus({ minutes: t });
  return {
    start: He(a.toJSDate(), d),
    end: He(n.toJSDate(), d)
  };
}
function H2(e, t) {
  return He(e, t);
}
function W2(e, t, d) {
  const a = F(e, d);
  if (!a) return "";
  const n = a.plus({ minutes: t });
  return He(n.toJSDate(), d);
}
function K2(e, t, d) {
  const a = F(e, d);
  if (!a) return !1;
  const n = a.plus({ minutes: t });
  return a.hasSame(n, "day");
}
function j2(e, t, d) {
  const a = F(e, d);
  if (!a) return "";
  const n = a.plus({ minutes: t });
  return a.hasSame(n, "day") ? le(n.toJSDate(), d) : He(n.toJSDate(), d);
}
function $n(e, t) {
  const d = F(e, t);
  if (!d) return "";
  const a = d.toFormat("MMM d, yyyy h:mm a"), n = d.toFormat("ZZZZ");
  return `${a} (${n})`;
}
function kd(e, t) {
  const d = F(e, t);
  return d ? `${d.toFormat("h:mm a")} (${d.toFormat("ZZZZ")})` : "";
}
function bt(e, t, d = !1) {
  const a = le(e, t, d);
  return !a || !t ? a : `${a} (${t.replace(/_/g, " ")})`;
}
function Y2(e, t) {
  const d = F(e, t);
  if (!d) return "";
  const a = d.toFormat("MMM d, yyyy"), n = d.toFormat("ZZZZ");
  return `${a} (${n})`;
}
function Z2(e, t, d, a = !1) {
  const n = F(e, d), r = F(t, d);
  if (!n || !r) return "";
  const o = n.hasSame(r, "day"), l = n.toFormat("ZZZZ"), i = a ? "HH:mm" : "h:mm a", c = `MMM d, yyyy ${i}`;
  return o ? `${n.toFormat(c)} - ${r.toFormat(i)} (${l})` : `${n.toFormat(c)} (${l}) - ${r.toFormat(c)} (${l})`;
}
function J2(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("EEE, MMM d, yyyy") : "";
}
function we(e, t, d = {}) {
  const a = F(e, t);
  if (!a) return "";
  const {
    includeTime: n = !1,
    is24HourFormat: r = !1,
    includeTimezoneAbbr: o = !1
  } = d, i = n ? `EEEE, MMMM d, yyyy 'at' ${r ? "HH:mm" : "h:mm a"}` : "EEEE, MMMM d, yyyy", c = a.toFormat(i);
  return o ? `${c} (${a.toFormat("ZZZZ")})` : c;
}
function q2(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("EEE, MMM d, yyyy h:mm a") : "";
}
function z2(e, t) {
  const d = F(e, t);
  if (!d) return "";
  const a = d.toFormat("EEE, MMM d, yyyy"), n = d.toFormat("ZZZZ");
  return `${a} (${n})`;
}
function Q2(e, t) {
  const d = F(e, t);
  if (!d) return "";
  const a = d.toFormat("EEE, MMM d, yyyy h:mm a"), n = d.toFormat("ZZZZ");
  return `${a} (${n})`;
}
function X2(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("MMM") : "";
}
function e1(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("d") : "";
}
function t1(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("EEEE") : "";
}
function yn(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("EEE") : "";
}
function Lt(e, t) {
  if (e == null || e === "")
    return null;
  let d;
  if (e instanceof Date)
    d = w.fromJSDate(e);
  else if (typeof e == "string") {
    if (t) {
      const a = e.replace(/Z|[+-]\d{2}:\d{2}$/g, "");
      d = w.fromISO(a, { zone: t });
    } else
      d = w.fromISO(e);
    d.isValid || (d = w.fromJSDate(new Date(e)));
  } else if (typeof e == "number")
    d = w.fromMillis(e);
  else
    return null;
  return d.isValid ? d : null;
}
function d1(e, t) {
  const d = Lt(e, t);
  if (!d) return "";
  const a = d.toFormat("MMM d, yyyy h:mm a"), n = d.toFormat("ZZZZ");
  return `${a} (${n})`;
}
function a1(e, t, d, a = !1) {
  const n = Lt(e, d), r = Lt(t, d);
  if (!n || !r) return "";
  const o = n.hasSame(r, "day"), l = n.toFormat("ZZZZ"), i = a ? "HH:mm" : "h:mm a", c = `MMM d, yyyy ${i}`;
  return o ? `${n.toFormat(c)} - ${r.toFormat(i)} (${l})` : `${n.toFormat(c)} (${l}) - ${r.toFormat(c)} (${l})`;
}
function n1(e) {
  return e || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
function r1(e, t) {
  const d = F(e, t);
  return d ? d.toFormat("yyyy-MM-dd") : "";
}
function o1(e, t, d) {
  const a = F(e, d), n = F(t, d);
  return !a || !n ? !1 : a.hasSame(n, "day");
}
function l1(e, t) {
  const d = F(e, t);
  return d ? `${d.weekNumber}-${d.weekYear}` : "";
}
function i1(e) {
  const t = e ? w.now().setZone(e) : w.now();
  return `${t.weekNumber}-${t.weekYear}`;
}
function Vd(e, t, d) {
  const a = w.fromObject(
    { weekYear: t, weekNumber: e, weekday: 1 },
    { zone: d }
  ).startOf("day"), n = a.plus({ days: 6 }).endOf("day");
  return { start: a, end: n };
}
function c1(e, t) {
  if (!e) return "";
  const d = e.split("-");
  if (d.length !== 2) return "";
  const a = Number.parseInt(d[0], 10), n = Number.parseInt(d[1], 10);
  if (Number.isNaN(a) || Number.isNaN(n)) return "";
  const { start: r, end: o } = Vd(a, n, t);
  return `${r.toFormat("MMM dd")} - ${o.toFormat("MMM dd")}`;
}
function s1(e, t) {
  const d = t ? w.now().setZone(t) : w.now();
  return {
    startDate: d.toFormat("yyyy-MM-dd"),
    endDate: d.plus({ days: e }).toFormat("yyyy-MM-dd")
  };
}
function u1(e, t) {
  const d = F(e, t);
  return d ? d.toMillis() : 0;
}
function m1(e) {
  return (e ? w.now().setZone(e) : w.now()).toMillis();
}
function g1(e) {
  const t = e ? w.now().setZone(e) : w.now(), d = t.weekNumber, a = t.weekYear, { start: n, end: r } = Vd(d, a, e);
  return {
    weekNumber: d,
    year: a,
    weekKey: `${d}-${a}`,
    startDate: n.toFormat("yyyy-MM-dd"),
    endDate: r.toFormat("yyyy-MM-dd"),
    startMs: n.toMillis(),
    endMs: r.toMillis()
  };
}
const $1 = "MMM dd, yyyy", y1 = "MMM DD, YYYY hh:mm A", E1 = "h:mm A", N1 = "DDD, MMM DD, YYYY", En = [], Nn = [], ht = [
  "hotmail",
  "outlook",
  "live",
  "passport",
  "msn",
  "aol",
  "yahoo",
  "gmail",
  "papercranegames"
], f1 = (e, t) => {
  const d = [
    ...ht,
    ...Nn
  ], a = [
    ...ht,
    ...En
  ];
  return t ? t === "google" ? d.includes(e) : t === "office365" ? a.includes(e) : !1 : ht.includes(
    e
  );
}, p1 = (e) => {
  const [, t] = e.toLowerCase().split("@");
  return t;
}, C1 = (e) => /[^\x20-\x7E]/.test(e) ? `=?UTF-8?B?${Buffer.from(e).toString("base64")}?=` : e, I1 = (e, t, d) => {
  const a = (e ?? "").trim(), n = (t ?? "").trim(), r = `${a} ${n}`.trim();
  return r || (d?.split("@")[0] ?? "");
};
function A1(e) {
  return e?.toLowerCase()?.trim() ?? "";
}
const St = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1 }, T1 = {
  "kognitiv-scheduler": "production",
  "rooster-staging": "staging",
  "rooster-sandbox": "sandbox",
  "rooster-qa": "qa",
  "rooster-qa-automation": "qa-automation",
  "rooster-europe": "production-europe",
  "rooster-europe-sandbox": "sandbox-europe",
  "rooster-preview": "preview",
  "rooster-impl": "impl",
  "rooster-development": "rooster-development",
  "rooster-hotfix": "hotfix",
  "rooster-hotfix-automation": "hotfix-automation",
  "rooster-europe-impl": "impl-europe",
  "rooster-europe-preview": "preview-europe"
}, h1 = {
  "kognitiv-scheduler": "production",
  "rooster-staging": "development-staging",
  "rooster-sandbox": "development",
  "rooster-qa": "qa",
  "rooster-qa-automation": "development-qa-automation",
  "rooster-europe": "production-europe",
  "rooster-europe-sandbox": "sandbox-europe",
  "rooster-preview": "preview",
  "rooster-impl": "impl",
  "rooster-development": "rooster-development",
  "rooster-hotfix": "hotfix",
  "rooster-hotfix-automation": "hotfix-automation",
  "rooster-europe-impl": "impl-europe",
  "rooster-europe-preview": "preview-europe"
}, fn = {
  "kognitiv-scheduler": {
    api: "https://api.roosterinc.com",
    app: "https://app.roosterinc.com",
    dataHandlerApi: "https://api.roosterinc.com/data-handler"
  },
  "rooster-staging": {
    api: "https://api-staging.roosterinc.com",
    app: "https://staging.roosterinc.com",
    dataHandlerApi: "https://api-staging.roosterinc.com/data-handler"
  },
  "rooster-sandbox": {
    api: "https://api-sandbox.roosterinc.com",
    app: "https://sandbox.roosterinc.com",
    dataHandlerApi: "https://api-sandbox.roosterinc.com/data-handler"
  },
  "rooster-qa": {
    api: "https://api-qa.roosterinc.com",
    app: "https://qa.roosterinc.com",
    dataHandlerApi: "https://api-qa.roosterinc.com/data-handler"
  },
  "rooster-qa-automation": {
    api: "https://api-qa-automation.roosterinc.com",
    app: "https://qa-automation.roosterinc.com",
    dataHandlerApi: "https://data-api-qa-automation.roosterinc.com/data-handler"
  },
  "rooster-europe": {
    api: "https://api-eu.roosterinc.com",
    app: "https://eu.roosterinc.com",
    dataHandlerApi: "https://api-eu.roosterinc.com/data-handler"
  },
  "rooster-europe-sandbox": {
    api: "https://api-sandbox-eu.roosterinc.com",
    app: "https://sandbox-eu.roosterinc.com",
    dataHandlerApi: "https://api-sandbox-eu.roosterinc.com/data-handler"
  },
  "rooster-preview": {
    api: "https://api-preview.roosterinc.com",
    app: "https://preview.roosterinc.com",
    dataHandlerApi: "https://data-api-preview.roosterinc.com/data-handler"
  },
  "rooster-impl": {
    api: "https://api-impl.roosterinc.com",
    app: "https://impl.roosterinc.com",
    dataHandlerApi: "https://api-impl.roosterinc.com/data-handler"
  },
  "rooster-development": {
    api: "https://api-dev.roosterinc.com",
    app: "https://dev.roosterinc.com",
    dataHandlerApi: "https://data-api-dev.roosterinc.com/data-handler"
  },
  "rooster-hotfix": {
    api: "https://api-hotfix.roosterinc.com",
    app: "https://hotfix.roosterinc.com",
    dataHandlerApi: "https://data-api-hotfix.roosterinc.com/data-handler"
  },
  "rooster-hotfix-automation": {
    api: "https://api-hotfix-automation.roosterinc.com",
    app: "https://hotfix-automation.roosterinc.com",
    dataHandlerApi: "https://data-api-hotfix-automation.roosterinc.com/data-handler"
  },
  "rooster-europe-impl": {
    api: "https://api-impl-eu.roosterinc.com",
    app: "https://impl-eu.roosterinc.com",
    dataHandlerApi: "https://api-impl-eu.roosterinc.com/data-handler"
  },
  "rooster-europe-preview": {
    api: "https://api-preview-eu.roosterinc.com",
    app: "https://preview-eu.roosterinc.com",
    dataHandlerApi: "https://api-preview-eu.roosterinc.com/data-handler"
  }
}, S = (e) => {
  if (typeof window < "u" && window?.__ROOSTER_ENV && e in window.__ROOSTER_ENV)
    return window.__ROOSTER_ENV[e];
  if (typeof import.meta < "u" && typeof St < "u" && e in St)
    return St[e];
  if (typeof process < "u" && process.env && e in process.env)
    return process.env[e];
}, b = {
  REACT_APP_ENV: S("REACT_APP_ENV") ?? S("VITE_REACT_APP_ENV") ?? "",
  REACT_APP_URL_API: S("REACT_APP_URL_API") ?? S("VITE_REACT_APP_URL_API") ?? "",
  VITE_REACT_APP_URL_API: S("VITE_REACT_APP_URL_API") ?? "",
  REACT_APP_PROJECT_ID: S("REACT_APP_PROJECT_ID") ?? "",
  GOOGLE_REGION_ID: S("GOOGLE_REGION_ID") ?? ""
}, pn = {
  api: S("REACT_APP_MY_LOCAL_URL") ? `${S("REACT_APP_MY_LOCAL_URL")}/api` : "http://localhost:5000",
  app: "http://localhost:3000",
  dataHandlerApi: S("REACT_APP_MY_LOCAL_URL") ? `${S("REACT_APP_MY_LOCAL_URL")}/data-handler` : "http://localhost:8080/data-handler",
  eventsApi: S("REACT_APP_MY_LOCAL_URL") ? `${S("REACT_APP_MY_LOCAL_URL")}/events-api` : "http://localhost:8081/events-api"
}, xd = () => {
  if (typeof window > "u") return !1;
  const e = window?.location?.hostname;
  return S("REACT_APP_KOG_URL")?.includes(e);
}, ot = () => xd() ? S("REACT_APP_URL_KOG_API") : S("REACT_APP_URL_API"), Hd = () => mt() ? "http://localhost:5173" : {
  roosterlink: S("REACT_APP_ROOSTER_LINKS_EXTERNAL_URL"),
  candidateAutobook: S(
    "REACT_APP_ROOSTER_AUTOBOOK_EXTERNAL_URL"
  ),
  candidateAvailability: S(
    "REACT_APP_ROOSTER_AVAILABILITY_EXTERNAL_URL"
  ),
  genericExternalAppUrl: S(
    "REACT_APP_ROOSTER_EXTERNAL_APP_GENERIC_URL"
  )
}, S1 = () => xd() ? S("REACT_APP_KOG_URL") : S("REACT_APP_URL"), _1 = (e) => S("REACT_APP_MY_LOCAL_URL") ? pn.dataHandlerApi : fn[e?.REACT_APP_PROJECT_ID]?.dataHandlerApi, R1 = () => b.REACT_APP_ENV === "qa", F1 = () => b.REACT_APP_ENV === "development", b1 = () => b.REACT_APP_ENV === "hotfix", L1 = () => b.REACT_APP_ENV === "hotfix-automation", M1 = () => b.REACT_APP_ENV === "qa-automation", D1 = () => b.REACT_APP_ENV === "preview", Cn = () => b.REACT_APP_ENV === "impl", In = () => b.REACT_APP_ENV === "impl-europe", An = () => b.REACT_APP_ENV === "preview-europe", v1 = () => b.REACT_APP_ENV?.includes("sandbox"), Tn = () => b.REACT_APP_ENV === "staging", hn = () => b.REACT_APP_ENV?.includes("production"), mt = () => {
  const e = S("REACT_APP_URL_API") ?? S("VITE_REACT_APP_URL_API");
  return !!(e?.includes("localhost") || e?.includes("ngrok"));
}, O1 = () => hn() || Cn() || In() || An() || Tn(), Sn = () => [
  "production-europe",
  "sandbox-europe",
  "impl-europe",
  "preview-europe",
  "production",
  "sandbox",
  "impl",
  "hotfix-automation",
  "staging",
  "qa",
  "hotfix",
  "qa-automation",
  "preview",
  "rooster-development"
].includes(b.REACT_APP_ENV ?? ""), Wd = S("REACT_APP_MY_LOCAL_URL") ? `${S("REACT_APP_MY_LOCAL_URL")}/functions` : "http://localhost:5001", P1 = (e = !1) => !e && mt() ? `${Wd}/${b.REACT_APP_PROJECT_ID}/${b.GOOGLE_REGION_ID}` : Sn() ? `${b.REACT_APP_URL_API}/functions` : `https://${b.GOOGLE_REGION_ID || "us-central1"}-${b.REACT_APP_PROJECT_ID}.cloudfunctions.net`, w1 = (e = !1) => !e && mt() ? `${Wd}/${b.REACT_APP_PROJECT_ID}/${b.GOOGLE_REGION_ID}` : `https://${b.GOOGLE_REGION_ID || "us-central1"}-${b.REACT_APP_PROJECT_ID}.cloudfunctions.net`, U1 = b.GOOGLE_REGION_ID, _n = {
  production: "https://scheduler-api.kognitivinc.com",
  sandbox: "https://rooster-api-sandbox.kognitivinc.com",
  preview: "https://api-preview.roosterinc.com",
  qa: "https://api-qa.roosterinc.com",
  "qa-automation": "https://api-qa-automation.roosterinc.com",
  staging: "https://rooster-api-staging.kognitivinc.com",
  "production-europe": "https://api.rooster-eu.com",
  "sandbox-europe": "https://api-sandbox.rooster-eu.com",
  impl: "https://rooster-api-impl.kognitivinc.com",
  hotfix: "https://rooster-api-hotfix.kognitivinc.com",
  "rooster-development": "https://rooster-api-development.kognitivinc.com",
  "impl-europe": "https://api-impl-eu.roosterinc.com",
  "preview-europe": "https://api-preview-eu.roosterinc.com"
}, B1 = () => mt() ? b.REACT_APP_ENV ? _n?.[b.REACT_APP_ENV] : "" : b.REACT_APP_URL_API, G1 = (e) => {
  if (e.length <= 1) return e;
  const t = [];
  let d = [];
  const a = e.sort((n, r) => n[0] - r[0]);
  t.push(a[0]);
  for (let n = 1; n < a.length; n += 1)
    d = t[t.length - 1], d[1] < a[n][0] ? t.push(a[n]) : d[1] < a[n][1] && (d[1] = a[n][1], t.pop(), t.push(d));
  return t;
}, k1 = (e) => e ? 1 : 0;
function V1() {
  return S("POSTGRES_ENABLED") === "true";
}
function x1() {
  return S("POSTGRES_ENABLED") !== "false";
}
function H1(e) {
  if (e?.length)
    return e.length === 1 ? e[0] : e.reduce((t, d) => {
      const a = t.data()?.updated?.seconds ?? 0;
      return (d.data()?.updated?.seconds ?? 0) > a ? d : t;
    });
}
const Rn = /url[\s\u00a0]*\(|expression[\s\u00a0]*\(|javascript:|behavior[\s\u00a0]*:|@import|-moz-binding/i;
function W1(e) {
  if (!e) return "";
  const t = e.split(";"), d = [];
  for (const a of t) {
    const n = a.trim();
    n && (Rn.test(n) || d.push(n));
  }
  return d.join("; ");
}
function K1(e) {
  if (!e) return "";
  const t = document.createElement("div");
  return t.innerHTML = e, t.querySelectorAll("img:not([alt])").forEach((d) => {
    d.setAttribute("alt", "");
  }), t.innerHTML;
}
function j1(e) {
  if (!e) return "";
  let t = e.replace(/<html[^>]*>/gi, "").replace(/<\/html>/gi, "").replace(/<head[^>]*>.*?<\/head>/gis, "").replace(/<body[^>]*>/gi, "").replace(/<\/body>/gi, "").replace(/<script[^>]*>.*?<\/script>/gis, "").replace(/<style[^>]*>.*?<\/style>/gis, "").replace(/<!DOCTYPE[^>]*>/gi, "").replace(/<\?xml[^>]*\?>/gi, "").replace(/<o:p>.*?<\/o:p>/gi, "").replace(/<\/?o:[^>]*>/gi, "");
  return t = t.replace(
    /<p>\s*(<(ul|ol|table|div|blockquote)[^>]*>)/gi,
    "$1"
  ), t = t.replace(
    /(<\/(ul|ol|table|div|blockquote)>\s*)<\/p>/gi,
    "$1"
  ), t.replace(/<p>\s*<p>/gi, "<p>").replace(/<\/p>\s*<\/p>/gi, "</p>").replace(/<p><\/p>/gi, "");
}
const Fn = [
  {
    locale: "aa-ER",
    languageName: "Afar",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "af-NA",
    languageName: "Afrikaans",
    countryName: "Namibia",
    countryFlag: "🇳🇦",
    countryCode: "NA"
  },
  {
    locale: "af-ZA",
    languageName: "Afrikaans",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "am-ET",
    languageName: "Amharic",
    countryName: "Ethiopia",
    countryFlag: "🇪🇹",
    countryCode: "ET"
  },
  {
    locale: "ar-EG",
    languageName: "Arabic",
    countryName: "Egypt",
    countryFlag: "🇪🇬",
    countryCode: "EG"
  },
  {
    locale: "ar-DZ",
    languageName: "Arabic",
    countryName: "Algeria",
    countryFlag: "🇩🇿",
    countryCode: "DZ"
  },
  {
    locale: "ar-BH",
    languageName: "Arabic",
    countryName: "Bahrain",
    countryFlag: "🇧🇭",
    countryCode: "BH"
  },
  {
    locale: "ar-DJ",
    languageName: "Arabic",
    countryName: "Djibouti",
    countryFlag: "🇩🇯",
    countryCode: "DJ"
  },
  {
    locale: "ar-ER",
    languageName: "Arabic",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "ar-IQ",
    languageName: "Arabic",
    countryName: "Iraq",
    countryFlag: "🇮🇶",
    countryCode: "IQ"
  },
  {
    locale: "ar-IL",
    languageName: "Arabic",
    countryName: "Israel",
    countryFlag: "🇮🇱",
    countryCode: "IL"
  },
  {
    locale: "ar-YE",
    languageName: "Arabic",
    countryName: "Yemen",
    countryFlag: "🇾🇪",
    countryCode: "YE"
  },
  {
    locale: "ar-JO",
    languageName: "Arabic",
    countryName: "Jordan",
    countryFlag: "🇯🇴",
    countryCode: "JO"
  },
  {
    locale: "ar-QA",
    languageName: "Arabic",
    countryName: "Qatar",
    countryFlag: "🇶🇦",
    countryCode: "QA"
  },
  {
    locale: "ar-KM",
    languageName: "Arabic",
    countryName: "Comoros",
    countryFlag: "🇰🇲",
    countryCode: "KM"
  },
  {
    locale: "ar-KW",
    languageName: "Arabic",
    countryName: "Kuwait",
    countryFlag: "🇰🇼",
    countryCode: "KW"
  },
  {
    locale: "ar-LB",
    languageName: "Arabic",
    countryName: "Lebanon",
    countryFlag: "🇱🇧",
    countryCode: "LB"
  },
  {
    locale: "ar-LY",
    languageName: "Arabic",
    countryName: "Libya",
    countryFlag: "🇱🇾",
    countryCode: "LY"
  },
  {
    locale: "ar-MA",
    languageName: "Arabic",
    countryName: "Morocco",
    countryFlag: "🇲🇦",
    countryCode: "MA"
  },
  {
    locale: "ar-MR",
    languageName: "Arabic",
    countryName: "Mauritania",
    countryFlag: "🇲🇷",
    countryCode: "MR"
  },
  {
    locale: "ar-OM",
    languageName: "Arabic",
    countryName: "Oman",
    countryFlag: "🇴🇲",
    countryCode: "OM"
  },
  {
    locale: "ar-PS",
    languageName: "Arabic",
    countryName: "Palestine",
    countryFlag: "🇵🇸",
    countryCode: "PS"
  },
  {
    locale: "ar-SA",
    languageName: "Arabic",
    countryName: "Saudi Arabia",
    countryFlag: "🇸🇦",
    countryCode: "SA"
  },
  {
    locale: "ar-SO",
    languageName: "Arabic",
    countryName: "Somalia",
    countryFlag: "🇸🇴",
    countryCode: "SO"
  },
  {
    locale: "ar-SD",
    languageName: "Arabic",
    countryName: "Sudan",
    countryFlag: "🇸🇩",
    countryCode: "SD"
  },
  {
    locale: "ar-SY",
    languageName: "Arabic",
    countryName: "Syria",
    countryFlag: "🇸🇾",
    countryCode: "SY"
  },
  {
    locale: "ar-TD",
    languageName: "Arabic",
    countryName: "Chad",
    countryFlag: "🇹🇩",
    countryCode: "TD"
  },
  {
    locale: "ar-TN",
    languageName: "Arabic",
    countryName: "Tunisia",
    countryFlag: "🇹🇳",
    countryCode: "TN"
  },
  {
    locale: "ar-AE",
    languageName: "Arabic",
    countryName: "United Arab Emirates",
    countryFlag: "🇦🇪",
    countryCode: "AE"
  },
  {
    locale: "ay-BO",
    languageName: "Aymara",
    countryName: "Bolivia",
    countryFlag: "🇧🇴",
    countryCode: "BO"
  },
  {
    locale: "az-AZ",
    languageName: "Azerbaijani",
    countryName: "Azerbaijan",
    countryFlag: "🇦🇿",
    countryCode: "AZ"
  },
  {
    locale: "be-BY",
    languageName: "Belarusian",
    countryName: "Belarus",
    countryFlag: "🇧🇾",
    countryCode: "BY"
  },
  {
    locale: "bn-BD",
    languageName: "Bengali",
    countryName: "Bangladesh",
    countryFlag: "🇧🇩",
    countryCode: "BD"
  },
  {
    locale: "bi-VU",
    languageName: "Bislama",
    countryName: "Vanuatu",
    countryFlag: "🇻🇺",
    countryCode: "VU"
  },
  {
    locale: "bs-BA",
    languageName: "Bosnian",
    countryName: "Bosnia and Herzegovina",
    countryFlag: "🇧🇦",
    countryCode: "BA"
  },
  {
    locale: "bs-ME",
    languageName: "Bosnian",
    countryName: "Montenegro",
    countryFlag: "🇲🇪",
    countryCode: "ME"
  },
  {
    locale: "bg-BG",
    languageName: "Bulgarian",
    countryName: "Bulgaria",
    countryFlag: "🇧🇬",
    countryCode: "BG"
  },
  {
    locale: "byn-ER",
    languageName: "Bilen",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "ca-AD",
    languageName: "Catalan",
    countryName: "Andorra",
    countryFlag: "🇦🇩",
    countryCode: "AD"
  },
  {
    locale: "cs-CZ",
    languageName: "Czech",
    countryName: "Czechia",
    countryFlag: "🇨🇿",
    countryCode: "CZ"
  },
  {
    locale: "ch-GU",
    languageName: "Chamorro",
    countryName: "Guam",
    countryFlag: "🇬🇺",
    countryCode: "GU"
  },
  {
    locale: "ch-MP",
    languageName: "Chamorro",
    countryName: "Northern Mariana Islands",
    countryFlag: "🇲🇵",
    countryCode: "MP"
  },
  {
    locale: "da-DK",
    languageName: "Danish",
    countryName: "Denmark",
    countryFlag: "🇩🇰",
    countryCode: "DK"
  },
  {
    locale: "de-BE",
    languageName: "German",
    countryName: "Belgium",
    countryFlag: "🇧🇪",
    countryCode: "BE"
  },
  {
    locale: "de-DE",
    languageName: "German",
    countryName: "Germany",
    countryFlag: "🇩🇪",
    countryCode: "DE"
  },
  {
    locale: "de-LI",
    languageName: "German",
    countryName: "Liechtenstein",
    countryFlag: "🇱🇮",
    countryCode: "LI"
  },
  {
    locale: "de-LU",
    languageName: "German",
    countryName: "Luxembourg",
    countryFlag: "🇱🇺",
    countryCode: "LU"
  },
  {
    locale: "de-AT",
    languageName: "German",
    countryName: "Austria",
    countryFlag: "🇦🇹",
    countryCode: "AT"
  },
  {
    locale: "de-CH",
    languageName: "German",
    countryName: "Switzerland",
    countryFlag: "🇨🇭",
    countryCode: "CH"
  },
  {
    locale: "de-VA",
    languageName: "German",
    countryName: "Vatican City",
    countryFlag: "🇻🇦",
    countryCode: "VA"
  },
  {
    locale: "dv-MV",
    languageName: "Divehi",
    countryName: "Maldives",
    countryFlag: "🇲🇻",
    countryCode: "MV"
  },
  {
    locale: "dz-BT",
    languageName: "Dzongkha",
    countryName: "Bhutan",
    countryFlag: "🇧🇹",
    countryCode: "BT"
  },
  {
    locale: "el-GR",
    languageName: "Greek (modern)",
    countryName: "Greece",
    countryFlag: "🇬🇷",
    countryCode: "GR"
  },
  {
    locale: "el-CY",
    languageName: "Greek (modern)",
    countryName: "Cyprus",
    countryFlag: "🇨🇾",
    countryCode: "CY"
  },
  {
    locale: "en-AS",
    languageName: "English",
    countryName: "American Samoa",
    countryFlag: "🇦🇸",
    countryCode: "AS"
  },
  {
    locale: "en-AI",
    languageName: "English",
    countryName: "Anguilla",
    countryFlag: "🇦🇮",
    countryCode: "AI"
  },
  {
    locale: "en-AQ",
    languageName: "English",
    countryName: "Antarctica",
    countryFlag: "🇦🇶",
    countryCode: "AQ"
  },
  {
    locale: "en-AG",
    languageName: "English",
    countryName: "Antigua and Barbuda",
    countryFlag: "🇦🇬",
    countryCode: "AG"
  },
  {
    locale: "en-AU",
    languageName: "English",
    countryName: "Australia",
    countryFlag: "🇦🇺",
    countryCode: "AU"
  },
  {
    locale: "en-BS",
    languageName: "English",
    countryName: "Bahamas",
    countryFlag: "🇧🇸",
    countryCode: "BS"
  },
  {
    locale: "en-BB",
    languageName: "English",
    countryName: "Barbados",
    countryFlag: "🇧🇧",
    countryCode: "BB"
  },
  {
    locale: "en-BZ",
    languageName: "English",
    countryName: "Belize",
    countryFlag: "🇧🇿",
    countryCode: "BZ"
  },
  {
    locale: "en-BM",
    languageName: "English",
    countryName: "Bermuda",
    countryFlag: "🇧🇲",
    countryCode: "BM"
  },
  {
    locale: "en-BW",
    languageName: "English",
    countryName: "Botswana",
    countryFlag: "🇧🇼",
    countryCode: "BW"
  },
  {
    locale: "en-IO",
    languageName: "English",
    countryName: "British Indian Ocean Territory",
    countryFlag: "🇮🇴",
    countryCode: "IO"
  },
  {
    locale: "en-CK",
    languageName: "English",
    countryName: "Cook Islands",
    countryFlag: "🇨🇰",
    countryCode: "CK"
  },
  {
    locale: "en-CW",
    languageName: "English",
    countryName: "Curacao",
    countryFlag: "🇨🇼",
    countryCode: "CW"
  },
  {
    locale: "en-DM",
    languageName: "English",
    countryName: "Dominica",
    countryFlag: "🇩🇲",
    countryCode: "DM"
  },
  {
    locale: "en-ER",
    languageName: "English",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "en-SZ",
    languageName: "English",
    countryName: "Eswatini",
    countryFlag: "🇸🇿",
    countryCode: "SZ"
  },
  {
    locale: "en-FK",
    languageName: "English",
    countryName: "Falkland Islands",
    countryFlag: "🇫🇰",
    countryCode: "FK"
  },
  {
    locale: "en-FJ",
    languageName: "English",
    countryName: "Fiji",
    countryFlag: "🇫🇯",
    countryCode: "FJ"
  },
  {
    locale: "en-FM",
    languageName: "English",
    countryName: "Federated States of Micronesia",
    countryFlag: "🇫🇲",
    countryCode: "FM"
  },
  {
    locale: "en-GM",
    languageName: "English",
    countryName: "Gambia",
    countryFlag: "🇬🇲",
    countryCode: "GM"
  },
  {
    locale: "en-GH",
    languageName: "English",
    countryName: "Ghana",
    countryFlag: "🇬🇭",
    countryCode: "GH"
  },
  {
    locale: "en-GI",
    languageName: "English",
    countryName: "Gibraltar",
    countryFlag: "🇬🇮",
    countryCode: "GI"
  },
  {
    locale: "en-GD",
    languageName: "English",
    countryName: "Grenada",
    countryFlag: "🇬🇩",
    countryCode: "GD"
  },
  {
    locale: "en-GU",
    languageName: "English",
    countryName: "Guam",
    countryFlag: "🇬🇺",
    countryCode: "GU"
  },
  {
    locale: "en-GG",
    languageName: "English",
    countryName: "Guernsey",
    countryFlag: "🇬🇬",
    countryCode: "GG"
  },
  {
    locale: "en-GY",
    languageName: "English",
    countryName: "Guyana",
    countryFlag: "🇬🇾",
    countryCode: "GY"
  },
  {
    locale: "en-HM",
    languageName: "English",
    countryName: "Heard Island and McDonald Islands",
    countryFlag: "🇭🇲",
    countryCode: "HM"
  },
  {
    locale: "en-HK",
    languageName: "English",
    countryName: "Hong Kong",
    countryFlag: "🇭🇰",
    countryCode: "HK"
  },
  {
    locale: "en-IN",
    languageName: "English",
    countryName: "India",
    countryFlag: "🇮🇳",
    countryCode: "IN"
  },
  {
    locale: "en-IM",
    languageName: "English",
    countryName: "Isle of Man",
    countryFlag: "🇮🇲",
    countryCode: "IM"
  },
  {
    locale: "en-IE",
    languageName: "English",
    countryName: "Ireland",
    countryFlag: "🇮🇪",
    countryCode: "IE"
  },
  {
    locale: "en-JM",
    languageName: "English",
    countryName: "Jamaica",
    countryFlag: "🇯🇲",
    countryCode: "JM"
  },
  {
    locale: "en-JE",
    languageName: "English",
    countryName: "Jersey",
    countryFlag: "🇯🇪",
    countryCode: "JE"
  },
  {
    locale: "en-VG",
    languageName: "English",
    countryName: "British Virgin Islands",
    countryFlag: "🇻🇬",
    countryCode: "VG"
  },
  {
    locale: "en-VI",
    languageName: "English",
    countryName: "Virgin Islands",
    countryFlag: "🇻🇮",
    countryCode: "VI"
  },
  {
    locale: "en-KY",
    languageName: "English",
    countryName: "Cayman Islands",
    countryFlag: "🇰🇾",
    countryCode: "KY"
  },
  {
    locale: "en-CM",
    languageName: "English",
    countryName: "Cameroon",
    countryFlag: "🇨🇲",
    countryCode: "CM"
  },
  {
    locale: "en-CA",
    languageName: "English",
    countryName: "Canada",
    countryFlag: "🇨🇦",
    countryCode: "CA"
  },
  {
    locale: "en-KE",
    languageName: "English",
    countryName: "Kenya",
    countryFlag: "🇰🇪",
    countryCode: "KE"
  },
  {
    locale: "en-KI",
    languageName: "English",
    countryName: "Kiribati",
    countryFlag: "🇰🇮",
    countryCode: "KI"
  },
  {
    locale: "en-UM",
    languageName: "English",
    countryName: "United States Minor Outlying Islands",
    countryFlag: "🇺🇲",
    countryCode: "UM"
  },
  {
    locale: "en-CC",
    languageName: "English",
    countryName: "Cocos (Keeling) Islands",
    countryFlag: "🇨🇨",
    countryCode: "CC"
  },
  {
    locale: "en-LS",
    languageName: "English",
    countryName: "Lesotho",
    countryFlag: "🇱🇸",
    countryCode: "LS"
  },
  {
    locale: "en-LR",
    languageName: "English",
    countryName: "Liberia",
    countryFlag: "🇱🇷",
    countryCode: "LR"
  },
  {
    locale: "en-MW",
    languageName: "English",
    countryName: "Malawi",
    countryFlag: "🇲🇼",
    countryCode: "MW"
  },
  {
    locale: "en-MT",
    languageName: "English",
    countryName: "Malta",
    countryFlag: "🇲🇹",
    countryCode: "MT"
  },
  {
    locale: "en-MH",
    languageName: "English",
    countryName: "Marshall Islands",
    countryFlag: "🇲🇭",
    countryCode: "MH"
  },
  {
    locale: "en-MU",
    languageName: "English",
    countryName: "Mauritius",
    countryFlag: "🇲🇺",
    countryCode: "MU"
  },
  {
    locale: "en-MS",
    languageName: "English",
    countryName: "Montserrat",
    countryFlag: "🇲🇸",
    countryCode: "MS"
  },
  {
    locale: "en-NA",
    languageName: "English",
    countryName: "Namibia",
    countryFlag: "🇳🇦",
    countryCode: "NA"
  },
  {
    locale: "en-NR",
    languageName: "English",
    countryName: "Nauru",
    countryFlag: "🇳🇷",
    countryCode: "NR"
  },
  {
    locale: "en-NZ",
    languageName: "English",
    countryName: "New Zealand",
    countryFlag: "🇳🇿",
    countryCode: "NZ"
  },
  {
    locale: "en-NG",
    languageName: "English",
    countryName: "Nigeria",
    countryFlag: "🇳🇬",
    countryCode: "NG"
  },
  {
    locale: "en-NU",
    languageName: "English",
    countryName: "Niue",
    countryFlag: "🇳🇺",
    countryCode: "NU"
  },
  {
    locale: "en-MP",
    languageName: "English",
    countryName: "Northern Mariana Islands",
    countryFlag: "🇲🇵",
    countryCode: "MP"
  },
  {
    locale: "en-NF",
    languageName: "English",
    countryName: "Norfolk Island",
    countryFlag: "🇳🇫",
    countryCode: "NF"
  },
  {
    locale: "en-PK",
    languageName: "English",
    countryName: "Pakistan",
    countryFlag: "🇵🇰",
    countryCode: "PK"
  },
  {
    locale: "en-PW",
    languageName: "English",
    countryName: "Palau",
    countryFlag: "🇵🇼",
    countryCode: "PW"
  },
  {
    locale: "en-PG",
    languageName: "English",
    countryName: "Papua New Guinea",
    countryFlag: "🇵🇬",
    countryCode: "PG"
  },
  {
    locale: "en-PH",
    languageName: "English",
    countryName: "Philippines",
    countryFlag: "🇵🇭",
    countryCode: "PH"
  },
  {
    locale: "en-PN",
    languageName: "English",
    countryName: "Pitcairn Islands",
    countryFlag: "🇵🇳",
    countryCode: "PN"
  },
  {
    locale: "en-PR",
    languageName: "English",
    countryName: "Puerto Rico",
    countryFlag: "🇵🇷",
    countryCode: "PR"
  },
  {
    locale: "en-RW",
    languageName: "English",
    countryName: "Rwanda",
    countryFlag: "🇷🇼",
    countryCode: "RW"
  },
  {
    locale: "en-MF",
    languageName: "English",
    countryName: "Saint Martin",
    countryFlag: "🇲🇫",
    countryCode: "MF"
  },
  {
    locale: "en-SB",
    languageName: "English",
    countryName: "Solomon Islands",
    countryFlag: "🇸🇧",
    countryCode: "SB"
  },
  {
    locale: "en-ZM",
    languageName: "English",
    countryName: "Zambia",
    countryFlag: "🇿🇲",
    countryCode: "ZM"
  },
  {
    locale: "en-WS",
    languageName: "English",
    countryName: "Samoa",
    countryFlag: "🇼🇸",
    countryCode: "WS"
  },
  {
    locale: "en-SC",
    languageName: "English",
    countryName: "Seychelles",
    countryFlag: "🇸🇨",
    countryCode: "SC"
  },
  {
    locale: "en-SL",
    languageName: "English",
    countryName: "Sierra Leone",
    countryFlag: "🇸🇱",
    countryCode: "SL"
  },
  {
    locale: "en-ZW",
    languageName: "English",
    countryName: "Zimbabwe",
    countryFlag: "🇿🇼",
    countryCode: "ZW"
  },
  {
    locale: "en-SG",
    languageName: "English",
    countryName: "Singapore",
    countryFlag: "🇸🇬",
    countryCode: "SG"
  },
  {
    locale: "en-SX",
    languageName: "English",
    countryName: "Sint Maarten",
    countryFlag: "🇸🇽",
    countryCode: "SX"
  },
  {
    locale: "en-SH",
    languageName: "English",
    countryName: "Saint Helena, Ascension and Tristan da Cunha",
    countryFlag: "🇸🇭",
    countryCode: "SH"
  },
  {
    locale: "en-KN",
    languageName: "English",
    countryName: "Saint Kitts and Nevis",
    countryFlag: "🇰🇳",
    countryCode: "KN"
  },
  {
    locale: "en-LC",
    languageName: "English",
    countryName: "Saint Lucia",
    countryFlag: "🇱🇨",
    countryCode: "LC"
  },
  {
    locale: "en-VC",
    languageName: "English",
    countryName: "Saint Vincent and the Grenadines",
    countryFlag: "🇻🇨",
    countryCode: "VC"
  },
  {
    locale: "en-ZA",
    languageName: "English",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "en-SD",
    languageName: "English",
    countryName: "Sudan",
    countryFlag: "🇸🇩",
    countryCode: "SD"
  },
  {
    locale: "en-GS",
    languageName: "English",
    countryName: "South Georgia and South Sandwich Islands",
    countryFlag: "🇬🇸",
    countryCode: "GS"
  },
  {
    locale: "en-SS",
    languageName: "English",
    countryName: "South Sudan",
    countryFlag: "🇸🇸",
    countryCode: "SS"
  },
  {
    locale: "en-TZ",
    languageName: "English",
    countryName: "Tanzania",
    countryFlag: "🇹🇿",
    countryCode: "TZ"
  },
  {
    locale: "en-TK",
    languageName: "English",
    countryName: "Tokelau",
    countryFlag: "🇹🇰",
    countryCode: "TK"
  },
  {
    locale: "en-TO",
    languageName: "English",
    countryName: "Tonga",
    countryFlag: "🇹🇴",
    countryCode: "TO"
  },
  {
    locale: "en-TT",
    languageName: "English",
    countryName: "Trinidad and Tobago",
    countryFlag: "🇹🇹",
    countryCode: "TT"
  },
  {
    locale: "en-TC",
    languageName: "English",
    countryName: "Turks and Caicos Islands",
    countryFlag: "🇹🇨",
    countryCode: "TC"
  },
  {
    locale: "en-TV",
    languageName: "English",
    countryName: "Tuvalu",
    countryFlag: "🇹🇻",
    countryCode: "TV"
  },
  {
    locale: "en-UG",
    languageName: "English",
    countryName: "Uganda",
    countryFlag: "🇺🇬",
    countryCode: "UG"
  },
  {
    locale: "en-VU",
    languageName: "English",
    countryName: "Vanuatu",
    countryFlag: "🇻🇺",
    countryCode: "VU"
  },
  {
    locale: "en-US",
    languageName: "English",
    countryName: "United States of America",
    countryFlag: "🇺🇸",
    countryCode: "US"
  },
  {
    locale: "en-GB",
    languageName: "English",
    countryName: "United Kingdom",
    countryFlag: "🇬🇧",
    countryCode: "GB"
  },
  {
    locale: "en-CX",
    languageName: "English",
    countryName: "Christmas Island",
    countryFlag: "🇨🇽",
    countryCode: "CX"
  },
  {
    locale: "et-EE",
    languageName: "Estonian",
    countryName: "Estonia",
    countryFlag: "🇪🇪",
    countryCode: "EE"
  },
  {
    locale: "fan-GQ",
    languageName: "Fang",
    countryName: "Equatorial Guinea",
    countryFlag: "🇬🇶",
    countryCode: "GQ"
  },
  {
    locale: "fo-FO",
    languageName: "Faroese",
    countryName: "Faroe Islands",
    countryFlag: "🇫🇴",
    countryCode: "FO"
  },
  {
    locale: "fa-IR",
    languageName: "Persian (Farsi)",
    countryName: "Iran",
    countryFlag: "🇮🇷",
    countryCode: "IR"
  },
  {
    locale: "fj-FJ",
    languageName: "Fijian",
    countryName: "Fiji",
    countryFlag: "🇫🇯",
    countryCode: "FJ"
  },
  {
    locale: "fi-FI",
    languageName: "Finnish",
    countryName: "Finland",
    countryFlag: "🇫🇮",
    countryCode: "FI"
  },
  {
    locale: "fr-GQ",
    languageName: "French",
    countryName: "Equatorial Guinea",
    countryFlag: "🇬🇶",
    countryCode: "GQ"
  },
  {
    locale: "fr-BE",
    languageName: "French",
    countryName: "Belgium",
    countryFlag: "🇧🇪",
    countryCode: "BE"
  },
  {
    locale: "fr-BJ",
    languageName: "French",
    countryName: "Benin",
    countryFlag: "🇧🇯",
    countryCode: "BJ"
  },
  {
    locale: "fr-BF",
    languageName: "French",
    countryName: "Burkina Faso",
    countryFlag: "🇧🇫",
    countryCode: "BF"
  },
  {
    locale: "fr-BI",
    languageName: "French",
    countryName: "Burundi",
    countryFlag: "🇧🇮",
    countryCode: "BI"
  },
  {
    locale: "fr-CD",
    languageName: "French",
    countryName: "Democratic Republic of the Congo",
    countryFlag: "🇨🇩",
    countryCode: "CD"
  },
  {
    locale: "fr-DJ",
    languageName: "French",
    countryName: "Djibouti",
    countryFlag: "🇩🇯",
    countryCode: "DJ"
  },
  {
    locale: "fr-CI",
    languageName: "French",
    countryName: "Ivory Coast",
    countryFlag: "🇨🇮",
    countryCode: "CI"
  },
  {
    locale: "fr-FR",
    languageName: "French",
    countryName: "France",
    countryFlag: "🇫🇷",
    countryCode: "FR"
  },
  {
    locale: "fr-GF",
    languageName: "French",
    countryName: "French Guiana",
    countryFlag: "🇬🇫",
    countryCode: "GF"
  },
  {
    locale: "fr-PF",
    languageName: "French",
    countryName: "French Polynesia",
    countryFlag: "🇵🇫",
    countryCode: "PF"
  },
  {
    locale: "fr-TF",
    languageName: "French",
    countryName: "French Southern and Antarctic Lands",
    countryFlag: "🇹🇫",
    countryCode: "TF"
  },
  {
    locale: "fr-MC",
    languageName: "French",
    countryName: "Principality of Monaco",
    countryFlag: "🇲🇨",
    countryCode: "MC"
  },
  {
    locale: "fr-GA",
    languageName: "French",
    countryName: "Gabon",
    countryFlag: "🇬🇦",
    countryCode: "GA"
  },
  {
    locale: "fr-GP",
    languageName: "French",
    countryName: "Guadeloupe",
    countryFlag: "🇬🇵",
    countryCode: "GP"
  },
  {
    locale: "fr-GG",
    languageName: "French",
    countryName: "Guernsey",
    countryFlag: "🇬🇬",
    countryCode: "GG"
  },
  {
    locale: "fr-GN",
    languageName: "French",
    countryName: "Guinea",
    countryFlag: "🇬🇳",
    countryCode: "GN"
  },
  {
    locale: "fr-HT",
    languageName: "French",
    countryName: "Haiti",
    countryFlag: "🇭🇹",
    countryCode: "HT"
  },
  {
    locale: "fr-JE",
    languageName: "French",
    countryName: "Jersey",
    countryFlag: "🇯🇪",
    countryCode: "JE"
  },
  {
    locale: "fr-CM",
    languageName: "French",
    countryName: "Cameroon",
    countryFlag: "🇨🇲",
    countryCode: "CM"
  },
  {
    locale: "fr-CA",
    languageName: "French",
    countryName: "Canada",
    countryFlag: "🇨🇦",
    countryCode: "CA"
  },
  {
    locale: "fr-KM",
    languageName: "French",
    countryName: "Comoros",
    countryFlag: "🇰🇲",
    countryCode: "KM"
  },
  {
    locale: "fr-LB",
    languageName: "French",
    countryName: "Lebanon",
    countryFlag: "🇱🇧",
    countryCode: "LB"
  },
  {
    locale: "fr-LU",
    languageName: "French",
    countryName: "Luxembourg",
    countryFlag: "🇱🇺",
    countryCode: "LU"
  },
  {
    locale: "fr-MG",
    languageName: "French",
    countryName: "Madagascar",
    countryFlag: "🇲🇬",
    countryCode: "MG"
  },
  {
    locale: "fr-ML",
    languageName: "French",
    countryName: "Mali",
    countryFlag: "🇲🇱",
    countryCode: "ML"
  },
  {
    locale: "fr-MQ",
    languageName: "French",
    countryName: "Martinique",
    countryFlag: "🇲🇶",
    countryCode: "MQ"
  },
  {
    locale: "fr-YT",
    languageName: "French",
    countryName: "Mayotte",
    countryFlag: "🇾🇹",
    countryCode: "YT"
  },
  {
    locale: "fr-NC",
    languageName: "French",
    countryName: "New Caledonia",
    countryFlag: "🇳🇨",
    countryCode: "NC"
  },
  {
    locale: "fr-NE",
    languageName: "French",
    countryName: "Niger",
    countryFlag: "🇳🇪",
    countryCode: "NE"
  },
  {
    locale: "fr-CG",
    languageName: "French",
    countryName: "Republic of the Congo",
    countryFlag: "🇨🇬",
    countryCode: "CG"
  },
  {
    locale: "fr-RE",
    languageName: "French",
    countryName: "Reunion",
    countryFlag: "🇷🇪",
    countryCode: "RE"
  },
  {
    locale: "fr-RW",
    languageName: "French",
    countryName: "Rwanda",
    countryFlag: "🇷🇼",
    countryCode: "RW"
  },
  {
    locale: "fr-MF",
    languageName: "French",
    countryName: "Saint Martin",
    countryFlag: "🇲🇫",
    countryCode: "MF"
  },
  {
    locale: "fr-BL",
    languageName: "French",
    countryName: "Saint Barthelemy",
    countryFlag: "🇧🇱",
    countryCode: "BL"
  },
  {
    locale: "fr-CH",
    languageName: "French",
    countryName: "Switzerland",
    countryFlag: "🇨🇭",
    countryCode: "CH"
  },
  {
    locale: "fr-SN",
    languageName: "French",
    countryName: "Senegal",
    countryFlag: "🇸🇳",
    countryCode: "SN"
  },
  {
    locale: "fr-SC",
    languageName: "French",
    countryName: "Seychelles",
    countryFlag: "🇸🇨",
    countryCode: "SC"
  },
  {
    locale: "fr-PM",
    languageName: "French",
    countryName: "Saint Pierre and Miquelon",
    countryFlag: "🇵🇲",
    countryCode: "PM"
  },
  {
    locale: "fr-TG",
    languageName: "French",
    countryName: "Togo",
    countryFlag: "🇹🇬",
    countryCode: "TG"
  },
  {
    locale: "fr-TD",
    languageName: "French",
    countryName: "Chad",
    countryFlag: "🇹🇩",
    countryCode: "TD"
  },
  {
    locale: "fr-VU",
    languageName: "French",
    countryName: "Vanuatu",
    countryFlag: "🇻🇺",
    countryCode: "VU"
  },
  {
    locale: "fr-VA",
    languageName: "French",
    countryName: "Vatican City",
    countryFlag: "🇻🇦",
    countryCode: "VA"
  },
  {
    locale: "fr-WF",
    languageName: "French",
    countryName: "Wallis and Futuna",
    countryFlag: "🇼🇫",
    countryCode: "WF"
  },
  {
    locale: "fr-CF",
    languageName: "French",
    countryName: "Central African Republic",
    countryFlag: "🇨🇫",
    countryCode: "CF"
  },
  {
    locale: "ff-BF",
    languageName: "Fula",
    countryName: "Burkina Faso",
    countryFlag: "🇧🇫",
    countryCode: "BF"
  },
  {
    locale: "ff-GN",
    languageName: "Fula",
    countryName: "Guinea",
    countryFlag: "🇬🇳",
    countryCode: "GN"
  },
  {
    locale: "ga-IE",
    languageName: "Irish",
    countryName: "Ireland",
    countryFlag: "🇮🇪",
    countryCode: "IE"
  },
  {
    locale: "gv-IM",
    languageName: "Manx",
    countryName: "Isle of Man",
    countryFlag: "🇮🇲",
    countryCode: "IM"
  },
  {
    locale: "gn-AR",
    languageName: "Guaraní",
    countryName: "Argentina",
    countryFlag: "🇦🇷",
    countryCode: "AR"
  },
  {
    locale: "gn-PY",
    languageName: "Guaraní",
    countryName: "Paraguay",
    countryFlag: "🇵🇾",
    countryCode: "PY"
  },
  {
    locale: "ht-HT",
    languageName: "Haitian",
    countryName: "Haiti",
    countryFlag: "🇭🇹",
    countryCode: "HT"
  },
  {
    locale: "he-IL",
    languageName: "Hebrew (modern)",
    countryName: "Israel",
    countryFlag: "🇮🇱",
    countryCode: "IL"
  },
  {
    locale: "hif-FJ",
    languageName: "Fiji Hindi",
    countryName: "Fiji",
    countryFlag: "🇫🇯",
    countryCode: "FJ"
  },
  {
    locale: "hi-IN",
    languageName: "Hindi",
    countryName: "India",
    countryFlag: "🇮🇳",
    countryCode: "IN"
  },
  {
    locale: "hr-BA",
    languageName: "Croatian",
    countryName: "Bosnia and Herzegovina",
    countryFlag: "🇧🇦",
    countryCode: "BA"
  },
  {
    locale: "hr-HR",
    languageName: "Croatian",
    countryName: "Croatia",
    countryFlag: "🇭🇷",
    countryCode: "HR"
  },
  {
    locale: "hr-ME",
    languageName: "Croatian",
    countryName: "Montenegro",
    countryFlag: "🇲🇪",
    countryCode: "ME"
  },
  {
    locale: "hu-HU",
    languageName: "Hungarian",
    countryName: "Hungary",
    countryFlag: "🇭🇺",
    countryCode: "HU"
  },
  {
    locale: "hy-AM",
    languageName: "Armenian",
    countryName: "Armenia",
    countryFlag: "🇦🇲",
    countryCode: "AM"
  },
  {
    locale: "hy-CY",
    languageName: "Armenian",
    countryName: "Cyprus",
    countryFlag: "🇨🇾",
    countryCode: "CY"
  },
  {
    locale: "id-ID",
    languageName: "Indonesian",
    countryName: "Indonesia",
    countryFlag: "🇮🇩",
    countryCode: "ID"
  },
  {
    locale: "is-IS",
    languageName: "Icelandic",
    countryName: "Iceland",
    countryFlag: "🇮🇸",
    countryCode: "IS"
  },
  {
    locale: "it-IT",
    languageName: "Italian",
    countryName: "Italy",
    countryFlag: "🇮🇹",
    countryCode: "IT"
  },
  {
    locale: "it-SM",
    languageName: "Italian",
    countryName: "San Marino",
    countryFlag: "🇸🇲",
    countryCode: "SM"
  },
  {
    locale: "it-CH",
    languageName: "Italian",
    countryName: "Switzerland",
    countryFlag: "🇨🇭",
    countryCode: "CH"
  },
  {
    locale: "it-VA",
    languageName: "Italian",
    countryName: "Vatican City",
    countryFlag: "🇻🇦",
    countryCode: "VA"
  },
  {
    locale: "ja-JP",
    languageName: "Japanese",
    countryName: "Japan",
    countryFlag: "🇯🇵",
    countryCode: "JP"
  },
  {
    locale: "kl-GL",
    languageName: "Greenlandic",
    countryName: "Greenland",
    countryFlag: "🇬🇱",
    countryCode: "GL"
  },
  {
    locale: "ka-GE",
    languageName: "Georgian",
    countryName: "Georgia",
    countryFlag: "🇬🇪",
    countryCode: "GE"
  },
  {
    locale: "kk-KZ",
    languageName: "Kazakh",
    countryName: "Kazakhstan",
    countryFlag: "🇰🇿",
    countryCode: "KZ"
  },
  {
    locale: "km-KH",
    languageName: "Khmer",
    countryName: "Cambodia",
    countryFlag: "🇰🇭",
    countryCode: "KH"
  },
  {
    locale: "rw-RW",
    languageName: "Kinyarwanda",
    countryName: "Rwanda",
    countryFlag: "🇷🇼",
    countryCode: "RW"
  },
  {
    locale: "ky-KG",
    languageName: "Kyrgyz",
    countryName: "Kyrgyzstan",
    countryFlag: "🇰🇬",
    countryCode: "KG"
  },
  {
    locale: "kg-CD",
    languageName: "Kongo",
    countryName: "Democratic Republic of the Congo",
    countryFlag: "🇨🇩",
    countryCode: "CD"
  },
  {
    locale: "ko-KP",
    languageName: "Korean",
    countryName: "North Korea",
    countryFlag: "🇰🇵",
    countryCode: "KP"
  },
  {
    locale: "ko-KR",
    languageName: "Korean",
    countryName: "South Korea",
    countryFlag: "🇰🇷",
    countryCode: "KR"
  },
  {
    locale: "kun-ER",
    languageName: "Kunama",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "ku-IQ",
    languageName: "Kurdish",
    countryName: "Iraq",
    countryFlag: "🇮🇶",
    countryCode: "IQ"
  },
  {
    locale: "lo-LA",
    languageName: "Lao",
    countryName: "Laos",
    countryFlag: "🇱🇦",
    countryCode: "LA"
  },
  {
    locale: "la-VA",
    languageName: "Latin",
    countryName: "Vatican City",
    countryFlag: "🇻🇦",
    countryCode: "VA"
  },
  {
    locale: "lv-LV",
    languageName: "Latvian",
    countryName: "Latvia",
    countryFlag: "🇱🇻",
    countryCode: "LV"
  },
  {
    locale: "ln-CD",
    languageName: "Lingala",
    countryName: "Democratic Republic of the Congo",
    countryFlag: "🇨🇩",
    countryCode: "CD"
  },
  {
    locale: "ln-CG",
    languageName: "Lingala",
    countryName: "Republic of the Congo",
    countryFlag: "🇨🇬",
    countryCode: "CG"
  },
  {
    locale: "lt-LT",
    languageName: "Lithuanian",
    countryName: "Lithuania",
    countryFlag: "🇱🇹",
    countryCode: "LT"
  },
  {
    locale: "lb-LU",
    languageName: "Luxembourgish",
    countryName: "Luxembourg",
    countryFlag: "🇱🇺",
    countryCode: "LU"
  },
  {
    locale: "lu-CD",
    languageName: "Luba-Katanga",
    countryName: "Democratic Republic of the Congo",
    countryFlag: "🇨🇩",
    countryCode: "CD"
  },
  {
    locale: "mh-MH",
    languageName: "Marshallese",
    countryName: "Marshall Islands",
    countryFlag: "🇲🇭",
    countryCode: "MH"
  },
  {
    locale: "mk-MK",
    languageName: "Macedonian",
    countryName: "North Macedonia",
    countryFlag: "🇲🇰",
    countryCode: "MK"
  },
  {
    locale: "mg-MG",
    languageName: "Malagasy",
    countryName: "Madagascar",
    countryFlag: "🇲🇬",
    countryCode: "MG"
  },
  {
    locale: "mt-MT",
    languageName: "Maltese",
    countryName: "Malta",
    countryFlag: "🇲🇹",
    countryCode: "MT"
  },
  {
    locale: "mn-MN",
    languageName: "Mongolian",
    countryName: "Mongolia",
    countryFlag: "🇲🇳",
    countryCode: "MN"
  },
  {
    locale: "mi-NZ",
    languageName: "Māori",
    countryName: "New Zealand",
    countryFlag: "🇳🇿",
    countryCode: "NZ"
  },
  {
    locale: "ms-BN",
    languageName: "Malay",
    countryName: "Brunei",
    countryFlag: "🇧🇳",
    countryCode: "BN"
  },
  {
    locale: "ms-SG",
    languageName: "Malay",
    countryName: "Singapore",
    countryFlag: "🇸🇬",
    countryCode: "SG"
  },
  {
    locale: "my-MM",
    languageName: "Burmese",
    countryName: "Myanmar",
    countryFlag: "🇲🇲",
    countryCode: "MM"
  },
  {
    locale: "na-NR",
    languageName: "Nauruan",
    countryName: "Nauru",
    countryFlag: "🇳🇷",
    countryCode: "NR"
  },
  {
    locale: "nr-ZA",
    languageName: "Southern Ndebele",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "nd-ZW",
    languageName: "Northern Ndebele",
    countryName: "Zimbabwe",
    countryFlag: "🇿🇼",
    countryCode: "ZW"
  },
  {
    locale: "ne-NP",
    languageName: "Nepali",
    countryName: "Nepal",
    countryFlag: "🇳🇵",
    countryCode: "NP"
  },
  {
    locale: "nl-AW",
    languageName: "Dutch",
    countryName: "Aruba",
    countryFlag: "🇦🇼",
    countryCode: "AW"
  },
  {
    locale: "nl-BE",
    languageName: "Dutch",
    countryName: "Belgium",
    countryFlag: "🇧🇪",
    countryCode: "BE"
  },
  {
    locale: "nl-CW",
    languageName: "Dutch",
    countryName: "Curacao",
    countryFlag: "🇨🇼",
    countryCode: "CW"
  },
  {
    locale: "nl-BQ",
    languageName: "Dutch",
    countryName: "Caribbean Netherlands",
    countryFlag: "🇧🇶",
    countryCode: "BQ"
  },
  {
    locale: "nl-NL",
    languageName: "Dutch",
    countryName: "Netherlands",
    countryFlag: "🇳🇱",
    countryCode: "NL"
  },
  {
    locale: "nl-MF",
    languageName: "Dutch",
    countryName: "Saint Martin",
    countryFlag: "🇲🇫",
    countryCode: "MF"
  },
  {
    locale: "nl-SX",
    languageName: "Dutch",
    countryName: "Sint Maarten",
    countryFlag: "🇸🇽",
    countryCode: "SX"
  },
  {
    locale: "nl-SR",
    languageName: "Dutch",
    countryName: "Suriname",
    countryFlag: "🇸🇷",
    countryCode: "SR"
  },
  {
    locale: "nn-BV",
    languageName: "Norwegian Nynorsk",
    countryName: "Bouvet Island",
    countryFlag: "🇧🇻",
    countryCode: "BV"
  },
  {
    locale: "nn-NO",
    languageName: "Norwegian Nynorsk",
    countryName: "Norway",
    countryFlag: "🇳🇴",
    countryCode: "NO"
  },
  {
    locale: "nb-BV",
    languageName: "Norwegian Bokmål",
    countryName: "Bouvet Island",
    countryFlag: "🇧🇻",
    countryCode: "BV"
  },
  {
    locale: "nb-NO",
    languageName: "Norwegian Bokmål",
    countryName: "Norway",
    countryFlag: "🇳🇴",
    countryCode: "NO"
  },
  {
    locale: "no-BV",
    languageName: "Norwegian",
    countryName: "Bouvet Island",
    countryFlag: "🇧🇻",
    countryCode: "BV"
  },
  {
    locale: "no-NO",
    languageName: "Norwegian",
    countryName: "Norway",
    countryFlag: "🇳🇴",
    countryCode: "NO"
  },
  {
    locale: "no-SJ",
    languageName: "Norwegian",
    countryName: "Svalbard",
    countryFlag: "🇸🇯",
    countryCode: "SJ"
  },
  {
    locale: "nrb-ER",
    languageName: "Nara",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "ny-MW",
    languageName: "Chichewa",
    countryName: "Malawi",
    countryFlag: "🇲🇼",
    countryCode: "MW"
  },
  {
    locale: "pa-AW",
    languageName: "(Eastern) Punjabi",
    countryName: "Aruba",
    countryFlag: "🇦🇼",
    countryCode: "AW"
  },
  {
    locale: "pa-CW",
    languageName: "(Eastern) Punjabi",
    countryName: "Curacao",
    countryFlag: "🇨🇼",
    countryCode: "CW"
  },
  {
    locale: "pl-PL",
    languageName: "Polish",
    countryName: "Poland",
    countryFlag: "🇵🇱",
    countryCode: "PL"
  },
  {
    locale: "pt-AO",
    languageName: "Portuguese",
    countryName: "Angola",
    countryFlag: "🇦🇴",
    countryCode: "AO"
  },
  {
    locale: "pt-GQ",
    languageName: "Portuguese",
    countryName: "Equatorial Guinea",
    countryFlag: "🇬🇶",
    countryCode: "GQ"
  },
  {
    locale: "pt-BR",
    languageName: "Portuguese",
    countryName: "Brazil",
    countryFlag: "🇧🇷",
    countryCode: "BR"
  },
  {
    locale: "pt-GW",
    languageName: "Portuguese",
    countryName: "Guinea-Bissau",
    countryFlag: "🇬🇼",
    countryCode: "GW"
  },
  {
    locale: "pt-CV",
    languageName: "Portuguese",
    countryName: "Cape Verde",
    countryFlag: "🇨🇻",
    countryCode: "CV"
  },
  {
    locale: "pt-MO",
    languageName: "Portuguese",
    countryName: "Macao",
    countryFlag: "🇲🇴",
    countryCode: "MO"
  },
  {
    locale: "pt-MZ",
    languageName: "Portuguese",
    countryName: "Mozambique",
    countryFlag: "🇲🇿",
    countryCode: "MZ"
  },
  {
    locale: "pt-TL",
    languageName: "Portuguese",
    countryName: "East Timor",
    countryFlag: "🇹🇱",
    countryCode: "TL"
  },
  {
    locale: "pt-PT",
    languageName: "Portuguese",
    countryName: "Portugal",
    countryFlag: "🇵🇹",
    countryCode: "PT"
  },
  {
    locale: "pt-ST",
    languageName: "Portuguese",
    countryName: "Sao Tome and Principe",
    countryFlag: "🇸🇹",
    countryCode: "ST"
  },
  {
    locale: "ps-AF",
    languageName: "Pashto",
    countryName: "Afghanistan",
    countryFlag: "🇦🇫",
    countryCode: "AF"
  },
  {
    locale: "qu-BO",
    languageName: "Quechua",
    countryName: "Bolivia",
    countryFlag: "🇧🇴",
    countryCode: "BO"
  },
  {
    locale: "rar-CK",
    languageName: "Cook Islands Māori",
    countryName: "Cook Islands",
    countryFlag: "🇨🇰",
    countryCode: "CK"
  },
  {
    locale: "rm-CH",
    languageName: "Romansh",
    countryName: "Switzerland",
    countryFlag: "🇨🇭",
    countryCode: "CH"
  },
  {
    locale: "ro-MD",
    languageName: "Romanian",
    countryName: "Moldova",
    countryFlag: "🇲🇩",
    countryCode: "MD"
  },
  {
    locale: "ro-RO",
    languageName: "Romanian",
    countryName: "Romania",
    countryFlag: "🇷🇴",
    countryCode: "RO"
  },
  {
    locale: "rtm-FJ",
    languageName: "Rotuman",
    countryName: "Fiji",
    countryFlag: "🇫🇯",
    countryCode: "FJ"
  },
  {
    locale: "rn-BI",
    languageName: "Kirundi",
    countryName: "Burundi",
    countryFlag: "🇧🇮",
    countryCode: "BI"
  },
  {
    locale: "ru-AQ",
    languageName: "Russian",
    countryName: "Antarctica",
    countryFlag: "🇦🇶",
    countryCode: "AQ"
  },
  {
    locale: "ru-BY",
    languageName: "Russian",
    countryName: "Belarus",
    countryFlag: "🇧🇾",
    countryCode: "BY"
  },
  {
    locale: "ru-KZ",
    languageName: "Russian",
    countryName: "Kazakhstan",
    countryFlag: "🇰🇿",
    countryCode: "KZ"
  },
  {
    locale: "ru-KG",
    languageName: "Russian",
    countryName: "Kyrgyzstan",
    countryFlag: "🇰🇬",
    countryCode: "KG"
  },
  {
    locale: "ru-RU",
    languageName: "Russian",
    countryName: "Russia",
    countryFlag: "🇷🇺",
    countryCode: "RU"
  },
  {
    locale: "ru-TJ",
    languageName: "Russian",
    countryName: "Tajikistan",
    countryFlag: "🇹🇯",
    countryCode: "TJ"
  },
  {
    locale: "ru-TM",
    languageName: "Russian",
    countryName: "Turkmenistan",
    countryFlag: "🇹🇲",
    countryCode: "TM"
  },
  {
    locale: "ru-UZ",
    languageName: "Russian",
    countryName: "Uzbekistan",
    countryFlag: "🇺🇿",
    countryCode: "UZ"
  },
  {
    locale: "sg-CF",
    languageName: "Sango",
    countryName: "Central African Republic",
    countryFlag: "🇨🇫",
    countryCode: "CF"
  },
  {
    locale: "si-LK",
    languageName: "Sinhalese",
    countryName: "Sri Lanka",
    countryFlag: "🇱🇰",
    countryCode: "LK"
  },
  {
    locale: "sk-SK",
    languageName: "Slovak",
    countryName: "Slovakia",
    countryFlag: "🇸🇰",
    countryCode: "SK"
  },
  {
    locale: "sk-CZ",
    languageName: "Slovak",
    countryName: "Czechia",
    countryFlag: "🇨🇿",
    countryCode: "CZ"
  },
  {
    locale: "sl-SI",
    languageName: "Slovene",
    countryName: "Slovenia",
    countryFlag: "🇸🇮",
    countryCode: "SI"
  },
  {
    locale: "sm-AS",
    languageName: "Samoan",
    countryName: "American Samoa",
    countryFlag: "🇦🇸",
    countryCode: "AS"
  },
  {
    locale: "sm-WS",
    languageName: "Samoan",
    countryName: "Samoa",
    countryFlag: "🇼🇸",
    countryCode: "WS"
  },
  {
    locale: "sn-ZW",
    languageName: "Shona",
    countryName: "Zimbabwe",
    countryFlag: "🇿🇼",
    countryCode: "ZW"
  },
  {
    locale: "so-SO",
    languageName: "Somali",
    countryName: "Somalia",
    countryFlag: "🇸🇴",
    countryCode: "SO"
  },
  {
    locale: "st-LS",
    languageName: "Southern Sotho",
    countryName: "Lesotho",
    countryFlag: "🇱🇸",
    countryCode: "LS"
  },
  {
    locale: "st-ZA",
    languageName: "Southern Sotho",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "es-GQ",
    languageName: "Spanish",
    countryName: "Equatorial Guinea",
    countryFlag: "🇬🇶",
    countryCode: "GQ"
  },
  {
    locale: "es-AR",
    languageName: "Spanish",
    countryName: "Argentina",
    countryFlag: "🇦🇷",
    countryCode: "AR"
  },
  {
    locale: "es-BZ",
    languageName: "Spanish",
    countryName: "Belize",
    countryFlag: "🇧🇿",
    countryCode: "BZ"
  },
  {
    locale: "es-BO",
    languageName: "Spanish",
    countryName: "Bolivia",
    countryFlag: "🇧🇴",
    countryCode: "BO"
  },
  {
    locale: "es-CL",
    languageName: "Spanish",
    countryName: "Chile",
    countryFlag: "🇨🇱",
    countryCode: "CL"
  },
  {
    locale: "es-CR",
    languageName: "Spanish",
    countryName: "Costa Rica",
    countryFlag: "🇨🇷",
    countryCode: "CR"
  },
  {
    locale: "es-DO",
    languageName: "Spanish",
    countryName: "Dominican Republic",
    countryFlag: "🇩🇴",
    countryCode: "DO"
  },
  {
    locale: "es-EC",
    languageName: "Spanish",
    countryName: "Ecuador",
    countryFlag: "🇪🇨",
    countryCode: "EC"
  },
  {
    locale: "es-SV",
    languageName: "Spanish",
    countryName: "El Salvador",
    countryFlag: "🇸🇻",
    countryCode: "SV"
  },
  {
    locale: "es-GU",
    languageName: "Spanish",
    countryName: "Guam",
    countryFlag: "🇬🇺",
    countryCode: "GU"
  },
  {
    locale: "es-GT",
    languageName: "Spanish",
    countryName: "Guatemala",
    countryFlag: "🇬🇹",
    countryCode: "GT"
  },
  {
    locale: "es-HN",
    languageName: "Spanish",
    countryName: "Honduras",
    countryFlag: "🇭🇳",
    countryCode: "HN"
  },
  {
    locale: "es-CO",
    languageName: "Spanish",
    countryName: "Colombia",
    countryFlag: "🇨🇴",
    countryCode: "CO"
  },
  {
    locale: "es-CU",
    languageName: "Spanish",
    countryName: "Cuba",
    countryFlag: "🇨🇺",
    countryCode: "CU"
  },
  {
    locale: "es-MX",
    languageName: "Spanish",
    countryName: "Mexico",
    countryFlag: "🇲🇽",
    countryCode: "MX"
  },
  {
    locale: "es-NI",
    languageName: "Spanish",
    countryName: "Nicaragua",
    countryFlag: "🇳🇮",
    countryCode: "NI"
  },
  {
    locale: "es-PA",
    languageName: "Spanish",
    countryName: "Panama",
    countryFlag: "🇵🇦",
    countryCode: "PA"
  },
  {
    locale: "es-PY",
    languageName: "Spanish",
    countryName: "Paraguay",
    countryFlag: "🇵🇾",
    countryCode: "PY"
  },
  {
    locale: "es-PE",
    languageName: "Spanish",
    countryName: "Peru",
    countryFlag: "🇵🇪",
    countryCode: "PE"
  },
  {
    locale: "es-PR",
    languageName: "Spanish",
    countryName: "Puerto Rico",
    countryFlag: "🇵🇷",
    countryCode: "PR"
  },
  {
    locale: "es-ES",
    languageName: "Spanish",
    countryName: "Spain",
    countryFlag: "🇪🇸",
    countryCode: "ES"
  },
  {
    locale: "es-UY",
    languageName: "Spanish",
    countryName: "Uruguay",
    countryFlag: "🇺🇾",
    countryCode: "UY"
  },
  {
    locale: "es-VE",
    languageName: "Spanish",
    countryName: "Venezuela",
    countryFlag: "🇻🇪",
    countryCode: "VE"
  },
  {
    locale: "es-EH",
    languageName: "Spanish",
    countryName: "Western Sahara",
    countryFlag: "🇪🇭",
    countryCode: "EH"
  },
  {
    locale: "sq-AL",
    languageName: "Albanian",
    countryName: "Albania",
    countryFlag: "🇦🇱",
    countryCode: "AL"
  },
  {
    locale: "sq-XK",
    languageName: "Albanian",
    countryName: "Kosovo",
    countryFlag: "🇽🇰",
    countryCode: "XK"
  },
  {
    locale: "sq-ME",
    languageName: "Albanian",
    countryName: "Montenegro",
    countryFlag: "🇲🇪",
    countryCode: "ME"
  },
  {
    locale: "sr-BA",
    languageName: "Serbian",
    countryName: "Bosnia and Herzegovina",
    countryFlag: "🇧🇦",
    countryCode: "BA"
  },
  {
    locale: "sr-XK",
    languageName: "Serbian",
    countryName: "Kosovo",
    countryFlag: "🇽🇰",
    countryCode: "XK"
  },
  {
    locale: "sr-ME",
    languageName: "Serbian",
    countryName: "Montenegro",
    countryFlag: "🇲🇪",
    countryCode: "ME"
  },
  {
    locale: "sr-RS",
    languageName: "Serbian",
    countryName: "Serbia",
    countryFlag: "🇷🇸",
    countryCode: "RS"
  },
  {
    locale: "ss-SZ",
    languageName: "Swati",
    countryName: "Eswatini",
    countryFlag: "🇸🇿",
    countryCode: "SZ"
  },
  {
    locale: "ss-ZA",
    languageName: "Swati",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "ssy-ER",
    languageName: "Saho",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "sw-CD",
    languageName: "Swahili",
    countryName: "Democratic Republic of the Congo",
    countryFlag: "🇨🇩",
    countryCode: "CD"
  },
  {
    locale: "sw-KE",
    languageName: "Swahili",
    countryName: "Kenya",
    countryFlag: "🇰🇪",
    countryCode: "KE"
  },
  {
    locale: "sw-TZ",
    languageName: "Swahili",
    countryName: "Tanzania",
    countryFlag: "🇹🇿",
    countryCode: "TZ"
  },
  {
    locale: "sw-UG",
    languageName: "Swahili",
    countryName: "Uganda",
    countryFlag: "🇺🇬",
    countryCode: "UG"
  },
  {
    locale: "sv-AX",
    languageName: "Swedish",
    countryName: "Åland Islands",
    countryFlag: "🇦🇽",
    countryCode: "AX"
  },
  {
    locale: "sv-FI",
    languageName: "Swedish",
    countryName: "Finland",
    countryFlag: "🇫🇮",
    countryCode: "FI"
  },
  {
    locale: "sv-SE",
    languageName: "Swedish",
    countryName: "Sweden",
    countryFlag: "🇸🇪",
    countryCode: "SE"
  },
  {
    locale: "ta-SG",
    languageName: "Tamil",
    countryName: "Singapore",
    countryFlag: "🇸🇬",
    countryCode: "SG"
  },
  {
    locale: "ta-LK",
    languageName: "Tamil",
    countryName: "Sri Lanka",
    countryFlag: "🇱🇰",
    countryCode: "LK"
  },
  {
    locale: "tg-TJ",
    languageName: "Tajik",
    countryName: "Tajikistan",
    countryFlag: "🇹🇯",
    countryCode: "TJ"
  },
  {
    locale: "th-TH",
    languageName: "Thai",
    countryName: "Thailand",
    countryFlag: "🇹🇭",
    countryCode: "TH"
  },
  {
    locale: "tig-ER",
    languageName: "Tigre",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "ti-ER",
    languageName: "Tigrinya",
    countryName: "Eritrea",
    countryFlag: "🇪🇷",
    countryCode: "ER"
  },
  {
    locale: "to-TO",
    languageName: "Tonga (Tonga Islands)",
    countryName: "Tonga",
    countryFlag: "🇹🇴",
    countryCode: "TO"
  },
  {
    locale: "tn-BW",
    languageName: "Tswana",
    countryName: "Botswana",
    countryFlag: "🇧🇼",
    countryCode: "BW"
  },
  {
    locale: "tn-ZA",
    languageName: "Tswana",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "ts-ZA",
    languageName: "Tsonga",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "tk-AF",
    languageName: "Turkmen",
    countryName: "Afghanistan",
    countryFlag: "🇦🇫",
    countryCode: "AF"
  },
  {
    locale: "tk-TM",
    languageName: "Turkmen",
    countryName: "Turkmenistan",
    countryFlag: "🇹🇲",
    countryCode: "TM"
  },
  {
    locale: "tr-TR",
    languageName: "Turkish",
    countryName: "Turkey",
    countryFlag: "🇹🇷",
    countryCode: "TR"
  },
  {
    locale: "tr-CY",
    languageName: "Turkish",
    countryName: "Cyprus",
    countryFlag: "🇨🇾",
    countryCode: "CY"
  },
  {
    locale: "uk-UA",
    languageName: "Ukrainian",
    countryName: "Ukraine",
    countryFlag: "🇺🇦",
    countryCode: "UA"
  },
  {
    locale: "ur-PK",
    languageName: "Urdu",
    countryName: "Pakistan",
    countryFlag: "🇵🇰",
    countryCode: "PK"
  },
  {
    locale: "uz-AF",
    languageName: "Uzbek",
    countryName: "Afghanistan",
    countryFlag: "🇦🇫",
    countryCode: "AF"
  },
  {
    locale: "uz-UZ",
    languageName: "Uzbek",
    countryName: "Uzbekistan",
    countryFlag: "🇺🇿",
    countryCode: "UZ"
  },
  {
    locale: "ve-ZA",
    languageName: "Venda",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "vi-VN",
    languageName: "Vietnamese",
    countryName: "Vietnam",
    countryFlag: "🇻🇳",
    countryCode: "VN"
  },
  {
    locale: "xh-ZA",
    languageName: "Xhosa",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  },
  {
    locale: "zh-CN",
    languageName: "Chinese",
    countryName: "China",
    countryFlag: "🇨🇳",
    countryCode: "CN"
  },
  {
    locale: "zh-HK",
    languageName: "Chinese",
    countryName: "Hong Kong",
    countryFlag: "🇭🇰",
    countryCode: "HK"
  },
  {
    locale: "zh-MO",
    languageName: "Chinese",
    countryName: "Macao",
    countryFlag: "🇲🇴",
    countryCode: "MO"
  },
  {
    locale: "zh-SG",
    languageName: "Chinese",
    countryName: "Singapore",
    countryFlag: "🇸🇬",
    countryCode: "SG"
  },
  {
    locale: "zh-TW",
    languageName: "Chinese",
    countryName: "Taiwan",
    countryFlag: "🇹🇼",
    countryCode: "TW"
  },
  {
    locale: "ms-MY",
    languageName: "Malay",
    countryName: "Malaysia",
    countryFlag: "🇲🇾",
    countryCode: "MY"
  },
  {
    locale: "zu-ZA",
    languageName: "Zulu",
    countryName: "South Africa",
    countryFlag: "🇿🇦",
    countryCode: "ZA"
  }
], bn = (e) => Fn.find((t) => t.locale === e), Y1 = (e) => {
  const t = bn(e);
  return t ? `${t.languageName} (${t.countryName})` : e;
}, Z1 = "America/New_York", Ln = 540, Mn = 1020, Dn = 0, vn = 0, On = 24, Pn = 15, wn = "", J1 = 5, q1 = 2, Un = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
], Bn = () => ({
  bufferBefore: Dn,
  bufferAfter: vn,
  restrictScheduleBefore: On,
  timeIncrement: Pn,
  additionalInformation: wn
}), Gn = (e, t, d, a = []) => e.map(
  (n) => ({
    type: "weekRecurring",
    intervals: t === 0 && d === 0 || a.includes(n) ? [] : [
      {
        from: t,
        to: d,
        isValid: !0,
        isBusyOverride: !1
      }
    ],
    wday: n
  })
), kn = () => ({
  timezone: A.tz.guess(),
  recurringAvailability: Gn(
    Un,
    Ln,
    Mn,
    ["saturday", "sunday"]
  ),
  overriddenAvailability: []
}), z1 = () => ({
  availability: kn(),
  additionalPreferences: Bn(),
  holidayCalendars: { available: [], enabled: [] }
}), Vn = (e, t) => e.interviews.find(
  (d) => xn(d) === t
), xn = (e) => {
  const { eventId: t, scheduledTaskId: d } = e ?? {};
  return t || d;
}, Q1 = (e, t, d, a) => {
  if (!e)
    return d.interviews[0];
  if (e && t.some((r) => r.type === "candidate")) {
    const r = d.interviews[0], o = d.interviews.reduce(
      (l, i) => l + i.duration,
      0
    );
    return {
      ...r,
      duration: o
    };
  }
  return Vn(
    d,
    a
  ) ?? null;
}, X1 = (e) => {
  const d = e?.filter(
    (a) => a?.interviews?.length > 0
  )?.sort(
    (a, n) => a?.start + a?.interviews[0]?.time * 6e4 + a?.id > n?.start + n?.interviews[0]?.time * 6e4 + n?.id || a?.status > n?.status ? -1 : 1
  );
  return Wa(d, "groupId") ?? {};
}, el = (e) => {
  const t = e?.map((r) => {
    const o = r.start + r?.interviews[0]?.time * 6e4, l = r.clientTimeZoneOffset ?? 0 ? r.timeZone : "UTC";
    return Gd(o, l);
  }), d = t.pop(), a = t.join(", ");
  return a?.length ? `${a} and ${d}` : d;
}, tl = (e) => e?.scheduledTaskId || e?.eventId || "", dl = (e) => {
  const { status: t, candidate: d } = e, a = ["sent"].includes(
    t
  ), n = !!(d?.scheduledTaskId || d?.eventId), r = d?.status === "failed";
  return (a || t === "failed" && r) && !n;
}, al = (e) => e ? [
  R.ROOSTERLINKS_MEETING,
  R.ROOSTERLINKS_PROSPECT
].some((t) => t === e) : !1, nl = ({
  start: e,
  time: t,
  timeZone: d
}) => {
  const a = e + t * 6e4 - A.tz(d).utcOffset() * 6e4, n = A.tz(a, d).utcOffset();
  return new Date(e - n * 6e4 + t * 6e4);
}, Hn = {
  smsEnabled: !0,
  whatsAppEnabled: !0,
  defaults: {
    smsToAttendee: !1,
    smsToHosts: !1,
    whatsAppToAttendee: !1,
    whatsAppToHosts: !1
  }
}, Wn = (e) => e === "prospect" ? "prospectLinks" : "roosterLinks", Fe = (e, t) => typeof e == "boolean" ? e : t, rl = (e, t) => {
  const d = e?.[Wn(t)] ?? {}, a = d?.defaults ?? {}, n = Hn;
  return {
    smsEnabled: Fe(d?.smsEnabled, n.smsEnabled),
    whatsAppEnabled: Fe(d?.whatsAppEnabled, n.whatsAppEnabled),
    defaults: {
      smsToAttendee: Fe(
        a.smsToAttendee,
        n.defaults.smsToAttendee
      ),
      smsToHosts: Fe(
        a.smsToHosts,
        n.defaults.smsToHosts
      ),
      whatsAppToAttendee: Fe(
        a.whatsAppToAttendee,
        n.defaults.whatsAppToAttendee
      ),
      whatsAppToHosts: Fe(
        a.whatsAppToHosts,
        n.defaults.whatsAppToHosts
      )
    }
  };
}, ol = (e, t) => t ? e : !1, ll = "Message and data rates may apply. Type STOP to unsubscribe or PAUSE, followed by the number of days, to pause subscription", il = (e) => {
  const t = e?.otherAccounts ?? {};
  return Object.values(t).reduce(
    (d, a) => {
      const n = a.messagingServices ?? {};
      return Object.values(n).reduce((r, o) => {
        if (o.status === "active") {
          const l = o.phoneNumbers ?? {};
          return { ...r, ...l };
        }
        return r;
      }, d);
    },
    {}
  );
}, cl = (e) => {
  const t = e?.otherAccounts ?? {}, d = Object.values(t).find((n) => {
    const r = n.messagingServices ?? {};
    return Object.values(r).some(
      (o) => o.status === "active"
    );
  });
  return Object.values(
    d?.messagingServices ?? {}
  ).find((n) => n.status === "active");
}, sl = (e) => {
  const { subAccount: t, otherAccounts: d, activeAccount: a } = e ?? {}, n = a?.sid ?? "";
  return d && n ? Object.values(d).find(
    (o) => o.sid === n
  )?.status === "active" : !n || !d ? t?.status === "active" : !1;
}, Kn = (e, t) => {
  const d = (a) => Kn(a, t);
  return Ka(e) ? ja(e) ? Ya(e, d) : Za(Ja(e, t), d) : e;
}, ul = async (e) => {
  const t = e * 1e3;
  await new Promise((d) => setTimeout(d, t));
}, ye = (e) => {
  if (!e || typeof e != "string")
    return "";
  let t = e;
  return t = t.replace(/<script[^>]*>.*?<\/script>/gis, ""), t = t.replace(/\s*on\w+\s*=\s*["'][^"']*["']/gi, ""), t = t.replace(/\s*on\w+\s*=\s*[^\s>]*/gi, ""), t = t.replace(/javascript\s*:/gi, ""), t = t.replace(/data\s*:/gi, ""), t = t.replace(/<[^>]*>/g, ""), t = t.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&nbsp;/g, " "), t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;"), t = t.replace(/\s+/g, " ").trim(), t;
}, ml = (e) => {
  if (!e || typeof e != "string")
    return "";
  let t = e.trim();
  return t = t.replace(/[\r\n]/g, ""), t = t.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, ""), t = t.replace(/\s+/g, ""), t;
}, gl = (e) => !e || typeof e != "string" ? !1 : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim()), $l = async (e, t) => {
  const a = {
    method: "POST",
    url: `${t ?? process.env.REACT_APP_URL_API}/syncApplicationToMongo`,
    data: {
      docIds: e
    },
    timeout: 3e4,
    raxConfig: {
      retry: 3,
      noResponseRetries: 2,
      retryDelay: 1e3
    }
  };
  try {
    return await dn(a);
  } catch (n) {
    console.log("Mongo sync error", n);
  }
}, Kd = (e, t) => Math.floor(Math.random() * (t - e + 1) + e), Bt = (e, t = 0) => {
  if (t > 20)
    throw new Error(
      "Failed to generate a valid password after multiple attempts"
    );
  const d = "ABCDEFGHIJKLMNOPQRSTUVWXYZ", a = "abcdefghijklmnopqrstuvwxyz", n = "0123456789", r = "!@#$%^&*()_+~`|}{[]:;?><,./-=", o = (N) => N.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"), l = (N, T) => {
    if (!T) return N;
    const O = new RegExp(`[${o(T)}]`, "g");
    return N.replace(O, "");
  }, i = "il1Lo0O";
  let c = e.excludeSimilarCharacters ? l(d, i) : d, s = e.excludeSimilarCharacters ? l(a, i) : a, u = e.excludeSimilarCharacters ? l(n, i) : n, m = r;
  if (e.exclude) {
    const N = e.exclude.replace(/\\/g, "");
    c = l(c, N), s = l(s, N), u = l(u, N), m = l(m, N);
  }
  let g = "";
  if (e.uppercase && (g += c), e.lowercase && (g += s), e.numbers && (g += u), e.symbols && (g += m), !g)
    throw new Error("At least one character set must be selected");
  let E = "";
  const y = new Uint8Array(e.length * 2);
  crypto.getRandomValues(y);
  for (let N = 0; N < e.length; N++)
    E += g[y[N] % g.length];
  if (e.strict) {
    const N = e.uppercase ? /[A-Z]/.test(E) : !0, T = e.lowercase ? /[a-z]/.test(E) : !0, O = e.numbers ? /[0-9]/.test(E) : !0, M = e.symbols ? /[!@#$%^&*()_+~`|}{[\]:;?><,./-=]/.test(E) : !0;
    if (!N || !T || !O || !M)
      return Bt(e, t + 1);
  }
  return E;
}, Ie = {
  minLength: 6,
  maxLength: 10,
  hasUppercase: !0,
  hasLowercase: !0,
  hasDigits: !0,
  hasSymbols: !0
}, be = {
  minLength: 8,
  maxLength: 14,
  hasUppercase: !0,
  hasLowercase: !0,
  hasDigits: !0,
  hasSymbols: !0
}, jd = (e, t, d, a, n, r) => {
  const o = new an();
  return o.is().min(e).is().max(t).has().not().spaces(), d && o.has().uppercase(), a && o.has().lowercase(), n && o.has().digits(), r && o.has().symbols(), o;
}, jn = ['$"'], Yd = (e) => jn.map(
  (t) => e.indexOf(t) !== -1
).includes(!0), Zd = [
  "\\",
  "&",
  "<",
  ">",
  "=",
  "[",
  "]",
  "`",
  '"',
  "/",
  " "
], Yn = (e) => e ? Zd.some((t) => e.includes(t)) : !1, yl = (e) => !Yn(e), Zn = (e, t = 0) => {
  if (t > 100)
    throw new Error(
      "Failed to generate a valid password after multiple attempts"
    );
  const {
    minLength: d = Ie.minLength,
    maxLength: a = Ie.maxLength,
    hasUppercase: n = Ie.hasUppercase,
    hasLowercase: r = Ie.hasLowercase,
    hasDigits: o = Ie.hasDigits,
    hasSymbols: l = Ie.hasSymbols
  } = e ?? Ie, i = {
    length: Kd(d, a),
    uppercase: n,
    lowercase: r,
    numbers: o,
    symbols: l,
    excludeSimilarCharacters: !0,
    strict: !0
  }, c = jd(
    d,
    a,
    n,
    r,
    o,
    l
  ), s = Bt(i);
  return !c.validate(s) || Yd(s) ? Zn(
    e,
    t + 1
  ) : s;
}, Jn = (e, t = 0) => {
  if (t > 20)
    throw new Error(
      "Failed to generate a valid password after multiple attempts"
    );
  const {
    minLength: d = be.minLength,
    maxLength: a = be.maxLength,
    hasUppercase: n = be.hasUppercase,
    hasDigits: r = be.hasDigits,
    hasSymbols: o = be.hasSymbols
  } = e ?? be, l = {
    length: Kd(d, a),
    uppercase: n,
    lowercase: !0,
    // Always include lowercase as baseline
    numbers: r,
    symbols: o,
    excludeSimilarCharacters: !0,
    // Exclude Webex forbidden characters: \, `, ", /, &, <, >, =, [, ], and space
    exclude: Zd.join(""),
    strict: !0
  }, i = jd(
    d,
    a,
    n,
    !0,
    // Always validate for lowercase as baseline
    r,
    o
  ), c = Bt(l);
  return !i.validate(c) || Yd(c) ? Jn(
    e,
    t + 1
  ) : c;
}, El = "SUPER_ADMIN", qn = "TENANT_ADMIN", zn = "SCHEDULING_ADMIN", Qn = "SCHEDULER", Xn = "SCHEDULER_ONLY", e0 = "MEETING_SCHEDULER", Nl = "Interviewer", fl = "Candidate", t0 = "IPP_USER", pl = Object.freeze([
  { label: "Scheduler Only", value: "SCHEDULER_ONLY" },
  { label: "Scheduler", value: "SCHEDULER" },
  { label: "Scheduling Admin", value: "SCHEDULING_ADMIN" },
  { label: "Tenant Admin", value: "TENANT_ADMIN" },
  { label: "Sourcer", value: "SOURCER" },
  { label: "Meeting Scheduler", value: "MEETING_SCHEDULER" }
]), Cl = Object.freeze([
  { label: "Scheduler Only", value: "SCHEDULER_ONLY" },
  { label: "Scheduler", value: "SCHEDULER" },
  { label: "Scheduling Admin", value: "SCHEDULING_ADMIN" },
  { label: "Tenant Admin", value: "TENANT_ADMIN" }
]), $ = Object.freeze({
  TENANT_ADMIN: "TENANT_ADMIN",
  SCHEDULING_ADMIN: "SCHEDULING_ADMIN",
  SCHEDULER: "SCHEDULER",
  SCHEDULER_ONLY: "SCHEDULER_ONLY",
  SOURCER: "IPP_USER",
  MEETING_SCHEDULER: "MEETING_SCHEDULER"
}), at = {
  [qn]: 4,
  [zn]: 3,
  [Qn]: 2,
  [Xn]: 1,
  [t0]: 0,
  [e0]: 0
}, Ue = (e, t) => e && t.some((d) => e[d]), Il = (e) => Ue(e, [$.SOURCER]) || !1, Al = (e) => Ue(e, [$.MEETING_SCHEDULER]), d0 = (e) => Ue(e, [$.TENANT_ADMIN]), a0 = (e) => Ue(e, [$.SCHEDULING_ADMIN]), n0 = (e) => Ue(e, [$.SCHEDULER]), r0 = (e) => Ue(e, [$.SCHEDULER_ONLY]), Tl = (e) => n0(e) || r0(e) || d0(e) || a0(e), Mt = (e) => typeof e == "string" ? e.toLowerCase() : "", o0 = (e) => Array.isArray(e) ? e.map(Mt).filter(Boolean) : e && typeof e == "object" ? Object.keys(e).map(Mt).filter(Boolean) : [], ed = (e, t) => {
  const d = Mt(t);
  return d ? o0(e).includes(d) : !1;
}, hl = (e, t) => e ? !!(ed(e.roles, t) || !(Array.isArray(e.roles) ? e.roles.length > 0 : e.roles != null && typeof e.roles == "object" && Object.keys(e.roles).length > 0) && e.role && ed([e.role], t)) : !1, Sl = (e, t) => {
  const d = e?.all_candidates_visibility || $.SCHEDULER_ONLY, n = (Array.isArray(t) ? t : Object.keys(t ?? {})).filter(Boolean).sort(
    (l, i) => (at[i] ?? -1) - (at[l] ?? -1)
  )[0];
  if (!n)
    return !1;
  const r = at?.[n], o = at?.[d];
  return r >= o;
}, _l = {
  tags: {
    ADD_TAGS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    ARCHIVE_TAGS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    UNARCHIVE_TAGS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    }
  },
  interviewers: {
    CREATE_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN, $.SCHEDULING_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    DELETE_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN, $.SCHEDULING_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    EDIT_IDENTITY_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN, $.SCHEDULING_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    ASSIGN_TAGS_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    UNASSIGN_TAGS_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    BULK_IMPORT_TAGS_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    ASSIGN_UTILIZATION_CAPS_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    SEND_CALENDAR_CONNECTION_INTERVIEWERS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    SET_INTERVIEWER_AVAILABILITY_REQUESTS_REMINDERS_NOTIFICATIONS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    }
  },
  rooms: {
    ASSIGN_TAGS_ROOMS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    UNASSIGN_TAGS_ROOMS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    BULK_IMPORT_TAGS_ROOMS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    ASSIGN_UTILIZATION_CAPS_ROOMS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    EDIT_UTILIZATION_CAPS_ROOMS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    }
  },
  prebriefDebrief: {
    SCHEDULE_PREBRIEFS_DEBRIEFS: {
      defaultValue: [
        $.TENANT_ADMIN,
        $.SCHEDULING_ADMIN,
        $.SCHEDULER,
        $.SCHEDULER_ONLY
      ],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    }
  },
  jobRequisitions: {
    ARCHIVE_JOB_REQUISITIONS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    UNARCHIVE_JOB_REQUISITIONS: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    }
  },
  purge: {
    EXECUTE_MANUAL_PURGE: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    CHANGE_PURGE_SCOPE: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    VIEW_PURGE_HISTORY: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    },
    EXPORT_PURGE_HISTORY: {
      defaultValue: [$.TENANT_ADMIN],
      restrictedValues: ["SOURCER", $.MEETING_SCHEDULER]
    }
  }
}, _t = "Dominican Republic", l0 = {
  1: [
    { name: "United States", code: "US", callingCode: "1" },
    { name: "Canada", code: "CA", callingCode: "1" }
  ],
  7: [{ name: "Russia", code: "RU", callingCode: "7" }],
  20: [{ name: "Egypt", code: "EG", callingCode: "20" }],
  27: [{ name: "South Africa", code: "ZA", callingCode: "27" }],
  30: [{ name: "Greece", code: "GR", callingCode: "30" }],
  31: [{ name: "Netherlands", code: "NL", callingCode: "31" }],
  32: [{ name: "Belgium", code: "BE", callingCode: "32" }],
  33: [{ name: "France", code: "FR", callingCode: "33" }],
  34: [{ name: "Spain", code: "ES", callingCode: "34" }],
  36: [{ name: "Hungary", code: "HU", callingCode: "36" }],
  39: [{ name: "Italy", code: "IT", callingCode: "39" }],
  40: [{ name: "Romania", code: "RO", callingCode: "40" }],
  41: [{ name: "Switzerland", code: "CH", callingCode: "41" }],
  43: [{ name: "Austria", code: "AT", callingCode: "43" }],
  44: [
    { name: "United Kingdom", code: "GB", callingCode: "44" },
    { name: "Guernsey", code: "GG", callingCode: "44" },
    { name: "Isle of Man", code: "IM", callingCode: "44" },
    { name: "Jersey", code: "JE", callingCode: "44" }
  ],
  45: [{ name: "Denmark", code: "DK", callingCode: "45" }],
  46: [{ name: "Sweden", code: "SE", callingCode: "46" }],
  47: [{ name: "Norway", code: "NO", callingCode: "47" }],
  48: [{ name: "Poland", code: "PL", callingCode: "48" }],
  49: [{ name: "Germany", code: "DE", callingCode: "49" }],
  51: [{ name: "Peru", code: "PE", callingCode: "51" }],
  52: [{ name: "Mexico", code: "MX", callingCode: "52" }],
  53: [{ name: "Cuba", code: "CU", callingCode: "53" }],
  54: [{ name: "Argentina", code: "AR", callingCode: "54" }],
  55: [{ name: "Brazil", code: "BR", callingCode: "55" }],
  56: [{ name: "Chile", code: "CL", callingCode: "56" }],
  57: [{ name: "Colombia", code: "CO", callingCode: "57" }],
  58: [{ name: "Venezuela", code: "VE", callingCode: "58" }],
  60: [{ name: "Malaysia", code: "MY", callingCode: "60" }],
  61: [
    { name: "Australia", code: "AU", callingCode: "61" },
    { name: "Cocos (Keeling) Islands", code: "CC", callingCode: "61" },
    { name: "Christmas Island", code: "CX", callingCode: "61" }
  ],
  62: [{ name: "Indonesia", code: "ID", callingCode: "62" }],
  63: [{ name: "Philippines", code: "PH", callingCode: "63" }],
  64: [
    { name: "New Zealand", code: "NZ", callingCode: "64" },
    { name: "Pitcairn Islands", code: "PN", callingCode: "64" }
  ],
  65: [{ name: "Singapore", code: "SG", callingCode: "65" }],
  66: [{ name: "Thailand", code: "TH", callingCode: "66" }],
  76: [{ name: "Kazakhstan", code: "KZ", callingCode: "76" }],
  77: [{ name: "Kazakhstan", code: "KZ", callingCode: "77" }],
  81: [{ name: "Japan", code: "JP", callingCode: "81" }],
  82: [{ name: "South Korea", code: "KR", callingCode: "82" }],
  84: [{ name: "Vietnam", code: "VN", callingCode: "84" }],
  86: [{ name: "China", code: "CN", callingCode: "86" }],
  90: [{ name: "Turkey", code: "TR", callingCode: "90" }],
  91: [{ name: "India", code: "IN", callingCode: "91" }],
  92: [{ name: "Pakistan", code: "PK", callingCode: "92" }],
  93: [{ name: "Afghanistan", code: "AF", callingCode: "93" }],
  94: [{ name: "Sri Lanka", code: "LK", callingCode: "94" }],
  95: [{ name: "Myanmar", code: "MM", callingCode: "95" }],
  98: [{ name: "Iran", code: "IR", callingCode: "98" }],
  211: [{ name: "South Sudan", code: "SS", callingCode: "211" }],
  212: [
    { name: "Western Sahara", code: "EH", callingCode: "212" },
    { name: "Morocco", code: "MA", callingCode: "212" }
  ],
  213: [{ name: "Algeria", code: "DZ", callingCode: "213" }],
  216: [{ name: "Tunisia", code: "TN", callingCode: "216" }],
  218: [{ name: "Libya", code: "LY", callingCode: "218" }],
  220: [{ name: "Gambia", code: "GM", callingCode: "220" }],
  221: [{ name: "Senegal", code: "SN", callingCode: "221" }],
  222: [{ name: "Mauritania", code: "MR", callingCode: "222" }],
  223: [{ name: "Mali", code: "ML", callingCode: "223" }],
  224: [{ name: "Guinea", code: "GN", callingCode: "224" }],
  225: [{ name: "Ivory Coast", code: "CI", callingCode: "225" }],
  226: [{ name: "Burkina Faso", code: "BF", callingCode: "226" }],
  227: [{ name: "Niger", code: "NE", callingCode: "227" }],
  228: [{ name: "Togo", code: "TG", callingCode: "228" }],
  229: [{ name: "Benin", code: "BJ", callingCode: "229" }],
  230: [{ name: "Mauritius", code: "MU", callingCode: "230" }],
  231: [{ name: "Liberia", code: "LR", callingCode: "231" }],
  232: [{ name: "Sierra Leone", code: "SL", callingCode: "232" }],
  233: [{ name: "Ghana", code: "GH", callingCode: "233" }],
  234: [{ name: "Nigeria", code: "NG", callingCode: "234" }],
  235: [{ name: "Chad", code: "TD", callingCode: "235" }],
  236: [
    {
      name: "Central African Republic",
      code: "CF",
      callingCode: "236"
    }
  ],
  237: [{ name: "Cameroon", code: "CM", callingCode: "237" }],
  238: [{ name: "Cape Verde", code: "CV", callingCode: "238" }],
  239: [
    {
      name: "SÃ£o TomÃ© and PrÃ­ncipe",
      code: "ST",
      callingCode: "239"
    }
  ],
  240: [{ name: "Equatorial Guinea", code: "GQ", callingCode: "240" }],
  241: [{ name: "Gabon", code: "GA", callingCode: "241" }],
  242: [{ name: "Republic of the Congo", code: "CG", callingCode: "242" }],
  243: [{ name: "DR Congo", code: "CD", callingCode: "243" }],
  244: [{ name: "Angola", code: "AO", callingCode: "244" }],
  245: [{ name: "Guinea-Bissau", code: "GW", callingCode: "245" }],
  246: [
    {
      name: "British Indian Ocean Territory",
      code: "IO",
      callingCode: "246"
    }
  ],
  248: [{ name: "Seychelles", code: "SC", callingCode: "248" }],
  249: [{ name: "Sudan", code: "SD", callingCode: "249" }],
  250: [{ name: "Rwanda", code: "RW", callingCode: "250" }],
  251: [{ name: "Ethiopia", code: "ET", callingCode: "251" }],
  252: [{ name: "Somalia", code: "SO", callingCode: "252" }],
  253: [{ name: "Djibouti", code: "DJ", callingCode: "253" }],
  254: [{ name: "Kenya", code: "KE", callingCode: "254" }],
  255: [{ name: "Tanzania", code: "TZ", callingCode: "255" }],
  256: [{ name: "Uganda", code: "UG", callingCode: "256" }],
  257: [{ name: "Burundi", code: "BI", callingCode: "257" }],
  258: [{ name: "Mozambique", code: "MZ", callingCode: "258" }],
  260: [{ name: "Zambia", code: "ZM", callingCode: "260" }],
  261: [{ name: "Madagascar", code: "MG", callingCode: "261" }],
  262: [
    { name: "Mayotte", code: "YT", callingCode: "262" },
    { name: "RÃ©union", code: "RE", callingCode: "262" }
  ],
  263: [{ name: "Zimbabwe", code: "ZW", callingCode: "263" }],
  264: [{ name: "Namibia", code: "NA", callingCode: "264" }],
  265: [{ name: "Malawi", code: "MW", callingCode: "265" }],
  266: [{ name: "Lesotho", code: "LS", callingCode: "266" }],
  267: [{ name: "Botswana", code: "BW", callingCode: "267" }],
  268: [{ name: "Swaziland", code: "SZ", callingCode: "268" }],
  269: [{ name: "Comoros", code: "KM", callingCode: "269" }],
  291: [{ name: "Eritrea", code: "ER", callingCode: "291" }],
  297: [{ name: "Aruba", code: "AW", callingCode: "297" }],
  298: [{ name: "Faroe Islands", code: "FO", callingCode: "298" }],
  299: [{ name: "Greenland", code: "GL", callingCode: "299" }],
  350: [{ name: "Gibraltar", code: "GI", callingCode: "350" }],
  351: [{ name: "Portugal", code: "PT", callingCode: "351" }],
  352: [{ name: "Luxembourg", code: "LU", callingCode: "352" }],
  353: [{ name: "Ireland", code: "IE", callingCode: "353" }],
  354: [{ name: "Iceland", code: "IS", callingCode: "354" }],
  355: [{ name: "Albania", code: "AL", callingCode: "355" }],
  356: [{ name: "Malta", code: "MT", callingCode: "356" }],
  357: [{ name: "Cyprus", code: "CY", callingCode: "357" }],
  358: [
    { name: "Ãland Islands", code: "AX", callingCode: "358" },
    { name: "Finland", code: "FI", callingCode: "358" }
  ],
  359: [{ name: "Bulgaria", code: "BG", callingCode: "359" }],
  370: [{ name: "Lithuania", code: "LT", callingCode: "370" }],
  371: [{ name: "Latvia", code: "LV", callingCode: "371" }],
  372: [{ name: "Estonia", code: "EE", callingCode: "372" }],
  373: [{ name: "Moldova", code: "MD", callingCode: "373" }],
  374: [{ name: "Armenia", code: "AM", callingCode: "374" }],
  375: [{ name: "Belarus", code: "BY", callingCode: "375" }],
  376: [{ name: "Andorra", code: "AD", callingCode: "376" }],
  377: [{ name: "Monaco", code: "MC", callingCode: "377" }],
  378: [{ name: "San Marino", code: "SM", callingCode: "378" }],
  379: [{ name: "Vatican City", code: "VA", callingCode: "379" }],
  380: [{ name: "Ukraine", code: "UA", callingCode: "380" }],
  381: [{ name: "Serbia", code: "RS", callingCode: "381" }],
  382: [{ name: "Montenegro", code: "ME", callingCode: "382" }],
  383: [{ name: "Kosovo", code: "XK", callingCode: "383" }],
  385: [{ name: "Croatia", code: "HR", callingCode: "385" }],
  386: [{ name: "Slovenia", code: "SI", callingCode: "386" }],
  387: [{ name: "Bosnia and Herzegovina", code: "BA", callingCode: "387" }],
  389: [{ name: "Macedonia", code: "MK", callingCode: "389" }],
  420: [{ name: "Czechia", code: "CZ", callingCode: "420" }],
  421: [{ name: "Slovakia", code: "SK", callingCode: "421" }],
  423: [{ name: "Liechtenstein", code: "LI", callingCode: "423" }],
  500: [
    { name: "Falkland Islands", code: "FK", callingCode: "500" },
    { name: "South Georgia", code: "GS", callingCode: "500" }
  ],
  501: [{ name: "Belize", code: "BZ", callingCode: "501" }],
  502: [{ name: "Guatemala", code: "GT", callingCode: "502" }],
  503: [{ name: "El Salvador", code: "SV", callingCode: "503" }],
  504: [{ name: "Honduras", code: "HN", callingCode: "504" }],
  505: [{ name: "Nicaragua", code: "NI", callingCode: "505" }],
  506: [{ name: "Costa Rica", code: "CR", callingCode: "506" }],
  507: [{ name: "Panama", code: "PA", callingCode: "507" }],
  508: [
    {
      name: "Saint Pierre and Miquelon",
      code: "PM",
      callingCode: "508"
    }
  ],
  509: [{ name: "Haiti", code: "HT", callingCode: "509" }],
  590: [
    { name: "Saint BarthÃ©lemy", code: "BL", callingCode: "590" },
    { name: "Guadeloupe", code: "GP", callingCode: "590" },
    { name: "Saint Martin", code: "MF", callingCode: "590" }
  ],
  591: [{ name: "Bolivia", code: "BO", callingCode: "591" }],
  592: [{ name: "Guyana", code: "GY", callingCode: "592" }],
  593: [{ name: "Ecuador", code: "EC", callingCode: "593" }],
  594: [{ name: "French Guiana", code: "GF", callingCode: "594" }],
  595: [{ name: "Paraguay", code: "PY", callingCode: "595" }],
  596: [{ name: "Martinique", code: "MQ", callingCode: "596" }],
  597: [{ name: "Suriname", code: "SR", callingCode: "597" }],
  598: [{ name: "Uruguay", code: "UY", callingCode: "598" }],
  670: [{ name: "Timor-Leste", code: "TL", callingCode: "670" }],
  672: [{ name: "Norfolk Island", code: "NF", callingCode: "672" }],
  673: [{ name: "Brunei", code: "BN", callingCode: "673" }],
  674: [{ name: "Nauru", code: "NR", callingCode: "674" }],
  675: [{ name: "Papua New Guinea", code: "PG", callingCode: "675" }],
  676: [{ name: "Tonga", code: "TO", callingCode: "676" }],
  677: [{ name: "Solomon Islands", code: "SB", callingCode: "677" }],
  678: [{ name: "Vanuatu", code: "VU", callingCode: "678" }],
  679: [{ name: "Fiji", code: "FJ", callingCode: "679" }],
  680: [{ name: "Palau", code: "PW", callingCode: "680" }],
  681: [{ name: "Wallis and Futuna", code: "WF", callingCode: "681" }],
  682: [{ name: "Cook Islands", code: "CK", callingCode: "682" }],
  683: [{ name: "Niue", code: "NU", callingCode: "683" }],
  685: [{ name: "Samoa", code: "WS", callingCode: "685" }],
  686: [{ name: "Kiribati", code: "KI", callingCode: "686" }],
  687: [{ name: "New Caledonia", code: "NC", callingCode: "687" }],
  688: [{ name: "Tuvalu", code: "TV", callingCode: "688" }],
  689: [{ name: "French Polynesia", code: "PF", callingCode: "689" }],
  690: [{ name: "Tokelau", code: "TK", callingCode: "690" }],
  691: [{ name: "Micronesia", code: "FM", callingCode: "691" }],
  692: [{ name: "Marshall Islands", code: "MH", callingCode: "692" }],
  850: [{ name: "North Korea", code: "KP", callingCode: "850" }],
  852: [{ name: "Hong Kong", code: "HK", callingCode: "852" }],
  853: [{ name: "Macau", code: "MO", callingCode: "853" }],
  855: [{ name: "Cambodia", code: "KH", callingCode: "855" }],
  856: [{ name: "Laos", code: "LA", callingCode: "856" }],
  880: [{ name: "Bangladesh", code: "BD", callingCode: "880" }],
  886: [{ name: "Taiwan", code: "TW", callingCode: "886" }],
  960: [{ name: "Maldives", code: "MV", callingCode: "960" }],
  961: [{ name: "Lebanon", code: "LB", callingCode: "961" }],
  962: [{ name: "Jordan", code: "JO", callingCode: "962" }],
  963: [{ name: "Syria", code: "SY", callingCode: "963" }],
  964: [{ name: "Iraq", code: "IQ", callingCode: "964" }],
  965: [{ name: "Kuwait", code: "KW", callingCode: "965" }],
  966: [{ name: "Saudi Arabia", code: "SA", callingCode: "966" }],
  967: [{ name: "Yemen", code: "YE", callingCode: "967" }],
  968: [{ name: "Oman", code: "OM", callingCode: "968" }],
  970: [{ name: "Palestine", code: "PS", callingCode: "970" }],
  971: [{ name: "United Arab Emirates", code: "AE", callingCode: "971" }],
  972: [{ name: "Israel", code: "IL", callingCode: "972" }],
  973: [{ name: "Bahrain", code: "BH", callingCode: "973" }],
  974: [{ name: "Qatar", code: "QA", callingCode: "974" }],
  975: [{ name: "Bhutan", code: "BT", callingCode: "975" }],
  976: [{ name: "Mongolia", code: "MN", callingCode: "976" }],
  977: [{ name: "Nepal", code: "NP", callingCode: "977" }],
  992: [{ name: "Tajikistan", code: "TJ", callingCode: "992" }],
  993: [{ name: "Turkmenistan", code: "TM", callingCode: "993" }],
  994: [{ name: "Azerbaijan", code: "AZ", callingCode: "994" }],
  995: [{ name: "Georgia", code: "GE", callingCode: "995" }],
  996: [{ name: "Kyrgyzstan", code: "KG", callingCode: "996" }],
  998: [{ name: "Uzbekistan", code: "UZ", callingCode: "998" }],
  1242: [{ name: "Bahamas", code: "BS", callingCode: "1242" }],
  1246: [{ name: "Barbados", code: "BB", callingCode: "1246" }],
  1264: [{ name: "Anguilla", code: "AI", callingCode: "1264" }],
  1268: [{ name: "Antigua and Barbuda", code: "AG", callingCode: "1268" }],
  1284: [{ name: "British Virgin Islands", code: "VG", callingCode: "1284" }],
  1340: [
    {
      name: "United States Virgin Islands",
      code: "VI",
      callingCode: "1340"
    }
  ],
  1345: [{ name: "Cayman Islands", code: "KY", callingCode: "1345" }],
  1441: [{ name: "Bermuda", code: "BM", callingCode: "1441" }],
  1473: [{ name: "Grenada", code: "GD", callingCode: "1473" }],
  1649: [
    {
      name: "Turks and Caicos Islands",
      code: "TC",
      callingCode: "1649"
    }
  ],
  1664: [{ name: "Montserrat", code: "MS", callingCode: "1664" }],
  1670: [
    {
      name: "Northern Mariana Islands",
      code: "MP",
      callingCode: "1670"
    }
  ],
  1671: [{ name: "Guam", code: "GU", callingCode: "1671" }],
  1684: [{ name: "American Samoa", code: "AS", callingCode: "1684" }],
  1721: [{ name: "Sint Maarten", code: "SX", callingCode: "1721" }],
  1758: [{ name: "Saint Lucia", code: "LC", callingCode: "1758" }],
  1767: [{ name: "Dominica", code: "DM", callingCode: "1767" }],
  1784: [
    {
      name: "Saint Vincent and the Grenadines",
      code: "VC",
      callingCode: "1784"
    }
  ],
  1787: [{ name: "Puerto Rico", code: "PR", callingCode: "1787" }],
  1809: [{ name: _t, code: "DO", callingCode: "1809" }],
  1829: [{ name: _t, code: "DO", callingCode: "1829" }],
  1849: [{ name: _t, code: "DO", callingCode: "1849" }],
  1868: [{ name: "Trinidad and Tobago", code: "TT", callingCode: "1868" }],
  1869: [{ name: "Saint Kitts and Nevis", code: "KN", callingCode: "1869" }],
  1876: [{ name: "Jamaica", code: "JM", callingCode: "1876" }],
  1939: [{ name: "Puerto Rico", code: "PR", callingCode: "1939" }],
  4779: [{ name: "Svalbard and Jan Mayen", code: "SJ", callingCode: "4779" }],
  5999: [{ name: "CuraÃ§ao", code: "CW", callingCode: "5999" }],
  3906698: [{ name: "Vatican City", code: "VA", callingCode: "3906698" }]
}, Rl = (e, t, d) => {
  let a = e?.trim(), n = t?.trim()?.replace(/^0+/, ""), r = null;
  if ((!e || e?.length === 0) && (a = "1"), e = e.replace(/\D/g, "").replace(/^0+/, ""), e.length === 0)
    a = "+1";
  else {
    let o = 0;
    try {
      o = Number.parseInt(e, 10);
    } catch {
      o = 1;
    }
    if (o < 1)
      a = "+1";
    else
      try {
        a = `+${l0[o][0].callingCode}`;
      } catch {
        a = "+1";
      }
  }
  if (n?.length > 0) {
    const o = n.toLowerCase().indexOf("x");
    o > -1 && (n = n.substring(0, o).trim()), n.startsWith("+") && (n = n.replace("+", ""));
    try {
      r = Qt(
        `${a ? `${a}` : ""} ${n}`
      ), r.isValid() || (r = null);
    } catch {
      try {
        r = Qt(`+${n}`);
      } catch {
        r = null;
      }
    }
  }
  return r ? d ? { countryNumber: a.substring(1), phoneNumber: n } : r.format("E.164") : "";
}, i0 = /^00[\s.-]*/, Fl = (e) => {
  const t = e?.trim?.() ?? "";
  if (!t) return "";
  const a = t.replace(/\s+/g, " ").replace(i0, "+");
  return a.startsWith("+") ? nn(a)?.countryCallingCode ?? "" : "";
}, c0 = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6], 0, 0, 0, 0, 0, 0, 0, [["6[2-467]\\d{3}", [5]], ["4\\d{4}", [5]], 0, 0, 0, 0, ["(?:0[1-9]|[1589]\\d)\\d{4}", [6]]]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [["[78]\\d{5}", [6]], ["690\\d{6}|[356]\\d{5}", [6, 9]], ["180[02]\\d{4}", [8]], ["[19]\\d{5}", [6]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[2-4679][2-8]\\d{6}", [8]], ["5[024-68]\\d{7}", [9]], ["400\\d{6}|800\\d{2,9}"], ["900[02]\\d{5}", [9]], 0, 0, ["600[25]\\d{5}", [9]], 0, 0, ["700[05]\\d{5}", [9]]]], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:[25][0-8]|[34][0-4]|6[0-5])[2-9]\\d{6}"], ["7\\d{8}"]]], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268", [["268(?:4(?:6[0-38]|84)|56[0-2])\\d{4}"], ["268(?:464|7(?:1[3-9]|[28]\\d|3[0246]|64|7[0-689]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["26840[69]\\d{4}"], ["26848[01]\\d{4}"]]], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264", [["264(?:292|4(?:6[12]|9[78]))\\d{4}"], ["264(?:235|4(?:69|76)|5(?:3[6-9]|8[1-4])|7(?:29|72))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, ["264724\\d{4}"]]], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["4505[0-2]\\d{3}|(?:[2358][16-9]\\d[2-9]|4410)\\d{4}|(?:[2358][2-5][2-9]|4(?:[2-57-9][2-9]|6\\d))\\d{5}", [8]], ["6(?:[78][2-9]|9\\d)\\d{6}", [9]], ["800\\d{4}", [7]], ["900[1-9]\\d\\d", [6]], ["700[2-9]\\d{4}", [8]], 0, 0, 0, 0, ["808[1-9]\\d\\d", [6]]]], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:1[0-25]|47)\\d|2(?:2[2-46]|3[1-8]|4[2-69]|5[2-7]|6[1-9]|8[1-7])|3[12]2)\\d{5}"], ["(?:33|4[1349]|55|77|88|9[13-9])\\d{6}"], ["800\\d{5}"], ["90[016]\\d{5}"], 0, 0, 0, 0, ["60(?:2[78]|3[5-9]|4[02-9]|5[0-46-9]|[6-8]\\d|9[0-2])\\d{4}"], ["80[1-4]\\d{5}"]]], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["2\\d(?:[0134][25-9]|[25-9]\\d)\\d{5}"], ["9[1-79]\\d{7}"]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1", 0, 0, [["3(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:(?:11[1-8]|670)\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68])))\\d{6}|(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|2(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}", [10]], ["93(?:7(?:1[15]|81)|8(?:21|4[16]|69|9[12]))[46]\\d{5}|9(?:2(?:2(?:2[59]|44|52)|3(?:26|44)|47[35]|9(?:[07]2|2[26]|34|46))|3327)[45]\\d{5}|9(?:2(?:657|9(?:54|66))|3(?:48[27]|7(?:55|77)|8(?:65|78)))[2-8]\\d{5}|9(?:2(?:284|3(?:02|23)|477|622|920)|3(?:4(?:46|89|92)|541))[2-7]\\d{5}|(?:675\\d|9(?:11[1-8]\\d|2(?:2(?:0[45]|1[2-6]|3[3-6])|3(?:[06]4|7[45])|494|6(?:04|1[2-8]|[36][45]|4[3-6])|80[45]|9(?:[17][4-6]|[48][45]|9[3-6]))|3(?:364|4(?:1[2-8]|[25][4-6]|3[3-6]|84)|5(?:1[2-9]|[38][4-6])|6(?:2[45]|44)|7[069][45]|8(?:0[45]|1[2-7]|3[4-6]|5[3-6]|7[2-6]|8[3-68]))))\\d{6}|9(?:2(?:2(?:62|81)|320|9(?:42|83))|3(?:329|4(?:62|7[16])|5(?:43|64)|7(?:18|5[17])))[2-6]\\d{5}|92(?:2(?:21|4[23]|6[145]|7[1-4]|8[356]|9[267])|3(?:16|3[13-8]|43|5[346-8]|9[3-5])|6(?:2[46]|4[78]|5[1568])|9(?:03|2[1457-9]|3[1356]|4[08]|[56][23]|82))4\\d{5}|9(?:2(?:257|3(?:24|46|92)|9(?:01|23|64))|3(?:4(?:42|64)|5(?:25|37|4[47]|71)|7(?:35|72)|825))[3-6]\\d{5}|9(?:2(?:2(?:02|2[3467]|4[156]|5[45]|6[6-8]|91)|3(?:1[47]|25|[45][25]|96)|47[48]|625|932)|3(?:38[2578]|4(?:0[0-24-9]|3[78]|4[457]|58|6[035-9]|72|83|9[136-8])|5(?:2[124]|[368][23]|4[2689]|7[2-6])|7(?:16|2[15]|3[14]|4[13]|5[468]|7[3-5]|8[26])|8(?:2[67]|3[278]|4[3-5]|5[78]|6[1-378]|[78]7|94)))[4-6]\\d{5}"], ["800\\d{7,8}"], ["60[04579]\\d{7}", [10]], 0, 0, ["810\\d{7}", [10]]]], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684", [["6846(?:22|33|44|55|77|88|9[19])\\d{4}"], ["684(?:2(?:48|5[2468]|7[26])|7(?:3[13]|70|82))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:11\\d|[2-9]\\d{3,11})|(?:316|463)\\d{3,10}|648[34]\\d{3,9}|(?:51|66|73)2\\d{3,10}|(?:2(?:1[467]|2[13-8]|5[2357]|6[1-46-8]|7[1-8]|8[124-7]|9[1458])|3(?:1[1-578]|3[23568]|4[5-7]|5[1378]|6[1-38]|8[3-68])|4(?:2[1-8]|35|7[1368]|8[2457])|5(?:2[1-8]|3[357]|4[147]|5[12578]|6[37])|6(?:13|2[1-47]|4[135-7]|5[468])|7(?:2[1-8]|35|4[13478]|5[68]|6[16-8]|7[1-6]|9[45]))\\d{4,10}"], ["6(?:485|(?:5[0-3579]|6[013-9]|[7-9]\\d)\\d)\\d{3,9}", [7, 8, 9, 10, 11, 12, 13]], ["800\\d{6,10}", [9, 10, 11, 12, 13]], ["(?:8[69][2-68]|9(?:0[01]|3[019]))\\d{6,10}", [9, 10, 11, 12, 13]], 0, 0, 0, 0, ["5(?:0[1-9]|17|[79]\\d)\\d{2,10}|7[28]0\\d{6,10}", [5, 6, 7, 8, 9, 10, 11, 12, 13]], ["8(?:10|2[018])\\d{6,10}|828\\d{5}", [8, 9, 10, 11, 12, 13]]]], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]], 0, 0, 0, 0, 0, 0, [["5(?:2\\d|8[1-9])\\d{4}"], ["(?:290|5[69]\\d|6(?:[03]0|22|4[0-2]|[69]\\d)|7(?:[34]\\d|7[07])|9(?:6[45]|9[4-8]))\\d{4}"], ["800\\d{4}"], ["900\\d{4}"], 0, 0, 0, 0, ["(?:28\\d|501)\\d{4}"]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", [["18[1-8]\\d{3,6}", [6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12]428|3655[02])\\d{4}|(?:2(?:22[0-79]|63[0-28])|3654)\\d{5}|(?:(?:1[28]|46)\\d|2(?:[014-6]2|[23]3))\\d{6}"], ["36554\\d{4}|(?:[16]0|4[04]|5[015]|7[07]|99)\\d{7}"], ["88\\d{7}"], ["900200\\d{3}"]]], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[05-79][2-9]|1[4579]|[23][24-9]|4[2-4689]|8[2457-9])|49[2-579]|5(?:0[2-49]|[13][2-9]|[268][2-4679]|4[4689]|5[2-79]|7[2-69]|9[2-4689]))\\d{5}", [8]], ["6040\\d{5}|6(?:03|[1-356]|44|7\\d)\\d{6}"], ["8[08]\\d{6}", [8]], ["9[0246]\\d{6}", [8]], 0, 0, ["703[235]0\\d{3}|70(?:2[0-5]|3[0146]|[56]0)\\d{4}", [8]], 0, 0, ["8[12]\\d{6}", [8]]]], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246", [["246521[0369]\\d{3}|246(?:2(?:2[78]|7[0-4])|4(?:1[024-6]|2\\d|3[2-9])|5(?:20|[34]\\d|54|7[1-3])|6(?:2\\d|38)|7[35]7|9(?:1[89]|63))\\d{4}"], ["246(?:(?:2(?:[3568]\\d|4[0-57-9])|3(?:5[2-9]|6[0-6])|4(?:46|5\\d)|69[5-7]|8(?:[2-5]\\d|83))\\d|52(?:1[147]|20))\\d{3}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:246976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["246(?:292|367|4(?:1[7-9]|3[01]|4[47-9]|67)|7(?:1[2-9]|2\\d|3[016]|53))\\d{4}"], 0, ["24631\\d{5}"]]], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4(?:31\\d\\d|423)|5222)\\d{3}(?:\\d{2})?|8332[6-9]\\d\\d|(?:3(?:03[56]|224)|4(?:22[25]|653))\\d{3,4}|(?:3(?:42[47]|529|823)|4(?:027|525|65(?:28|8))|562|6257|7(?:1(?:5[3-5]|6[12]|7[156]|89)|22[589]56|32|42675|52(?:[25689](?:56|8)|[347]8)|71(?:6[1267]|75|89)|92374)|82(?:2[59]|32)56|9(?:03[23]56|23(?:256|373)|31|5(?:1|2[4589]56)))\\d{3}|(?:3(?:02[348]|22[35]|324|422)|4(?:22[67]|32[236-9]|6(?:2[46]|5[57])|953)|5526|6(?:024|6655)|81)\\d{4,5}|(?:2(?:7(?:1[0-267]|2[0-289]|3[0-29]|4[01]|5[1-3]|6[013]|7[0178]|91)|8(?:0[125]|1[1-6]|2[0157-9]|3[1-69]|41|6[1-35]|7[1-5]|8[1-8]|9[0-6])|9(?:0[0-2]|1[0-4]|2[568]|3[3-6]|5[5-7]|6[0136-9]|7[0-7]|8[014-9]))|3(?:0(?:2[025-79]|3[2-4])|181|22[12]|32[2356]|824)|4(?:02[09]|22[348]|32[045]|523|6(?:27|54))|666(?:22|53)|7(?:22[57-9]|42[56]|82[35])8|8(?:0[124-9]|2(?:181|2[02-4679]8)|4[12]|[5-7]2)|9(?:[04]2|2(?:2|328)|81))\\d{4}|(?:2(?:[23]\\d|[45])\\d\\d|3(?:1(?:2[5-7]|[5-7])|425|822)|4(?:033|1\\d|[257]1|332|4(?:2[246]|5[25])|6(?:2[35]|56|62)|8(?:23|54)|92[2-5])|5(?:02[03489]|22[457]|32[35-79]|42[46]|6(?:[18]|53)|724|826)|6(?:023|2(?:2[2-5]|5[3-5]|8)|32[3478]|42[34]|52[47]|6(?:[18]|6(?:2[34]|5[24]))|[78]2[2-5]|92[2-6])|7(?:02|21\\d|[3-589]1|6[12]|72[24])|8(?:217|3[12]|[5-7]1)|9[24]1)\\d{5}|(?:(?:3[2-8]|5[2-57-9]|6[03-589])1|4[4689][18])\\d{5}|[59]1\\d{5}"], ["(?:1[13-9]\\d|644)\\d{7}|(?:3[78]|44|66)[02-9]\\d{7}", [10]], ["80[03]\\d{7}", [10]], 0, 0, 0, 0, 0, ["96(?:0[469]|1[0-47]|3[389]|43|6[69]|7[78])\\d{6}", [10]]]], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, [["80[2-8]\\d{5}|(?:1[0-69]|[23][2-8]|4[23]|5\\d|6[013-57-9]|71|8[1-79]|9[2-4])\\d{6}", [8]], ["4[5-9]\\d{7}", [9]], ["800[1-9]\\d{4}", [8]], ["(?:70(?:2[0-57]|3[04-7]|44|6[04-69]|7[0579])|90\\d\\d)\\d{4}", [8]], 0, 0, ["78(?:0[578]|1[014-8]|2[25]|3[15-8]|48|5[05]|60|7[06-8]|9\\d)\\d{4}", [8]], 0, 0, ["7879\\d{4}", [8]]]], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:49|5[23]|6[5-7]|9[016-9])|4(?:4[569]|5[4-6]|6[5-7]|7[0179])|5(?:[34]\\d|50|6[5-7]))\\d{4}"], ["(?:0[1-7]|44|5[0-8]|[67]\\d)\\d{6}"]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{5,7}|(?:43[1-6]|70[1-9])\\d{4,5}|(?:[36]\\d|4[124-7]|[57][1-9]|8[1-6]|9[1-7])\\d{5,6}", [6, 7, 8]], ["(?:43[07-9]|99[69]\\d)\\d{5}|(?:8[7-9]|98)\\d{7}", [8, 9]], ["(?:00800\\d\\d|800)\\d{5}", [8, 12]], ["90\\d{6}", [8]], 0, 0, 0, 0, 0, ["700\\d{5}", [8]]]], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:3[1356]|6[0156]|7\\d)\\d|6(?:1[16]\\d|500|6(?:0\\d|3[12]|44|55|7[7-9]|88)|9[69][69])|7(?:[07]\\d\\d|1(?:11|78)))\\d{4}"], ["(?:3(?:[0-79]\\d|8[0-57-9])\\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\\d|7[0-689])))\\d{4}"], ["8[02369]\\d{6}"], ["(?:87|9[0-8])\\d{6}"], 0, 0, 0, 0, 0, ["84\\d{6}"]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]], 0, 0, 0, 0, 0, 0, [["(?:22|31)\\d{6}"], ["(?:29|6[124-9]|7[125-9])\\d{6}"]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]], 0, 0, 0, 0, 0, 0, [["2090\\d{4}|(?:012\\d\\d|2(?:02|1[037]|2[45]|3[68]|4\\d))\\d{5}"], ["(?:01(?:2[5-9]|[4-69]\\d)|4[0-8]|[56]\\d|9[013-9])\\d{6}"], 0, 0, 0, 0, ["81\\d{6}", [8]], 0, ["857[58]\\d{4}", [8]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441", [["441(?:[46]\\d\\d|5(?:4\\d|60|89))\\d{4}"], ["441(?:[2378]\\d|5[0-39]|9[02])\\d{5}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["22[0-7]\\d{4}|(?:2[013-9]|[34]\\d|5[0-25-9])\\d{5}"], ["(?:22[89]|[78]\\d\\d)\\d{4}"], 0, 0, 0, 0, 0, 0, ["5[34]\\d{5}"]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?", 0, 0, 0, [["(?:2(?:2\\d\\d|5(?:11|[258]\\d|9[67])|6(?:12|2\\d|9[34])|8(?:2[34]|39|62))|3(?:3\\d\\d|4(?:6\\d|8[24])|8(?:25|42|5[257]|86|9[25])|9(?:[27]\\d|3[2-4]|4[248]|5[24]|6[2-6]))|4(?:4\\d\\d|6(?:11|[24689]\\d|72)))\\d{4}", [8]], ["[67]\\d{7}", [8]], ["8001[07]\\d{4}", [9]], 0, 0, 0, 0, 0, ["50\\d{6}", [8]]]], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]", [["(?:318[023]|41(?:6[023]|70)|7(?:1[578]|2[05]|50)\\d)\\d{3}"], ["(?:31(?:8[14-8]|9[14578])|416[14-9]|7(?:0[01]|7[07]|8\\d|9[056])\\d)\\d{3}"]]], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2", 0, 0, [["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-5]\\d{7}", [10]], ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])(?:7|9\\d)\\d{7}", [10, 11]], ["800\\d{6,7}", [9, 10]], ["[59]00\\d{6,7}", [9, 10]], 0, 0, 0, 0, 0, ["(?:30[03]\\d{3}|4(?:0(?:0\\d|20)|370|864))\\d{4}|300\\d{5}", [8, 10]]]], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242", [["242(?:3(?:02|[236][1-9]|4[0-24-9]|5[0-68]|7[347]|8[0-4]|9[2-467])|461|502|6(?:0[1-5]|12|2[013]|[45]0|7[67]|8[78]|9[89])|7(?:02|88))\\d{4}"], ["242(?:3(?:5[79]|7[56]|95)|4(?:[23][1-9]|4[1-35-9]|5[1-8]|6[2-8]|7\\d|81)|5(?:2[45]|3[35]|44|5[1-46-9]|65|77)|6[34]6|7(?:27|38)|8(?:0[1-9]|1[02-9]|2\\d|3[0-4]|[89]9))\\d{4}"], ["242300\\d{4}|8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, ["242225\\d{4}"]]], BT: ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[3-6]|[34][5-7]|5[236]|6[2-46]|7[246]|8[2-4])\\d{5}", [7]], ["(?:1[67]|[78]7)\\d{6}", [8]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:4[0-48]|6[0-24]|9[0578])|3(?:1[0-35-9]|55|[69]\\d|7[013]|81)|4(?:6[03]|7[1267]|9[0-5])|5(?:3[03489]|4[0489]|7[1-47]|88|9[0-49])|6(?:2[1-35]|5[149]|8[013467]))\\d{4}", [7]], ["(?:321|7[1-8]\\d)\\d{5}", [8]], ["(?:0800|800\\d)\\d{6}", [10]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["79(?:1(?:[0-2]\\d|3[0-8])|2[0-7]\\d)\\d{3}", [8]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, [["(?:1(?:5(?:1[1-5]|[24]\\d|6[2-4]|9[1-7])|6(?:[235]\\d|4[1-7])|7\\d\\d)|2(?:1(?:[246]\\d|3[0-35-9]|5[1-9])|2(?:[235]\\d|4[0-8])|3(?:[26]\\d|3[02-79]|4[024-7]|5[03-7])))\\d{5}", [9]], ["(?:2(?:5[5-79]|9[1-9])|(?:33|44)\\d)\\d{6}", [9]], ["800\\d{3,7}|8(?:0[13]|20\\d)\\d{7}"], ["(?:810|902)\\d{7}", [10]], 0, 0, 0, 0, ["249\\d{6}", [9]]], "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[02]\\d|36|[68]0)|[3-58](?:[02]\\d|[68]0)|7(?:[02]\\d|32|[68]0))\\d{4}", [7]], ["6[0-35-7]\\d{5}", [7]], ["0800\\d{7}", [11]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:12|573)\\d\\d|276)\\d{5}|[1-6]\\d{6}"], ["88\\d{5}|(?:8[0-69]|9[017-9])\\d{7}", [7, 9]]]], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]], 0, 0, 0, 0, 0, 0, [["2[12]\\d{6}"], ["7[024-7]\\d{6}"], 0, ["8776\\d{4}"]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]], 0, 0, 0, 0, 0, 0, [["222[1-589]\\d{5}"], ["026(?:1[0-5]|6[6-9])\\d{4}|0(?:[14-6]\\d\\d|2(?:40|5[5-8]|6[07-9]))\\d{5}"], 0, ["80[0-2]\\d{6}"]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[12467]|3[1-4]|4[134]|5[256]|6[12]|[7-9]1)\\d{7}", [9]], ["(?:6[89]|7[235-9])\\d{7}", [9]], ["800\\d{6}", [9]], ["90[016]\\d{6}", [9]], ["878\\d{6}", [9]], ["860\\d{9}", [12]], ["5[18]\\d{7}", [9]], ["74[0248]\\d{6}", [9]], 0, ["84[0248]\\d{6}", [9]]]], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]], 0, 0, 0, 0, 0, 0, [["2(?:[15]\\d{3}|7(?:2(?:0[23]|1[2357]|2[245]|3[45]|4[3-5])|3(?:06|1[69]|[2-6]7)))\\d{5}"], ["0[157]\\d{8}"]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[13-7]|4[1-5])\\d{3}"], ["[578]\\d{4}"]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]], 0, 0, 0, 0, 0, 0, [["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578])\\d|6(?:00|[13-57]\\d)|8(?:0[1-9]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}", [9]], ["2(?:1982[0-6]|3314[05-9])\\d{3}|(?:2(?:1(?:160|962)|2\\d{3}|3(?:(?:2\\d|50)\\d|3(?:[03467]\\d|1[0-35-9]|2[1-9]|5[0-24-9]|8[0-389]|9[0-8])|600)|646[59])|(?:(?:3[2-5]|[47][1-35]|5[1-3578]|6[13-57])\\d|8(?:0[1-8]|[1-9]\\d))\\d\\d|9(?:(?:10[01]|(?:[2458]\\d|7[1-9])\\d)\\d|3(?:[0-57-9]\\d\\d|6(?:0[02-9]|[1-9]\\d))|6(?:[0-8]\\d\\d|9(?:[02-79]\\d|1[05-9]))|9(?:[03-9]\\d\\d|1(?:[0235-9]\\d|4[0-24-9])|2(?:[0-79]\\d|8[0-46-9]))))\\d{4}", [9]], ["(?:123|8)00\\d{6}", [9, 11]], 0, 0, 0, 0, 0, ["44\\d{7}", [9]], ["600\\d{7,8}", [10, 11]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]], 0, 0, 0, 0, 0, 0, [["2(?:22|33)\\d{6}", [9]], ["(?:24[23]|6(?:[25-9]\\d|40))\\d{6}", [9]], ["88\\d{6,7}"]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, [["(?:10(?:[02-79]\\d\\d|[18](?:0[1-9]|[1-9]\\d))|2(?:[02-57-9]\\d{3}|1(?:[18](?:0[1-9]|[1-9]\\d)|[2-79]\\d\\d))|(?:41[03]|8078|9(?:78|94))\\d\\d)\\d{5}|(?:10|2[0-57-9])(?:1(?:00|23)\\d\\d|95\\d{3,4})|(?:41[03]|9(?:78|94))(?:100\\d\\d|95\\d{3,4})|8078123|(?:43[35]|754|851)\\d{7,8}|(?:43[35]|754|851)(?:1(?:00\\d|23)\\d|95\\d{3,4})|(?:3(?:11|7[179])|4(?:[15]1|3[12])|5(?:1\\d|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[57]|6[09])|8(?:71|98))(?:[02-8]\\d{7}|1(?:0(?:0\\d\\d(?:\\d{3})?|[1-9]\\d{5})|[13-9]\\d{6}|2(?:[0-24-9]\\d{5}|3\\d(?:\\d{4})?))|9(?:[0-46-9]\\d{6}|5\\d{3}(?:\\d(?:\\d{2})?)?))|(?:3(?:1[02-9]|35|49|5\\d|7[02-68]|9[1-68])|4(?:1[24-9]|2[179]|3[46-9]|5[2-9]|6[47-9]|7\\d|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[17]\\d|2[248]|3[04-9]|4[3-6]|5[0-3689]|6[2368]|9[02-9])|8(?:1[236-8]|2[5-7]|3\\d|5[2-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))(?:[02-8]\\d{6}|1(?:0(?:0\\d\\d(?:\\d{2})?|[1-9]\\d{4})|[13-9]\\d{5}|2(?:[0-24-9]\\d{4}|3\\d(?:\\d{3})?))|9(?:[0-46-9]\\d{5}|5\\d{3,5}))", [7, 8, 9, 10, 11]], ["1740[0-5]\\d{6}|1(?:[38]\\d|4[57]|[59][0-35-9]|6[25-7]|7[0-35-8])\\d{8}", [11]], ["(?:(?:10|21)8|8)00\\d{7}", [10, 12]], ["16[08]\\d{5}", [8]], 0, 0, 0, 0, 0, ["10(?:10\\d{4}|96\\d{3,4})|400\\d{7}|950\\d{7,8}|(?:2[0-57-9]|3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))96\\d{3,4}", [7, 8, 9, 10, 11]]], "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?", 0, 0, 0, [["601055(?:[0-4]\\d|50)\\d\\d|6010(?:[0-4]\\d|5[0-4])\\d{4}|(?:46|60(?:[18][1-9]|[24-7][2-9]))\\d{6}", [8, 10]], ["333301[0-5]\\d{3}|3333(?:00|2[5-9]|[3-9]\\d)\\d{4}|(?:3(?:(?:0[0-5]|1\\d|5[01]|70)\\d|2(?:[0-3]\\d|4[1-9])|3(?:00|3[0-24-9]))|9(?:101|408))\\d{6}", [10]], ["1800\\d{7}", [11]], ["(?:19(?:0[01]|4[78])|901)\\d{7}", [10, 11]]]], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))", 0, 0, 0, [["210[7-9]\\d{4}|2(?:[024-7]\\d|1[1-9])\\d{5}", [8]], ["(?:3005\\d|6500[01])\\d{3}|(?:5[07]|6[0-4]|7[0-3]|8[3-9])\\d{6}", [8]], ["800\\d{7}", [10]], ["90[059]\\d{7}", [10]], 0, 0, 0, 0, ["(?:210[0-6]|4\\d{3}|5100)\\d{4}", [8]]]], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[23]|4[89])\\d{4,6}|(?:31|4[36]|8(?:0[25]|78)\\d)\\d{6}|(?:2[1-4]|4[1257]|7\\d)\\d{5,6}"], ["(?:5\\d|6[2-4])\\d{6}", [8]], ["800\\d{7}", [10]], 0, 0, 0, 0, 0, 0, ["807\\d{7}", [10]]]], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[1-7]|3[0-8]|4[12]|5[1256]|6\\d|7[1-3]|8[1-5])\\d{4}"], ["(?:36|5[1-389]|9\\d)\\d{5}"], ["800\\d{4}"], 0, 0, 0, 0, 0, ["(?:3[3-5]|4[356])\\d{5}"]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]", [["9(?:4(?:3[0-5]|4[14]|6\\d)|50\\d|7(?:2[014]|3[02-9]|4[4-9]|6[357]|77|8[7-9])|8(?:3[39]|[46]\\d|7[01]|8[57-9]))\\d{4}"], ["953[01]\\d{4}|9(?:5[12467]|6[5-9])\\d{5}"], 0, 0, 0, 0, 0, ["955\\d{5}", [8]], 0, ["60[0-2]\\d{4}", [7]]]], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-478])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]], 0, 0, 0, 0, 0, 0, [["2[2-6]\\d{6}"], ["9(?:10|[4-79]\\d)\\d{5}"], ["800\\d{5}"], ["90[09]\\d{5}"], ["700\\d{5}"], 0, ["(?:50|77)\\d{6}"], 0, 0, ["80[1-9]\\d{5}"]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[1257-9]|4[16-9]|5[13-9])\\d{7}", [9]], ["7(?:060\\d|19(?:[0-5]\\d|6[0-6]))\\d{4}|(?:60[1-8]|7(?:0[2-5]|[2379]\\d))\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:0[05689]|76)\\d{6}", [9]], ["70[01]\\d{6}", [9]], ["9(?:3\\d{9}|6\\d{7,10})"], ["9(?:5\\d|7[2-4])\\d{6}", [9]], 0, ["9[17]0\\d{6}", [9]], ["8[134]\\d{7}", [9]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0", 0, 0, 0, 0, 0, [["32\\d{9,11}|49[1-6]\\d{10}|322\\d{6}|49[0-7]\\d{3,9}|(?:[34]0|[68]9)\\d{3,13}|(?:2(?:0[1-689]|[1-3569]\\d|4[0-8]|7[1-7]|8[0-7])|3(?:[3569]\\d|4[0-79]|7[1-7]|8[1-8])|4(?:1[02-9]|[2-48]\\d|5[0-6]|6[0-8]|7[0-79])|5(?:0[2-8]|[124-6]\\d|[38][0-8]|[79][0-7])|6(?:0[02-9]|[1-358]\\d|[47][0-8]|6[1-9])|7(?:0[2-8]|1[1-9]|[27][0-7]|3\\d|[4-6][0-8]|8[0-5]|9[013-7])|8(?:0[2-9]|1[0-79]|2\\d|3[0-46-9]|4[0-6]|5[013-9]|6[1-8]|7[0-8]|8[0-24-6])|9(?:0[6-9]|[1-4]\\d|[589][0-7]|6[0-8]|7[0-467]))\\d{3,12}", [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]], ["1(?:(?:5(?:[0-25-9]\\d\\d|3(?:10|33))|7[26-9]\\d\\d)\\d{6}|6[023]\\d{7,8})|17\\d{8}", [10, 11]], ["800\\d{7,12}", [10, 11, 12, 13, 14, 15]], ["(?:137[7-9]|900(?:[135]|9\\d))\\d{6}", [10, 11]], ["700\\d{8}", [11]], ["1(?:6(?:013|255|399)|7(?:(?:[015]1|[69]3)3|[2-4]55|[78]99))\\d{7,8}|15(?:(?:[03-68]00|113)\\d|2\\d55|7\\d99|9\\d33)\\d{7}", [12, 13]], ["18(?:1\\d{5,11}|[2-9]\\d{8})", [8, 9, 10, 11, 12, 13, 14]], ["16(?:4\\d{1,10}|[89]\\d{1,11})", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14]], 0, ["180\\d{5,11}|13(?:7[1-6]\\d\\d|8)\\d{4}", [7, 8, 9, 10, 11, 12, 13, 14]]]], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]], 0, 0, 0, 0, 0, 0, [["2(?:1[2-5]|7[45])\\d{5}"], ["77\\d{6}"]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0-59][1-9]|[6-8]\\d)|3(?:[0-3][1-9]|4[13]|5[1-58]|6[1347-9]|7\\d|8[1-8]|9[1-79])|4(?:[0-25][1-9]|[34][2-9]|6[13-579]|7[13579]|8[1-47]|9[127])|5(?:[0-36][1-9]|4[146-9]|5[3-57-9]|7[568]|8[1-358]|9[1-69])|6(?:[0135][1-9]|2[1-68]|4[2-8]|6[1689]|[78]\\d|9[15689])|7(?:[0-69][1-9]|7[3-9]|8[147])|8(?:[16-9][1-9]|2[1-58])|9(?:[1-47-9][1-9]|6\\d))\\d{5}"], ["(?:2[6-8]|37|6[78]|96)\\d{6}|(?:2[0-59]|3[0-689]|[457]\\d|6[0-69]|8[126-9]|9[1-47-9])[1-9]\\d{5}"], ["80\\d{6}"], ["90\\d{6}"]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767", [["767(?:2(?:55|66)|4(?:2[01]|4[0-25-9])|50[0-4])\\d{4}"], ["767(?:2(?:[2-4689]5|7[5-7])|31[5-7]|61[1-8]|70[1-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9", [["8(?:[04]9[2-9]\\d\\d|29(?:2(?:[0-59]\\d|6[04-9]|7[0-27]|8[0237-9])|3(?:[0-35-9]\\d|4[7-9])|[45]\\d\\d|6(?:[0-27-9]\\d|[3-5][1-9]|6[0135-8])|7(?:0[013-9]|[1-37]\\d|4[1-35689]|5[1-4689]|6[1-57-9]|8[1-79]|9[1-8])|8(?:0[146-9]|1[0-48]|[248]\\d|3[1-79]|5[01589]|6[013-68]|7[124-8]|9[0-8])|9(?:[0-24]\\d|3[02-46-9]|5[0-79]|60|7[0169]|8[57-9]|9[02-9])))\\d{4}"], ["8[024]9[2-9]\\d{6}"], ["800(?:14|[2-9]\\d)\\d{5}|8[024]9[01]\\d{6}|8(?:33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["9619\\d{5}|(?:1\\d|2[013-79]|3[0-8]|4[013-689])\\d{6}"], ["(?:5(?:4[0-29]|5\\d|6[0-3])|6(?:[569]\\d|7[0-6])|7[7-9]\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["80[3-689]1\\d{5}", [9]], 0, 0, 0, 0, ["98[23]\\d{6}", [9]], ["80[12]1\\d{5}", [9]]]], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["[2-7][2-7]\\d{6}", [8]], ["964[0-2]\\d{5}|9(?:39|[57][89]|6[0-36-9]|[89]\\d)\\d{6}", [9]], ["1800\\d{7}|1[78]00\\d{6}", [10, 11]], 0, 0, 0, 0, 0, ["[2-7]890\\d{4}", [8]]]], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:3[23589]|4[3-8]|6\\d|7[1-9]|88)\\d{5}", [7]], ["(?:5\\d{5}|8(?:1(?:0(?:0(?:00|[178]\\d)|[3-9]\\d\\d)|(?:1(?:0[2-6]|1\\d)|(?:2[0-59]|[3-79]\\d)\\d)\\d)|2(?:0(?:0(?:00|4\\d)|(?:19|[2-7]\\d)\\d)|(?:(?:[124-69]\\d|3[5-9])\\d|7(?:[0-79]\\d|8[13-9])|8(?:[2-6]\\d|7[01]))\\d)|[349]\\d{4}))\\d\\d|5(?:(?:[02]\\d|5[0-478])\\d|1(?:[0-8]\\d|95)|6(?:4[0-4]|5[1-589]))\\d{3}", [7, 8]], ["800(?:(?:0\\d\\d|1)\\d|[2-9])\\d{3}"], ["(?:40\\d\\d|900)\\d{4}", [7, 8]], ["70[0-2]\\d{5}", [8]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["13[23]\\d{6}|(?:15|57)\\d{6,7}|(?:2\\d|3|4[05-8]|5[05]|6[24-689]|8[2468]|9[235-7])\\d{7}", [8, 9]], ["1[0-25]\\d{8}", [10]], ["800\\d{7}", [10]], ["900\\d{7}", [10]]]], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]", [["528[89]\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1[12568]|[24]0|55|6[146])|8\\d\\d)\\d{4}"], ["(?:17[1-3]|7\\d\\d)\\d{4}"]]], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["96906(?:0[0-8]|1[1-9]|[2-9]\\d)\\d\\d|9(?:69(?:0[0-57-9]|[1-9]\\d)|73(?:[0-8]\\d|9[1-9]))\\d{4}|(?:8(?:[1356]\\d|[28][0-8]|[47][1-9])|9(?:[135]\\d|[268][0-8]|4[1-9]|7[124-9]))\\d{6}"], ["96906(?:09|10)\\d\\d|(?:590(?:10[0-2]|600)|97390\\d)\\d{3}|(?:6\\d|7[1-48])\\d{7}"], ["[89]00\\d{6}"], ["80[367]\\d{6}"], ["70\\d{7}"], 0, ["51\\d{7}"], 0, 0, ["90[12]\\d{6}"]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["11667[01]\\d{3}|(?:11(?:1(?:1[1-468]|2[2-7]|3[1-5]|5[5-8]|8[6-8])|2(?:13|3[6-8]|5[89]|7[05-9]|8[2-6])|3(?:2[01]|3[0-289]|4[1289]|7[1-4]|87)|4(?:1[69]|3[2-49]|4[0-3]|6[5-8]|7\\d)|5(?:1[578]|44|5[0-4])|6(?:1[578]|2[69]|39|4[5-7]|5[0-5]|6[0-59]|8[015-8]))|2(?:2(?:11[1-9]|22[0-7]|33\\d|44[1467]|66[1-68])|5(?:11[124-6]|33[2-8]|44[1467]|55[14]|66[1-3679]|77[124-79]|880))|3(?:3(?:11[0-46-8]|(?:22|55)[0-6]|33[0134689]|44[04]|66[01467])|4(?:44[0-8]|55[0-69]|66[0-3]|77[1-5]))|4(?:6(?:119|22[0-24-7]|33[1-5]|44[13-69]|55[14-689]|660|88[1-4])|7(?:(?:11|22)[1-9]|33[13-7]|44[13-6]|55[1-689]))|5(?:7(?:227|55[05]|(?:66|77)[14-8])|8(?:11[149]|22[013-79]|33[0-68]|44[013-8]|550|66[1-5]|77\\d)))\\d{4}"], ["700[1-9]\\d{5}|(?:7(?:0[1-9]|1[0-8]|22|77|86|99)|9\\d\\d)\\d{6}"]]], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", [["1[3-7][1-8]\\d{3,6}|(?:19[1-8]|[23568][1-8]\\d|9(?:00|[1-8]\\d))\\d{2,6}", [5, 6, 7, 8, 9]], ["4946\\d{2,6}|(?:4[0-8]|50)\\d{4,8}", [6, 7, 8, 9, 10]], ["800\\d{4,6}", [7, 8, 9]], ["[67]00\\d{5,6}", [8, 9]], 0, 0, ["20\\d{4,8}|60[12]\\d{5,6}|7(?:099\\d{4,5}|5[03-9]\\d{3,7})|20[2-59]\\d\\d|(?:606|7(?:0[78]|1|3\\d))\\d{7}|(?:10|29|3[09]|70[1-5]\\d)\\d{4,8}"]], "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, [["603\\d{4}|(?:3[0-5]|6[25-7]|8[58])\\d{5}", [7]], ["(?:[279]\\d|45|5[01568]|8[034679])\\d{5}", [7]], ["0800\\d{7}", [11]]], "00"], FK: ["500", "00", "[2-7]\\d{4}", [5], 0, 0, 0, 0, 0, 0, 0, [["[2-47]\\d{4}"], ["[56]\\d{4}"]]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]], 0, 0, 0, 0, 0, 0, [["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-6]\\d)\\d)\\d{3}"], ["31(?:00[67]|208|309)\\d\\d|(?:3(?:[2357]0[1-9]|602|804|905)|(?:820|9[2-7]\\d)\\d)\\d{3}"]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))", 0, 0, 0, [["(?:20|[34]\\d|8[19])\\d{4}"], ["(?:[27][1-9]|5\\d|9[16])\\d{4}"], ["80[257-9]\\d{3}"], ["90(?:[13-5][15-7]|2[125-7]|9\\d)\\d\\d"], 0, 0, 0, 0, ["(?:6[0-36]|88)\\d{4}"]]], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:26[013-9]|59[1-35-9])\\d{6}|(?:[13]\\d|2[0-57-9]|4[1-9]|5[0-8])\\d{7}"], ["(?:6(?:[0-24-8]\\d|3[0-8]|9[589])|7[3-9]\\d)\\d{6}"], ["80[0-5]\\d{6}"], ["836(?:0[0-36-9]|[1-9]\\d)\\d{4}|8(?:1[2-9]|2[2-47-9]|3[0-57-9]|[569]\\d|8[0-35-9])\\d{6}"], 0, 0, ["80[6-9]\\d{6}"], 0, ["9\\d{8}"], ["8(?:1[01]|2[0156]|4[024]|84)\\d{6}"]]], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1", 0, 0, [["[01]1\\d{6}", [8]], ["(?:(?:0[2-7]|7[467])\\d|6(?:0[0-4]|10|[256]\\d))\\d{5}|[2-7]\\d{6}"]]], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473", [["473(?:2(?:3[0-2]|69)|3(?:2[89]|86)|4(?:[06]8|3[5-9]|4[0-4]|5[59]|73|90)|63[68]|7(?:58|84)|800|938)\\d{4}"], ["473(?:4(?:0[2-79]|1[04-9]|2[0-5]|49|5[6-8])|5(?:2[01]|3[3-8])|901)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3(?:[256]\\d|4[124-9]|7[0-4])|4(?:1\\d|2[2-7]|3[1-79]|4[2-8]|7[239]|9[1-7]))\\d{6}"], ["5(?:(?:(?:0555|1(?:[17]77|555))[5-9]|757(?:7[7-9]|8[01]))\\d|22252[0-4])\\d\\d|5(?:0(?:0[17]0|505)|1(?:0[01]0|1(?:07|33|51))|2(?:0[02]0|2[25]2)|3(?:0[03]0|3[35]3)|(?:40[04]|900)0|5222)[0-4]\\d{3}|(?:5(?:0(?:0(?:0\\d|1[12]|22|3[0-6]|44|5[05]|77|88|9[09])|(?:[14]\\d|77)\\d|22[02])|1(?:1(?:[03][01]|[124]\\d|5[2-6]|7[0-4])|4\\d\\d)|[23]555|4(?:4\\d\\d|555)|5(?:[0157-9]\\d\\d|200|333|444)|6[89]\\d\\d|7(?:(?:[0147-9]\\d|22)\\d|5(?:00|[57]5))|8(?:0(?:[018]\\d|2[0-4])|5(?:55|8[89])|8(?:55|88))|9(?:090|[1-35-9]\\d\\d))|790\\d\\d)\\d{4}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["70[67]\\d{6}"]]], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["594(?:[02-49]\\d|1[0-5]|5[6-9]|6[0-3]|80)\\d{4}"], ["(?:694(?:[0-249]\\d|3[0-8])|7093[0-3])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:396|76\\d)\\d|476[0-6])\\d{4}"]]], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["3082[0-5]\\d{4}|3(?:0(?:[237]\\d|8[01])|[167](?:2[0-6]|7\\d|80)|2(?:2[0-5]|7\\d|80)|3(?:2[0-3]|7\\d|80)|4(?:2[013-9]|3[01]|7\\d|80)|5(?:2[0-7]|7\\d|80)|8(?:2[0-2]|7\\d|80)|9(?:[28]0|7\\d))\\d{5}", [9]], ["(?:2(?:[0346-9]\\d|5[67])|5(?:[03-7]\\d|9[1-9]))\\d{6}", [9]], ["800\\d{5}", [8]]]], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]], 0, 0, 0, 0, 0, 0, [["2190[0-2]\\d{3}|2(?:0(?:[02]\\d|3[01])|16[24-9]|2[2-5]\\d)\\d{4}"], ["5251[0-4]\\d{3}|(?:5(?:[146-8]\\d\\d|250)|60(?:1[01]|6\\d))\\d{4}"]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:19|3[1-7]|[68][1-9]|70|9\\d)\\d{4}"], ["[245]\\d{5}"], ["80\\d{4}"], 0, 0, 0, 0, 0, ["3[89]\\d{4}"]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:[23]\\d\\d|4(?:1[024679]|[6-9]\\d))|5(?:5(?:3\\d|4[0-7])|6[67]\\d|7(?:1[04]|2[035]|3[58]|48))|8[0-589]\\d\\d)\\d{3}"], ["556\\d{4}|(?:[23679]\\d|4[015]|5[0-489]|8[67])\\d{5}"]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:24|3[12]|4[1-35-7]|5[13]|6[189]|[78]1|9[1478])|1\\d\\d)\\d{4}", [8]], ["6[0-356]\\d{7}", [9]], 0, 0, 0, 0, 0, 0, ["722\\d{6}", [9]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["33[0-24-9]\\d[46]\\d{4}|3(?:33|5\\d)\\d[7-9]\\d{4}"], ["(?:222|55\\d)\\d{6}"], ["80\\d[1-9]\\d{5}"], ["90\\d[1-9]\\d{5}"]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:1\\d\\d|2(?:2[1-46-9]|[36][1-8]|4[1-7]|5[1-4]|7[1-5]|[89][1-9])|3(?:1\\d|2[1-57]|[35][1-3]|4[13]|7[1-7]|8[124-6]|9[1-79])|4(?:1\\d|2[1-8]|3[1-4]|4[13-5]|6[1-578]|9[1-5])|5(?:1\\d|[29][1-4]|3[1-5]|4[124]|5[1-6])|6(?:1\\d|[269][1-6]|3[1245]|4[1-7]|5[13-9]|7[14]|8[1-5])|7(?:1\\d|2[1-5]|3[1-6]|4[1-7]|5[1-57]|6[135]|9[125-7])|8(?:1\\d|2[1-5]|[34][1-4]|9[1-57]))\\d{6}", [10]], ["68[57-9]\\d{7}|(?:69|94)\\d{8}", [10]], ["800\\d{7,9}"], ["90[19]\\d{7}", [10]], ["70\\d{8}", [10]], 0, ["5005000\\d{3}", [10]], 0, 0, ["8(?:0[16]|12|[27]5|50)\\d{7}", [10]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["[267][2-9]\\d{6}", [8]], ["(?:[3-5]\\d\\d|80[0-4])\\d{5}", [8]], ["18[01]\\d{8}", [11]], ["19\\d{9}", [11]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671", [["671(?:2\\d\\d|3(?:00|3[39]|4[349]|55|6[26])|4(?:00|56|7[1-9]|8[02-9])|5(?:55|6[2-5]|88)|6(?:3[2-578]|4[24-9]|5[34]|78|8[235-9])|7(?:[0479]7|2[0167]|3[45]|8[7-9])|8(?:[2-57-9]8|6[478])|9(?:2[29]|6[79]|7[1279]|8[7-9]|9[78]))\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]], 0, 0, 0, 0, 0, 0, [["443\\d{6}", [9]], ["9(?:5\\d|6[569]|77)\\d{6}", [9]], 0, 0, 0, 0, 0, 0, ["40\\d{5}", [7]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:1[6-9]|2[0-35-9]|3[1-4]|5[3-9]|6\\d|7[0-79])|3(?:2[25-9]|3\\d)|4(?:4[0-24]|5[56])|50[0-6]|77[1-57])\\d{4}"], ["(?:51[01]|6\\d\\d|7(?:[0-5]\\d|6[0-39]|70))\\d{4}"], ["(?:289|8(?:00|6[28]|88|99))\\d{4}"], ["9008\\d{3}"], 0, 0, 0, 0, ["515\\d{4}"]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[13-9]\\d|2[013-9])\\d|3(?:(?:[1569][0-24-9]|4[0-246-9]|7[0-24-69])\\d|8(?:4[0-8]|[579]\\d|6[0-5]))|58(?:0[1-9]|1[2-9]))\\d{4}", [8]], ["(?:4(?:44[0-35-9]|6(?:4[0-57-9]|6[0-6])|7(?:3[0-4]|4[0-48]|6[0-5]))|5(?:35[4-8]|73[0-6]|95[0-8])|6(?:26[013-8]|(?:66|78)[0-5])|70(?:7[1-8]|8[0-8])|84(?:4[0-2]|8[0-35-9])|9(?:29[013-9]|39[014-9]|59[0-467]|899))\\d{4}|(?:4(?:4[0-35-9]|6[0-357-9]|7[0-25])|5(?:[1-59][0-46-9]|6[0-4689]|7[0-246-9])|6(?:0[1-9]|[13-59]\\d|[268][0-57-9]|7[0-79])|70[1-59]|84[0-39]|9(?:0[1-9]|1[02-9]|[2358][0-8]|[467]\\d))\\d{5}", [8]], ["800\\d{6}", [9]], ["900(?:[0-24-9]\\d{7}|3\\d{1,4})", [5, 6, 7, 8, 11]], ["8(?:1[0-4679]\\d|2(?:[0-36]\\d|7[0-4])|3(?:[034]\\d|2[09]|70))\\d{4}", [8]], 0, ["30(?:0[1-9]|[15-7]\\d|2[047]|89)\\d{4}", [8]], ["7(?:1(?:0[0-38]|1[0-3679]|3[013]|69|9[0136])|2(?:[02389]\\d|1[18]|7[27-9])|3(?:[0-38]\\d|7[0-369]|9[2357-9])|47\\d|5(?:[178]\\d|5[0-5])|6(?:0[0-7]|2[236-9]|[35]\\d)|7(?:[27]\\d|8[7-9])|8(?:[23689]\\d|7[1-9])|9(?:[025]\\d|6[0-246-8]|7[0-36-9]|8[238]))\\d{4}", [8]]], "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2(?:0[0-59]|1[1-9]|[23]\\d|4[02-7]|5[57]|6[245]|7[0135689]|8[01346-9]|9[0-2])|4(?:0[578]|2[3-59]|3[13-9]|4[0-68]|5[1-3589])|5(?:0[2357-9]|1[1-356]|4[03-5]|5\\d|6[014-69]|7[04]|80)|6(?:[056]\\d|17|2[067]|3[047]|4[0-378]|[78][0-8]|9[01])|7(?:0[5-79]|6[46-9]|7[02-9]|8[034]|91)|8(?:79|8[0-357-9]|9[1-57-9]))\\d{4}", [8]], ["[37-9]\\d{7}", [8]], ["8002\\d{7}", [11]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[0-3]|3[1-5]|4[02-47-9]|5[1-3])\\d{6,7}", [8, 9]], ["9(?:(?:0[1-9]|[12589]\\d)\\d\\d|7(?:[0679]\\d\\d|5(?:[01]\\d|44|55|77|9[5-79])))\\d{4}|98\\d{6}", [8, 9]], ["80\\d{5,7}"], ["6[01459]\\d{6}|6[01]\\d{5}", [7, 8]], ["7[45]\\d{6}", [8]], 0, ["62\\d{6,7}|72\\d{6}", [8, 9]]]], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2\\d|5[1-5]|81|9[149])\\d{5}"], ["(?:[34]\\d|5[56])\\d{6}"], ["8\\d{7}"], 0, 0, 0, 0, 0, ["9(?:[67][0-4]|8[0-3589]|9\\d)\\d{5}"]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06", 0, 0, 0, 0, 0, [["(?:1\\d|[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6[23689]|8[2-57-9]|9[2-69])\\d{6}", [8]], ["(?:[257]0|3[01])\\d{7}", [9]], ["(?:[48]0\\d|680[29])\\d{5}"], ["9[01]\\d{6}", [8]], 0, 0, ["38\\d{7}", [9]], 0, ["21\\d{7}", [9]]]], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[124]\\d{7,8}|619\\d{8}|2(?:1(?:14|500)|2\\d{3})\\d{3}|61\\d{5,8}|(?:2(?:[35][1-4]|6[0-8]|7[1-6]|8\\d|9[1-8])|3(?:1|[25][1-8]|3[1-68]|4[1-3]|6[1-3568]|7[0-469]|8\\d)|4(?:0[1-589]|1[01347-9]|2[0-36-8]|3[0-24-68]|43|5[1-378]|6[1-5]|7[134]|8[1245])|5(?:1[1-35-9]|2[25-8]|3[124-9]|4[1-3589]|5[1-46]|6[1-8])|6(?:[25]\\d|3[1-69]|4[1-6])|7(?:02|[125][1-9]|[36]\\d|4[1-8]|7[0-36-9])|9(?:0[12]|1[013-8]|2[0-479]|5[125-8]|6[23679]|7[159]|8[01346]))\\d{5,8}", [7, 8, 9, 10, 11]], ["8[1-35-9]\\d{7,10}", [9, 10, 11, 12]], ["00(?:1803\\d{5,11}|7803\\d{7})|(?:177\\d|800)\\d{5,7}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17]], ["809\\d{7}", [10]], 0, 0, ["(?:1500|8071\\d{3})\\d{3}", [7, 10]], 0, 0, ["804\\d{7}", [10]]]], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|21)\\d{6,7}|(?:2[24-9]|4(?:0[24]|5\\d|7)|5(?:0[45]|1\\d|8)|6(?:1\\d|[237-9])|9(?:1\\d|[35-9]))\\d{5}|(?:23|4(?:[1-469]|8\\d)|5[23679]|6[4-6]|7[14]|9[04])\\d{7}"], ["8(?:22|[35-9]\\d)\\d{6}", [9]], ["1800\\d{6}", [10]], ["15(?:1[2-8]|[2-8]0|9[089])\\d{6}", [10]], ["700\\d{6}", [9]], ["88210[1-9]\\d{4}|8(?:[35-79]5\\d\\d|8(?:[013-9]\\d\\d|2(?:[01][1-9]|[2-9]\\d)))\\d{5}", [10]], ["818\\d{6}", [9]], 0, ["76\\d{7}", [9]], ["18[59]0\\d{6}", [10]]]], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0", 0, 0, 0, 0, 0, [["153\\d{8,9}|29[1-9]\\d{5}|(?:2[0-8]|[3489]\\d)\\d{6}", [8, 11, 12]], ["55(?:4(?:0[01]|10|5[0-7])|57[0-289])\\d{4}|5(?:(?:[0-2][02-9]|[36]\\d|[49][2-9]|8[3-7])\\d|5(?:01|2\\d|3[0-3]|4[34]|5[0-25689]|6[6-8]|7[0-267]|8[7-9]|9[1-9]))\\d{5}", [9]], ["1(?:255|80[019]\\d{3})\\d{3}", [7, 10]], ["1212\\d{4}|1(?:200|9(?:0[0-2]|19))\\d{6}", [8, 10]], 0, ["151\\d{8,9}", [11, 12]], ["1599\\d{6}", [10]], 0, ["7(?:38(?:[05]\\d|8[018])|8(?:33|55|77|81)\\d)\\d{4}|7(?:18|2[23]|3[237]|47|6[258]|7\\d|82|9[2-9])\\d{6}", [9]], ["1700\\d{6}", [10]]]], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24", [["1624(?:230|[5-8]\\d\\d)\\d{3}"], ["76245[06]\\d{4}|7(?:4576|[59]24\\d|624[0-4689])\\d{5}"], ["808162\\d{4}"], ["8(?:440[49]06|72299\\d)\\d{3}|(?:8(?:45|70)|90[0167])624\\d{4}"], ["70\\d{8}"], 0, ["3440[49]06\\d{3}|(?:3(?:08162|3\\d{4}|45624|7(?:0624|2299))|55\\d{4})\\d{4}"], 0, ["56\\d{8}"]]], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0", 0, 0, 0, 0, 0, [["2717(?:[2-7]\\d|95)\\d{4}|(?:271[0-689]|782[0-6])[2-7]\\d{5}|(?:170[24]|2(?:(?:[02][2-79]|90)\\d|80[13468])|(?:3(?:23|80)|683|79[1-7])\\d|4(?:20[24]|72[2-8])|552[1-7])\\d{6}|(?:11|33|4[04]|80)[2-7]\\d{7}|(?:342|674|788)(?:[0189][2-7]|[2-7]\\d)\\d{5}|(?:1(?:2[0-249]|3[0-25]|4[145]|[59][14]|6[014]|7[1257]|8[01346])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[13]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[014-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91))[2-7]\\d{6}|(?:1(?:2[35-8]|3[346-9]|4[236-9]|[59][0235-9]|6[235-9]|7[34689]|8[257-9])|2(?:1[134689]|3[24-8]|4[2-8]|5[25689]|6[2-4679]|7[3-79]|8[2-479]|9[235-9])|3(?:01|1[79]|2[1245]|4[5-8]|5[125689]|6[235-7]|7[157-9]|8[2-46-8])|4(?:1[14578]|2[5689]|3[2-467]|5[4-7]|6[35]|73|8[2689]|9[2389])|5(?:[16][146-9]|2[14-8]|3[1346]|4[14-69]|5[46]|7[2-4]|8[2-8]|9[246])|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])|7(?:1[013-9]|2[0235-9]|3[2679]|4[1-35689]|5[2-46-9]|[67][02-9]|8[013-7]|9[089])|8(?:1[1357-9]|2[235-8]|3[03-57-9]|4[0-24-9]|5\\d|6[2457-9]|7[1-6]|8[1256]|9[2-4]))\\d[2-7]\\d{5}", [10]], ["(?:61279|7(?:887[02-9]|9(?:313|79[07-9]))|8(?:079[04-9]|(?:84|91)7[02-8]))\\d{5}|(?:6(?:12|[2-47]1|5[17]|6[13]|80)[0189]|7(?:1(?:2[0189]|9[0-5])|2(?:[14][017-9]|8[0-59])|3(?:2[5-8]|[34][017-9]|9[016-9])|4(?:1[015-9]|[29][89]|39|8[389])|5(?:[15][017-9]|2[04-9]|9[7-9])|6(?:0[0-47]|1[0-257-9]|2[0-4]|3[19]|5[4589])|70[0289]|88[089]|97[02-8])|8(?:0(?:6[67]|7[02-8])|70[017-9]|84[01489]|91[0-289]))\\d{6}|(?:7(?:31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[0189]\\d|7[02-8])\\d{5}|(?:6(?:[09]\\d|1[04679]|2[03689]|3[05-9]|4[0489]|50|6[069]|7[07]|8[7-9])|7(?:0\\d|2[0235-79]|3[05-8]|40|5[0346-8]|6[6-9]|7[1-9]|8[0-79]|9[089])|8(?:0[01589]|1[0-57-9]|2[235-9]|3[03-57-9]|[45]\\d|6[02457-9]|7[1-69]|8[0-25-9]|9[02-9])|9\\d\\d)\\d{7}|(?:6(?:(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|8[124-6])\\d|7(?:[235689]\\d|4[0189]))|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-5])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]|881))[0189]\\d{5}", [10]], ["000800\\d{7}|1(?:600\\d{6}|80(?:0\\d{4,9}|3\\d{9}))"], ["186[12]\\d{9}", [13]], 0, 0, ["140\\d{7}", [10]], 0, 0, ["1860\\d{7}", [11]]]], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]], 0, 0, 0, 0, 0, 0, [["37\\d{5}"], ["38\\d{5}"]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1\\d{7}|(?:2[13-5]|3[02367]|4[023]|5[03]|6[026])\\d{6,7}", [8, 9]], ["7[3-9]\\d{8}", [10]]]], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])(?:[03-57]\\d{7}|[16]\\d{3}(?:\\d{4})?|[289]\\d{3}(?:\\d(?:\\d{3})?)?)|94(?:000[09]|(?:12\\d|30[0-2])\\d|2(?:121|[2689]0\\d)|4(?:111|40\\d))\\d{4}", [6, 7, 10]], ["9(?:(?:0[0-5]|[13]\\d|2[0-3])\\d\\d|9(?:[0-46]\\d\\d|5(?:10|5\\d)|8(?:[12]\\d|88)|9(?:0[0-3]|[19]\\d|21|69|77|8[7-9])))\\d{5}", [10]], 0, 0, 0, 0, ["96(?:0[12]|2[16-8]|3(?:08|[14]5|[23]|66)|4(?:0|80)|5[01]|6[89]|86|9[19])", [4, 5]]]], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["(?:4(?:1[0-24-69]|2[0-7]|[37][0-8]|4[0-24589]|5[0-68]|6\\d|8[0-36-8])|5(?:05|[156]\\d|2[02578]|3[0-579]|4[03-7]|7[0-2578]|8[0-35-9]|9[013-689])|872)\\d{4}", [7]], ["(?:38[589]\\d\\d|6(?:1[1-8]|2[0-6]|3[026-9]|4[014679]|5[0159]|6[0-69]|70|8[06-8]|9\\d)|7(?:5[057]|[6-9]\\d)|8(?:2[0-59]|[3-69]\\d|8[238]))\\d{4}"], ["80[0-8]\\d{4}", [7]], ["90(?:0\\d|1[5-79]|2[015-79]|3[135-79]|4[125-7]|5[25-79]|7[1-37]|8[0-35-7])\\d{3}", [7]], 0, ["(?:689|8(?:7[18]|80)|95[48])\\d{4}", [7]], ["809\\d{4}", [7]], 0, ["49[0-24-79]\\d{4}", [7]]], "00"], IT: ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876", [["8766060\\d{3}|(?:658(?:2(?:[0-8]\\d|9[0-46-9])|[3-9]\\d\\d)|876(?:52[35]|6(?:0[1-3579]|1[0235-9]|[23]\\d|40|5[06]|6[2-589]|7[0-25-9]|8[04]|9[4-9])|7(?:0[2-689]|[1-6]\\d|8[056]|9[45])|9(?:0[1-8]|1[02378]|[2-8]\\d|9[2-468])))\\d{4}"], ["(?:658295|876(?:2(?:0[1-9]|[13-9]\\d|2[013-9])|[348]\\d\\d|5(?:0[1-9]|[1-9]\\d)|6(?:4[89]|6[67])|7(?:0[07]|7\\d|8[1-47-9]|9[0-36-9])|9(?:[01]9|9[0579])))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["87(?:000|90[01])\\d{3}|(?:2(?:6(?:2[0-35-9]|3[0-578]|4[24-7]|5[0-24-8]|[6-8][023]|9[0-3])|7(?:0[1-79]|10|2[014-7]|3[0-689]|4[019]|5[0-3578]))|32(?:0[1-69]|1[1-35-7]|2[024-7]|3\\d|4[0-3]|[5-7][023])|53(?:0[0-3]|[13][023]|2[0-59]|49|5[0-35-9]|6[15]|7[45]|8[1-6]|9[0-36-9])|6(?:2(?:[05]0|22)|3(?:00|33)|4(?:0[0-25]|1[2-7]|2[0569]|[38][07-9]|4[025689]|6[0-589]|7\\d|9[0-2])|5(?:[01][056]|2[034]|3[0-57-9]|4[178]|5[0-69]|6[0-35-9]|7[1-379]|8[0-68]|9[0239]))|87(?:20|7[078]|99))\\d{4}", [8]], ["(?:427|7(?:[78][0-25-9]|9\\d))\\d{6}", [9]], ["80\\d{6}", [8]], ["9\\d{7}", [8]], ["70\\d{7}", [9]], 0, ["8(?:10|8\\d)\\d{5}", [8]], ["74(?:66|77)\\d{5}", [9]], 0, ["85\\d{6}", [8]]]], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1", 0, 0, [["(?:1(?:1[235-8]|2[3-6]|3[3-9]|4[2-6]|[58][2-8]|6[2-7]|7[2-9]|9[1-9])|(?:2[2-9]|[36][1-9])\\d|4(?:[2-578]\\d|6[02-8]|9[2-59])|5(?:[2-589]\\d|6[1-9]|7[2-8])|7(?:[25-9]\\d|3[4-9]|4[02-9])|8(?:[2679]\\d|3[2-9]|4[5-9]|5[1-9]|8[03-9])|9(?:[2-58]\\d|[679][1-9]))\\d{6}", [9]], ["(?:601[0-4]0|[7-9]0[1-9]\\d\\d)\\d{5}", [10]], ["00777(?:[01]|5\\d)\\d\\d|(?:00(?:7778|882[1245])|(?:120|800\\d)\\d\\d)\\d{4}|00(?:37|66|78)\\d{6,13}"], ["990\\d{6}", [9]], ["60\\d{7}", [9]], 0, ["570\\d{6}", [9]], ["20\\d{8}", [10]], ["50[1-9]\\d{7}", [10]]]], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[245]|5[1-79]|6[01457-9])\\d{5,7}|(?:4[136]|5[08]|62)\\d{7}|(?:[24]0|66)\\d{6,7}", [7, 8, 9]], ["(?:1(?:0[0-8]|1\\d|2[014]|[34]0)|7\\d\\d)\\d{6}", [9]], ["800[02-8]\\d{5,6}", [9, 10]], ["900[02-9]\\d{5}", [9]]]], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["312(?:5[0-79]\\d|9(?:[0-689]\\d|7[0-24-9]))\\d{3}|(?:3(?:1(?:2[0-46-8]|3[1-9]|47|[56]\\d)|2(?:22|3[0-479]|6[0-7])|4(?:22|5[6-9]|6\\d)|5(?:22|3[4-7]|59|6\\d)|6(?:22|5[35-7]|6\\d)|7(?:22|3[468]|4[1-9]|59|[67]\\d)|9(?:22|4[1-8]|6\\d))|6(?:09|12|2[2-4])\\d)\\d{5}", [9]], ["312(?:58\\d|973)\\d{3}|(?:2(?:0[0-35]|2\\d)|5[0-24-7]\\d|600|7(?:[07]\\d|55)|88[08]|9(?:12|9[05-9]))\\d{6}", [9]], ["800\\d{6,7}"]]], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["23(?:4(?:[2-4]|[56]\\d)|[568]\\d\\d)\\d{4}|23[236-9]\\d{5}|(?:2[4-6]|3[2-6]|4[2-4]|[5-7][2-5])(?:(?:[237-9]|4[56]|5\\d)\\d{5}|6\\d{5,6})", [8, 9]], ["(?:(?:1[28]|3[18]|9[67])\\d|6[016-9]|7(?:[07-9]|[16]\\d)|8(?:[013-79]|8\\d))\\d{6}|(?:1\\d|9[0-57-9])\\d{6}|(?:2[3-6]|3[2-6]|4[2-4]|[5-7][2-5])48\\d{5}", [8, 9]], ["1800(?:1\\d|2[019])\\d{4}", [10]], ["1900(?:1\\d|2[09])\\d{4}", [10]]]], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0", 0, 0, 0, 0, 0, [["(?:[24]\\d|3[1-9]|50|65(?:02[12]|12[56]|22[89]|[3-5]00)|7(?:27\\d\\d|3100|5(?:02[12]|12[56]|22[89]|[34](?:00|81)|500))|8[0-5])\\d{3}"], ["(?:6200[01]|7(?:310[1-9]|5(?:02[03-9]|12[0-47-9]|22[0-7]|[34](?:0[1-9]|8[02-9])|50[1-9])))\\d{3}|(?:63\\d\\d|7(?:(?:[0146-9]\\d|2[0-689])\\d|3(?:[02-9]\\d|1[1-9])|5(?:[0-2][013-9]|[34][1-79]|5[1-9]|[6-9]\\d)))\\d{4}", [8]], 0, 0, 0, 0, 0, 0, ["30(?:0[01]\\d\\d|12(?:11|20))\\d\\d", [8]]]], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]], 0, 0, 0, 0, 0, 0, [["7[4-7]\\d{5}"], ["[34]\\d{6}"], 0, ["8\\d{6}"]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869", [["869(?:2(?:29|36)|302|4(?:6[015-9]|70)|56[5-7])\\d{4}"], ["869(?:48[89]|55[6-8]|66\\d|76[02-7])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:195|2)\\d|3[19]|4[159]|5[37]|6[17]|7[39]|85)\\d{6}"], ["19[1-3]\\d{7}", [10]]]], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?", 0, 0, 0, [["(?:2|3[1-3]|[46][1-4]|5[1-5])[1-9]\\d{6,7}|(?:3[1-3]|[46][1-4]|5[1-5])1\\d{2,3}", [5, 6, 8, 9, 10]], ["1(?:05(?:[0-8]\\d|9[0-6])|22[13]\\d)\\d{4,5}|1(?:0[0-46-9]|[16-9]\\d|2[013-9])\\d{6,7}", [9, 10]], ["00(?:308\\d{6,7}|798\\d{7,9})|(?:00368|[38]0)\\d{7}", [9, 11, 12, 13, 14]], ["60[2-9]\\d{6}", [9]], ["50\\d{8,9}", [10, 11]], 0, ["1(?:5(?:22|33|44|66|77|88|99)|6(?:[07]0|44|6[0168]|88)|8(?:00|33|55|77|99))\\d{4}", [8]], ["15\\d{7,8}", [9, 10]], ["70\\d{8}", [10]]]], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[23]\\d\\d|4(?:[1-35-9]\\d|44)|5(?:0[034]|[2-46]\\d|5[1-3]|7[1-7]))\\d{4}", [8]], ["(?:41\\d\\d|5(?:(?:[05]\\d|1[0-7]|6[56])\\d|2(?:22|5[25])|7(?:55|77)|88[58])|6(?:(?:0[034679]|5[015-9]|6\\d)\\d|1(?:00|11|6[16])|2[26]2|3[36]3|4[46]4|7(?:0[013-9]|[67]\\d)|8[68]8|9(?:[069]\\d|3[039]))|9(?:(?:[04679]\\d|8[057-9])\\d|1(?:00|1[01]|99)|2(?:00|2\\d)|3(?:00|3[03])|5(?:00|5\\d)))\\d{4}", [8]], ["18\\d{5}", [7]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345", [["345(?:2(?:22|3[23]|44|66)|333|444|6(?:23|38|40)|7(?:30|4[35-79]|6[6-9]|77)|8(?:00|1[45]|4[89]|88)|9(?:14|4[035-9]))\\d{4}"], ["345(?:32[1-9]|42[0-4]|5(?:1[67]|2[5-79]|4[6-9]|50|76)|649|82[56]|9(?:1[679]|2[2-9]|3[06-9]|90))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["(?:345976|900[2-9]\\d\\d)\\d{4}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", [["(?:33622|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9]|97)|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[2-4]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]|59))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[2-4]\\d|5[139])|4(?:2\\d|3[1-35-9]|59)|5(?:[23]\\d|4[0-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59))))\\d{5}", [10]], ["7(?:0[0-25-8]|47|6[0-4]|7[15-8]|85)\\d{7}", [10]], ["8(?:00|108\\d{3})\\d{7}"], ["809\\d{7}", [10]], ["808\\d{7}", [10]], 0, 0, 0, ["751\\d{7}", [10]]], "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[13]|[35-7][14]|41|8[1468])\\d{6}", [8]], ["(?:20(?:[23579]\\d|8[78])|30[24]\\d)\\d{6}|30\\d{7}", [9, 10]]]], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0", 0, 0, 0, 0, 0, [["7(?:62|8[0-6]|9[04-9])\\d{4}|(?:[14-69]\\d|2(?:[14-69]\\d|[78][1-9])|7[2-57]|8[02-9])\\d{5}"], ["(?:(?:3|81)\\d|7(?:[01]\\d|6[013-9]|8[7-9]|9[1-3]))\\d{5}"], 0, ["9[01]\\d{6}", [8]], 0, 0, 0, 0, 0, ["80\\d{6}", [8]]]], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758", [["758(?:234|4(?:30|5\\d|6[2-9]|8[0-2])|57[0-2]|(?:63|75)8)\\d{4}"], ["758(?:28[4-7]|384|4(?:6[01]|8[4-9])|5(?:1[89]|20|84)|7(?:1[2-9]|2\\d|3[0-3])|812)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0", 0, 0, 0, [["(?:2(?:01|1[27]|2[024]|3\\d|6[02-578]|96)|3(?:[24]0|33|7[0135-7]|8[048]|9[0269]))\\d{4}", [7]], ["(?:6(?:(?:4[5-9]|5\\d)\\d|6(?:[024-68]\\d|1[01]|3[7-9]|70))\\d|7(?:[37-9]\\d|42|56))\\d{4}"], ["8002[28]\\d\\d|80(?:05\\d|9)\\d{4}"], ["90(?:02[258]|1(?:23|3[14])|66[136])\\d\\d", [7]], 0, ["697(?:42|56|[78]\\d)\\d{4}", [9]], ["870(?:28|87)\\d\\d", [7]]]], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:12[2-9]|602|8[12]\\d|9(?:1\\d|22|9[245]))\\d{6}|(?:11|2[13-7]|3[1-8]|4[157]|5[12457]|6[35-7])[2-57]\\d{6}"], ["7(?:[0-25-8]\\d|4[0-4])\\d{6}"], 0, 0, 0, 0, ["1973\\d{5}"]]], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2\\d{7}", [8]], ["(?:(?:(?:22|33)0|555|7(?:6[01]|7\\d)|88\\d)\\d|4(?:240|[67]))\\d{5}|[56]\\d{6}", [7, 9]], 0, ["332(?:02|[34]\\d)\\d{4}", [9]]]], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["[56]\\d{7}"], ["800[1256]\\d{4}"]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]", 0, 0, 0, [["(?:3[1478]|4[124-6]|52)\\d{6}"], ["6\\d{7}"], ["80[02]\\d{5}"], ["9(?:0[0239]|10)\\d{5}"], ["70[05]\\d{5}"], 0, ["70[67]\\d{5}"], 0, ["[89]01\\d{5}"], ["808\\d{5}"]]], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)", 0, 0, 0, [["(?:35[013-9]|80[2-9]|90[89])\\d{1,8}|(?:2[2-9]|3[0-46-9]|[457]\\d|8[13-9]|9[2-579])\\d{2,9}"], ["6(?:[269][18]|5[1568]|7[189]|81)\\d{6}", [9]], ["800\\d{5}", [8]], ["90[015]\\d{5}", [8]], 0, 0, 0, 0, ["20(?:1\\d{5}|[2-689]\\d{1,7})", [4, 5, 6, 7, 8, 9, 10]], ["801\\d{5}", [8]]]], LV: ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]], 0, 0, 0, 0, 0, 0, [["6\\d{7}"], ["2333[0-8]\\d{3}|2(?:[0-24-9]\\d\\d|3(?:0[07]|[14-9]\\d|2[02-9]|3[0-24-9]))\\d{4}"], ["80\\d{6}"], ["90\\d{6}"], 0, 0, 0, 0, 0, ["81\\d{6}"]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0[56]|[1-6]\\d|7[124579]|8[124])|3(?:1\\d|2[2356])|4(?:[17]\\d|2[1-357]|5[2-4]|8[124])|5(?:[1347]\\d|2[1-469]|5[13-5]|8[1-4])|6(?:[1-479]\\d|5[2-57]|8[1-5])|7(?:[13]\\d|2[13-79])|8(?:[124]\\d|5[124]|84))\\d{6}"], ["9[1-6]\\d{7}"]]], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:870|9[2-47-9]\\d)\\d{5}", [8]], ["4(?:[469]\\d|5[1-9])\\d{5}|(?:3|6\\d)\\d{7}"], ["(?:800|90\\d)\\d{5}", [8]]]], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[1-9]|3[1-79])\\d|5(?:33|5[257]))\\d{5}"], ["562\\d{5}|(?:6\\d|7[16-9])\\d{6}"], ["800\\d{5}"], ["90[056]\\d{5}"], 0, 0, ["803\\d{5}"], 0, ["3[08]\\d{6}"], ["808\\d{5}"]]], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:20[2-8]|3(?:[0-2][2-7]|3[24-7])|4(?:0[2-467]|1[2467])|5(?:0[2467]|1[24-7]|2[2-467]))\\d{5}", [8]], ["6(?:[07-9]\\d|3[024]|6[0-25])\\d{5}", [8]], ["80(?:[0-2578]|9\\d)\\d{5}"], ["9(?:4[1568]|5[178])\\d{5}", [8]], 0, 0, ["77[1-9]\\d{5}", [8]], 0, ["78[1-49]\\d{5}", [8]]]], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1", 0, 0, [["2072[29]\\d{4}|20(?:2\\d|4[47]|5[3467]|6[279]|7[356]|8[268]|9[2457])\\d{5}"], ["3[2-47-9]\\d{7}"], 0, 0, 0, 0, 0, 0, ["22\\d{7}"]]], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1", 0, 0, 0, 0, 0, [["(?:247|528|625)\\d{4}"], ["(?:(?:23|54)5|329|45[35-8])\\d{4}"], 0, 0, 0, 0, 0, 0, ["635\\d{4}"]]], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:(?:2(?:62|77)0|3444)\\d|4[56]440)\\d{3}|(?:34|4[357])700\\d{3}|(?:2(?:[0-3]\\d|5[0-578]|6[01]|82)|3(?:1[3-68]|[23][2-68]|4[23568])|4(?:[23][2-68]|4[3-68]|5[2568]|6[25-8]|7[24-68]|8[4-68]))\\d{5}"], ["7(?:3555|(?:474|9[019]7)7)\\d{3}|7(?:[0-25-8]\\d\\d|3(?:[1-478]\\d|6[01])|4(?:2\\d|60|7[01578])|9(?:[2-4]\\d|5[01]|7[015]))\\d{4}"], ["800\\d{5}"], ["5\\d{7}"], 0, 0, 0, 0, 0, ["8(?:0[1-9]|[1-9]\\d)\\d{5}"]]], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:07[0-8]|12[67])\\d{4}|(?:2(?:02|1[4-689])|4(?:0[0-4]|4[1-59]))\\d{5}"], ["2(?:0(?:01|79)|17\\d)\\d{4}|(?:5[0-3]|[679]\\d|8[2-59])\\d{6}"], ["80\\d{6}"]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:12|[28]\\d|3[56]|7[3-6]|9[0-6])\\d|4(?:2[29]|7[0-2]|83)|6)|2(?:2(?:00|8[34])|4(?:0\\d|22|7[0-2]|83)|51\\d\\d)|4(?:2(?:2\\d\\d|48[013])|3(?:20\\d|4(?:70|83)|56)|420\\d|5(?:2\\d|470))|6(?:0(?:[23]|88\\d)|(?:124|[56]2\\d)\\d|2472|3(?:20\\d|470)|4(?:2[04]\\d|472)|7(?:3\\d\\d|4[67]0|8(?:[01459]\\d|8))))\\d{4}|5(?:2(?:2\\d{5,6}|47[02]\\d{4})|(?:3472|4(?:2(?:1|86)|470)|522\\d|6(?:20\\d|483)|7(?:20\\d|48[01])|8(?:20\\d|47[02])|9(?:20\\d|470))\\d{4})|7(?:(?:0470|4(?:25\\d|470)|5(?:202|470|96\\d))\\d{4}|1(?:20\\d{4,5}|4(?:70|83)\\d{4}))|8(?:1(?:2\\d{5,6}|4(?:10|7[01]\\d)\\d{3})|2(?:2\\d{5,6}|(?:320|490\\d)\\d{3})|(?:3(?:2\\d\\d|470)|4[24-7]|5(?:(?:2\\d|51)\\d|4(?:[1-35-9]\\d|4[0-57-9]))|6[23])\\d{4})|(?:1[2-6]\\d|4(?:2[24-8]|3[2-7]|[46][2-6]|5[3-5])|5(?:[27][2-8]|3[2-68]|4[24-8]|5[23]|6[2-4]|8[24-7]|9[2-7])|6(?:[19]20|42[03-6]|(?:52|7[45])\\d)|7(?:[04][24-8]|[15][2-7]|22|3[2-4])|8(?:1[2-689]|2[2-8]|(?:[35]2|64)\\d))\\d{4}|25\\d{5,6}|(?:2[2-9]|6(?:1[2356]|[24][2-6]|3[24-6]|5[2-4]|6[2-8]|7[235-7]|8[245]|9[24])|8(?:3[24]|5[245]))\\d{4}", [6, 7, 8, 9]], ["(?:17[01]|9(?:2(?:[0-4]|[56]\\d\\d)|(?:3(?:[0-36]|4\\d)|(?:6\\d|8[89]|9[4-8])\\d|7(?:3|40|[5-9]\\d))\\d|4(?:(?:[0245]\\d|[1379])\\d|88)|5[0-6])\\d)\\d{4}|9[69]1\\d{6}|9(?:[68]\\d|9[089])\\d{5}", [7, 8, 9, 10]], ["80080(?:0[1-9]|2\\d)\\d{3}", [10]], 0, 0, 0, 0, 0, ["1333\\d{4}", [8]]]], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[12]2[1-3]\\d{5,6}|(?:(?:[12](?:1|27)|5[368])\\d\\d|7(?:0(?:[0-5]\\d|7[078]|80)|128))\\d{4}|[12](?:3[2-8]|4[2-68]|5[1-4689])\\d{6,7}"], ["92[0139]\\d{5}|(?:5[05]|6[069]|7[28]|8[0135689]|9[013-9])\\d{6}", [8]], 0, 0, 0, 0, 0, 0, ["712[0-79]\\d{4}|7(?:1[013-9]|[5-79]\\d)\\d{5}", [8]]]], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]], 0, 0, 0, 0, 0, 0, [["(?:28[2-9]|8(?:11|[2-57-9]\\d))\\d{5}", [8]], ["6800[0-79]\\d{3}|6(?:[235]\\d\\d|6(?:0[0-5]|[1-9]\\d)|8(?:0[1-9]|[14-8]\\d|2[5-9]|[39][0-4]))\\d{4}", [8]], ["0800\\d{3}", [7]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670", [["670(?:2(?:3[3-7]|56|8[4-8])|32[1-38]|4(?:33|8[348])|5(?:32|55|88)|6(?:64|70|82)|78[3589]|8[3-9]8|989)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:596(?:[03-7]\\d|1[05]|2[7-9]|8[0-39]|9[04-9])|80[6-9]\\d\\d|9(?:477[6-9]|767[4589]))\\d{4}"], ["(?:69[67]\\d\\d|7091[0-3])\\d{4}"], ["80[0-5]\\d{6}"], ["8[129]\\d{7}"], 0, 0, 0, 0, ["9(?:397[0-3]|477[0-5]|76(?:6\\d|7[0-367]))\\d{4}"]]], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]], 0, 0, 0, 0, 0, 0, [["(?:25[08]|35\\d|45[1-7])\\d{5}"], ["[2-4][0-46-9]\\d{6}"], ["800\\d{5}"]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664", [["6644(?:1[0-3]|91)\\d{4}"], ["664(?:3(?:49|9[1-6])|49[2-6])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]], 0, 0, 0, 0, 0, 0, [["20(?:3[1-4]|6[059])\\d{4}|2(?:0[19]|[1-357]\\d|60)\\d{5}"], ["(?:7(?:210|[79]\\d\\d)|9(?:[29]\\d\\d|69[67]|8(?:1[1-3]|89|97)))\\d{4}"], ["800(?:02|[3467]\\d)\\d{3}"], ["5(?:0(?:0(?:37|43)|(?:6\\d|70|9[0168])\\d)|[12]\\d0[1-5])\\d{3}"], 0, 0, ["501\\d{5}"], ["7117\\d{4}"], ["3550\\d{4}"]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:[0346-8]\\d|1[0-8])|4(?:[013568]\\d|2[4-8]|71|90)|54(?:[3-5]\\d|71)|6\\d\\d|8(?:14|3[129]))\\d{4}", [7, 8]], ["5(?:4(?:2[1-389]|7[1-9])|87[15-8])\\d{4}|(?:5(?:2[5-9]|4[3-689]|[57]\\d|8[0-689]|9[0-8])|7(?:0[0-6]|3[013]))\\d{5}", [8]], ["802\\d{7}|80[0-2]\\d{4}", [7, 10]], ["30\\d{5}", [7]], 0, 0, 0, ["219\\d{4}", [7]], ["3(?:20|9\\d)\\d{4}", [7]]], "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:0[0-4]|3[0-59])|6(?:[58][024689]|6[024-68]|7[02468]))\\d{4}", [7]], ["(?:46[46]|[79]\\d\\d)\\d{4}", [7]], ["800\\d{7}", [10]], ["900\\d{7}", [10]], 0, 0, ["4(?:0[01]|50)\\d{4}", [7]]], "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1[2-9]|2[12]\\d\\d)\\d{5}"], ["111\\d{6}|(?:31|77|[89][89])\\d{7}", [9]]]], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:0[01]|2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["(?:2(?:2\\d|3[1-35-8]|4[13-9]|7[1-689]|8[1-578]|9[467])|3(?:1[1-79]|[2458][1-9]|3\\d|7[1-8]|9[1-5])|4(?:1[1-57-9]|[267][1-9]|3[1-8]|[45]\\d|8[1-35-9]|9[2-689])|5(?:[56]\\d|88|9[1-79])|6(?:1[2-68]|[2-4][1-9]|5[1-36-9]|6[0-57-9]|7[1-7]|8[67]|9[4-8])|7(?:[1346][1-9]|[27]\\d|5[13-9]|8[1-69]|9[17])|8(?:1\\d|2[13-689]|3[1-6]|4[124-6]|6[1246-9]|7[0-378]|9[12479])|9(?:1[346-9]|2[1-4]|3[2-46-8]|5[1348]|[69]\\d|7[12]|8[1-8]))\\d{7}"], ["8(?:00|88)\\d{7}"], ["900\\d{7}"], ["500\\d{7}"], 0, 0, 0, 0, ["300\\d{7}"]], "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0", 0, 0, 0, 0, 0, [["427[01]\\d{4}|(?:3(?:2[0-36-9]|3[0-368]|4[0-278]|5[0-24-8]|6[0-467]|7[1246-9]|8\\d|9[0-57])\\d|4(?:2[0-689]|[3-79]\\d|8[1-35689])|5(?:2[0-589]|[3468]\\d|5[0-489]|7[1-9]|9[23])|6(?:2[2-9]|3[1357-9]|[46]\\d|5[0-6]|7[0-35-9]|85|9[015-8])|7(?:[2579]\\d|3[03-68]|4[0-8]|6[5-9]|8[0-35-9])|8(?:[24][2-8]|3[2-5]|5[2-7]|6[2-589]|7[2-578]|[89][2-9])|9(?:0[57]|13|[25-7]\\d|[3489][0-8]))\\d{5}", [8, 9]], ["1(?:1888[689]|4400|8(?:47|8[27])[0-4])\\d{4}|1(?:0(?:[23568]\\d|4[0-6]|7[016-9]|9[0-8])|1(?:[1-5]\\d\\d|6(?:0[5-9]|[1-9]\\d)|7(?:[0-4]\\d|5[0-7]))|(?:[269]\\d|[37][1-9]|4[235-9])\\d|5(?:31|9\\d\\d)|8(?:1[23]|[236]\\d|4[06]|5(?:46|[7-9])|7[016-9]|8[01]|9[0-8]))\\d{5}", [9, 10]], ["1[378]00\\d{6}", [10]], ["1600\\d{6}", [10]], 0, 0, 0, 0, ["15(?:4(?:6[0-4]\\d|8(?:0[125]|[17]\\d|21|3[01]|4[01589]|5[014]|6[02]))|6(?:32[0-6]|78\\d))\\d{4}", [10]]]], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["2(?:[1346]\\d|5[0-2]|[78][12]|93)\\d{5}", [8]], ["8[2-79]\\d{7}", [9]], ["800\\d{6}", [9]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["64426\\d{3}|6(?:1(?:2[2-7]|3[01378]|4[0-4])|254|32[0237]|4(?:27|41|5[25])|52[236-8]|626|7(?:2[2-4]|30))\\d{4,5}|6(?:1(?:(?:0\\d|2[0189]|3[24-69]|4[5-9])\\d|17|69|7[014])|2(?:17|5[0-36-8]|69|70)|3(?:17|2[14-689]|34|6[289]|7[01]|81)|4(?:17|2[0-2]|4[06]|5[0137]|69|7[01])|5(?:17|2[0459]|69|7[01])|6(?:17|25|38|42|69|7[01])|7(?:17|2[569]|3[13]|6[89]|7[01]))\\d{4}"], ["(?:60|8[1245])\\d{7}", [9]], ["80\\d{7}", [9]], ["8701\\d{5}", [9]], 0, 0, 0, 0, ["8(?:3\\d\\d|86)\\d{5}"]]], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[03-9]|3[0-5]|4[1-7]|88)\\d{4}"], ["(?:[579]\\d|8[0-79])\\d{4}"], ["050\\d{3}"], ["36\\d{4}"]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]], 0, 0, 0, 0, 0, 0, [["2(?:0(?:20|3[1-8]|4[13-5]|5[14]|6[14578]|7[1-578])|1(?:4[145]|5[14]|6[14-68]|7[169]|88))\\d{4}"], ["(?:23|7[0467]|[89]\\d)\\d{6}"], ["08\\d{6}"], ["09\\d{6}"]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1", 0, 0, [["(?:1(?:06|17|28|39)|3[0-2]\\d)\\d{3}"], ["(?:14|3[58])\\d{4}"]]], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:[1259]\\d|3[013-9]|4[1-8]|6[024-689]|7[1-79]|8[2-9])\\d{6}", [10]], ["(?:702[0-24-9]|819[01])\\d{6}|(?:7(?:0[13-9]|[12]\\d)|8(?:0[1-9]|1[0-8])|9(?:0[1-9]|1[1-6]))\\d{7}", [10]], ["800\\d{7,11}"], 0, 0, 0, ["700\\d{7,11}"]]], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]], 0, 0, 0, 0, 0, 0, [["2\\d{7}"], ["(?:5(?:5[0-7]|[78]\\d)|6(?:20|3[035]|4[045]|5[05]|77|8[1-9]|9[059])|(?:7[5-8]|8\\d)\\d)\\d{5}"], ["1800\\d{4}"]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:[035]\\d|1[13-578]|6[124-8]|7[24]|8[0-467])|2(?:[0346]\\d|2[2-46-9]|5[125]|9[479])|3(?:[03568]\\d|1[3-8]|2[01]|4[1-8])|4(?:[0356]\\d|1[1-368]|7[58]|8[15-8]|9[23579])|5(?:[0358]\\d|[19][1-9]|2[1-57-9]|4[13-8]|6[126]|7[0-3578])|7\\d\\d)\\d{6}", [9]], ["(?:6[1-58]|970\\d)\\d{7}", [9, 11]], ["800\\d{4,7}", [7, 8, 9, 10]], ["90[069]\\d{4,7}", [7, 8, 9, 10]], 0, 0, ["140(?:1[035]|2[0346]|3[03568]|4[0356]|5[0358]|8[458])|(?:140(?:1[16-8]|2[259]|3[124]|4[17-9]|5[124679]|7)|8[478]\\d{6})\\d", [5, 6, 9]], ["66\\d{7}", [9]], ["(?:85|91)\\d{7}", [9]]]], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]", [["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0-6]\\d|99[02-6])\\d{5}|(?:2[13-79]|3[135-8]|4[146-9]|5[135-7]|6[13-9]|7[15-9]|8[1-46-9]|9[1-7])[2-6]\\d{5}", [8]], ["9(?:00|6[0-3]|7[0-24-6]|8[0-24-68])\\d{7}", [10]], ["1(?:66001|800\\d\\d)\\d{5}", [11]]]], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]], 0, 0, 0, 0, 0, 0, [["444\\d{4}"], ["(?:222|55[3-9]|666|777|8\\d\\d|999)\\d{4}"]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, [["[47]\\d{3}", [4]], ["(?:[56]|888[1-9])\\d{3}"]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["240\\d{5}|(?:3[2-79]|[49][2-9]|6[235-9]|7[2-57-9])\\d{6}", [8]], ["2(?:[0-27-9]\\d|6)\\d{6,7}|2(?:1\\d|75)\\d{5}", [8, 9, 10]], ["508\\d{6,7}|80\\d{6,8}", [8, 9, 10]], ["(?:1[13-57-9]\\d{5}|50(?:0[08]|30|66|77|88))\\d{3}|90\\d{6,8}", [7, 8, 9, 10]], ["70\\d{7}", [9]], 0, ["8(?:1[16-9]|22|3\\d|4[045]|5[459]|6[235-9]|7[0-3579]|90)\\d{2,7}"]], "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]], 0, 0, 0, 0, 0, 0, [["2[1-6]\\d{6}", [8]], ["1505\\d{4}|(?:7(?:[125-9]\\d|41)|9(?:0[1-9]|[1-9]\\d))\\d{5}", [8]], ["8007\\d{4,5}|(?:500|800[05])\\d{4}"], ["900\\d{5}", [8]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["(?:1(?:0\\d|1[0479]|2[37]|3[0137]|4[17]|5[05]|6[058]|7[0167]|8[2358]|9[1389])|2(?:[0235-79]\\d|1[0-7]|4[013-9]|8[02-9])|3(?:[047-9]\\d|1[0-8]|2[0-5]|33|5[0-35]|6[068])|4(?:00|3[0-579]|4\\d|7[0-57-9])|5(?:[01]\\d|2[0-7]|[56]0|79)|7(?:0[09]|2[0-26-8]|3[03]|4[04]|5[05-9]|6[0156]|7[0-24-9]|8[4-9]|90)|8(?:09|2[89]|3\\d|4[0-24-689]|5[014]|8[02])|9(?:0[5-9]|1[0135-8]|2[036-9]|3[35-79]|40|5[0457-9]|6[05-9]|7[04-9]|8[35-8]|9\\d))\\d{4}", [7]], ["(?:1[16]1|21[89]|6\\d{3}|8(?:1[01]|7[23]))\\d{4}", [7, 8]], ["800\\d{4,5}|(?:00800|800\\d)\\d{6}"], ["(?:8(?:22|55|60|7[78]|86)|9(?:00|81))\\d{4}", [7]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:(?:4[34]|5[14])[0-8]|687)\\d|7(?:173|(?:3[0-8]|55)\\d)|8(?:10[05689]|6(?:0[06-9]|1[6-9]|29)|7(?:0[0569]|[56]0)))\\d{4}|(?:1[0-8]|4[12]|5[236]|6[1-7]|7[246]|8[2-4])\\d{6}", [8]], ["9\\d{8}", [9]], ["800\\d{5}", [8]], ["805\\d{5}", [8]], ["80[24]\\d{5}", [8]], 0, 0, 0, 0, ["801\\d{5}", [8]]], "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["4(?:0[4-689]|9[4-68])\\d{5}", [8]], ["8[7-9]\\d{6}", [8]], ["80[0-5]\\d{6}", [9]], 0, 0, 0, ["44\\d{4}", [6]], 0, ["499\\d{5}", [8]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, [["(?:(?:3[0-2]|4[257]|5[34]|9[78])\\d|64[1-9]|85[02-46-9])\\d{4}", [7]], ["(?:7\\d|8[1-48])\\d{6}", [8]], ["180\\d{4}", [7]], 0, 0, 0, 0, ["27[01]\\d{4}", [7]], ["2(?:0[0-57]|7[568])\\d{4}", [7]]], "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:(?:2[3-8]|3[2-68]|4[2-9]|5[2-6]|6[2-58]|7[24578])\\d{3}|88(?:22\\d\\d|42))\\d{4}|(?:2|8[2-8]\\d\\d)\\d{5}", [6, 8, 9, 10]], ["(?:8(?:1[37]|9[5-8])|9(?:0[5-9]|1[0-24-9]|[235-7]\\d|4[2-9]|8[135-9]|9[1-9]))\\d{7}", [10]], ["1800\\d{7,9}", [11, 12, 13]]]], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:(?:21|42)[2-9]|58[126])\\d{7}|(?:2[25]|4[0146-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]\\d{6,7}|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8]))[2-9]\\d{5,6}", [9, 10]], ["3(?:[0-247]\\d|3[0-79]|55|64)\\d{7}", [10]], ["800\\d{5}(?:\\d{3})?", [8, 11]], ["900\\d{5}", [8]], ["122\\d{6}", [9]], 0, ["(?:2(?:[125]|3[2358]|4[2-4]|9[2-8])|4(?:[0-246-9]|5[3479])|5(?:[1-35-7]|4[2-467])|6(?:0[468]|[1-8])|7(?:[14]|2[236])|8(?:[16]|2[2-689]|3[23578]|4[3478]|5[2356])|9(?:1|22|3[27-9]|4[2-6]|6[3569]|9[2-7]))111\\d{6}", [11, 12]]]], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]], 0, 0, 0, 0, 0, 0, [["47\\d{7}|(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])(?:[02-9]\\d{6}|1(?:[0-8]\\d{5}|9\\d{3}(?:\\d{2})?))", [7, 9]], ["2131[89]\\d{4}|21(?:1[013-5]|2\\d|3[2-9])\\d{5}|(?:45|5[0137]|6[069]|7[2389]|88)\\d{7}", [9]], ["800\\d{6,7}", [9, 10]], ["70[01346-8]\\d{6}", [9]], 0, 0, ["804\\d{6}", [9]], ["64\\d{4,7}", [6, 7, 8, 9]], ["39\\d{7}", [9]], ["801\\d{6}", [9]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:4[1-35-9]|5[0-47-9]|80[6-9]\\d\\d)\\d{4}"], ["(?:4[02-489]|5[02-9]|708(?:4[0-5]|5[0-6]))\\d{4}"], ["80[0-5]\\d{6}", [9]], ["8[129]\\d{7}", [9]]]], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939", [["(?:787|939)[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:22[2-47-9]|42[45]|82[014-68]|92[3569])\\d{5}", [8]], ["5[69]\\d{7}", [9]], ["1800\\d{6}", [10]], 0, 0, 0, 0, 0, 0, ["1700\\d{6}", [10]]]], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]], 0, 0, 0, 0, 0, 0, [["2(?:[12]\\d|3[1-689]|4[1-59]|[57][1-9]|6[1-35689]|8[1-69]|9[1256])\\d{6}"], ["6(?:[06]92(?:30|9\\d)|[35]92(?:[049]\\d|3[034]))\\d{3}|(?:(?:16|6[0356])93|9(?:[1-36]\\d\\d|480))\\d{5}"], ["80[02]\\d{6}"], ["(?:6(?:0[178]|4[68])\\d|76(?:0[1-57]|1[2-47]|2[237]))\\d{5}"], ["884[0-4689]\\d{5}"], ["600\\d{6}|6[06]92(?:0\\d|3[349]|49)\\d{3}"], ["70(?:38[01]|596|(?:7\\d|8[17])\\d)\\d{4}"], ["6(?:222\\d|89(?:00|88|99))\\d{4}"], ["30\\d{7}"], ["80(?:8\\d|9[1579])\\d{5}"]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2(?:55|77)|345|488|5(?:35|44|87)|6(?:22|54|79)|7(?:33|47)|8(?:24|55|76)|900)\\d{4}"], ["(?:(?:46|83)[0-5]|(?:6[2-4689]|78)0)\\d{4}|(?:45|77|88)\\d{5}"]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, [["(?:[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36])\\d{5,7}|(?:2(?:2[4-68]|[4-68]\\d|7[15]|9[1-5])|3(?:18|3[167]|4[2357]|51|[67]\\d)|4(?:3[12]|5[13]|9[1-47])|5(?:[1-4]\\d|5[02-4])|6(?:3[1-3]|44|7[1-8])|7(?:4[0-4]|5\\d|6[1-578]|75|8[0-8])|858)\\d{5,6}", [7, 8, 9]], ["9(?:51|6[129]|7[1-6]|8[1-7]|9[1-5])\\d{6}", [9]], ["9800\\d{5,7}", [9, 10, 11]], 0, 0, 0, ["[2-9]0\\d{4,7}", [6, 7, 8, 9]], 0, ["8700[0-4]\\d{4}", [9]]]], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]], 0, 0, 0, 0, 0, 0, [["4(?:1111|2022)\\d{3}|4(?:[04]\\d\\d|14[0-6]|999)\\d{4}", [8]], ["[35-7]\\d{7}", [8]], ["800\\d{4}|(?:0080[01]|800)\\d{6}", [7, 9, 11]], 0, 0, 0, 0, ["2[136]\\d{5}", [7]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["[23][13-6]\\d{7}|(?:2(?:19\\d|[3-6]\\d9)|31\\d\\d)\\d\\d"], ["(?:630|702)0\\d{5}|(?:6(?:00|2\\d)|7(?:0[013-9]|1[0-3]|[2-7]\\d|8[03-8]|9[0-39]))\\d{6}", [9]], ["800\\d{6}", [9]], ["90[0136]\\d{6}", [9]], 0, 0, ["(?:37\\d|80[578])\\d{6}", [9]], 0, 0, ["801\\d{6}", [9]]], 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:11[1-9]\\d|(?:2[389]|39)(?:0[2-9]|[2-9]\\d))\\d{3,8}|(?:1[02-9]|2[0-24-7]|3[0-8])[2-9]\\d{4,9}", [7, 8, 9, 10, 11, 12]], ["6(?:[0-689]|7\\d)\\d{6,7}", [8, 9, 10]], ["800\\d{3,9}"], ["(?:78\\d|90[0169])\\d{3,7}", [6, 7, 8, 9, 10]], 0, 0, ["7[06]\\d{4,10}"]]], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:06|2[23568]\\d)\\d{6}"], ["7[237-9]\\d{7}", [9]], ["800\\d{6}", [9]], ["900\\d{6}", [9]]]], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, 0, 0, 0, 0, [["1(?:1\\d|2[24-8]|3[35-8]|4[3-68]|6[2-5]|7[235-7])\\d{6}", [9]], ["579[01]\\d{5}|5(?:[013-689]\\d|7[0-8])\\d{6}", [9]], ["800\\d{7}", [10]], ["925\\d{6}", [9]], 0, 0, 0, 0, 0, ["920\\d{6}", [9]]]], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]], 0, 0, 0, 0, 0, 0, [["(?:1[4-79]|[23]\\d|4[0-2]|5[03]|6[0-37])\\d{3}", [5]], ["48\\d{3}|(?:(?:6[89]|7[1-9]|8[4-9])\\d|9(?:1[2-9]|2[013-9]|3[0-2]|[46]\\d|5[0-46-9]|7[0-689]|8[0-79]|9[0-8]))\\d{4}"], ["1[38]\\d{3}", [5]], 0, 0, 0, 0, 0, ["5[12]\\d{3}", [5]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, [["4[2-46]\\d{5}"], ["2[125-8]\\d{5}"], ["800[08]\\d{3}"], ["85\\d{5}"], 0, 0, 0, 0, ["971\\d{4}|(?:64|95)\\d{5}"]], "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1(?:5\\d|8[35-7])\\d{6}"], ["(?:1[0-2]|9[0-3569])\\d{7}"]]], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0", 0, 0, 0, 0, 0, [["(?:(?:[12][136]|3[356]|4[0246]|6[03]|8\\d)\\d|90[1-9])\\d{4,6}|(?:1(?:2[0-35]|4[0-4]|5[0-25-9]|7[13-6]|[89]\\d)|2(?:2[0-7]|4[0136-8]|5[0138]|7[018]|8[01]|9[0-57])|3(?:0[0-4]|1\\d|2[0-25]|4[056]|7[0-2]|8[0-3]|9[023])|4(?:1[013-8]|3[0135]|5[14-79]|7[0-246-9]|8[0156]|9[0-689])|5(?:0[0-6]|[15][0-5]|2[0-68]|3[0-4]|4\\d|6[03-5]|7[013]|8[0-79]|9[01])|6(?:1[1-3]|2[0-4]|4[02-57]|5[0-37]|6[0-3]|7[0-2]|8[0247]|9[0-356])|9(?:1[0-68]|2\\d|3[02-5]|4[0-3]|5[0-4]|[68][01]|7[0135-8]))\\d{5,6}", [7, 8, 9]], ["7[02369]\\d{7}", [9]], ["20\\d{4,7}", [6, 7, 8, 9]], ["649\\d{6}|99[1-59]\\d{4}(?:\\d{3})?|9(?:00|39|44)[1-8]\\d{3,6}", [7, 8, 9, 10]], ["75[1-8]\\d{6}", [9]], ["(?:25[245]|67[3-68])\\d{9}", [12]], ["10[1-8]\\d{6}", [9]], ["74[02-9]\\d{6}", [9]], 0, ["77[0-7]\\d{6}", [9]]]], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [["662[0-24-9]\\d{4}|6(?:[0-578]\\d|6[013-57-9]|9[0-35-9])\\d{5}", [8]], ["898[02-8]\\d{4}|(?:8(?:0[1-9]|[1-8]\\d|9[0-7])|9[0-8]\\d)\\d{5}", [8]], ["(?:18|8)00\\d{7}", [10, 11]], ["1900\\d{7}", [11]], 0, 0, ["7000\\d{7}", [11]], 0, ["(?:3[12]\\d|666)\\d{5}", [8]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]", [["2(?:[0-57-9]\\d|6[4-9])\\d\\d"], ["[56]\\d{4}", [5]], 0, 0, 0, 0, 0, 0, ["262\\d\\d", [5]]]], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["(?:[1-357][2-8]|4[24-8])\\d{6}", [8]], ["65(?:[178]\\d|5[56]|6[01])\\d{4}|(?:[37][01]|4[0139]|51|6[489])\\d{6}", [8]], ["80\\d{4,6}", [6, 7, 8]], ["89[1-3]\\d{2,5}|90\\d{4,6}"], 0, 0, 0, 0, ["(?:59\\d\\d|8(?:1(?:[67]\\d|8[0-589])|2(?:0\\d|2[0-37-9]|8[0-2489])|3[389]\\d))\\d{4}", [8]]], "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79", [["79\\d{6}", [8]], ["(?:4[015-8]|9\\d)\\d{6}", [8]], ["80[01]\\d{5}", [8]], ["82[09]\\d{5}", [8]], ["880\\d{5}", [8]], ["81[23]\\d{5}", [8]], ["(?:0[235-9]|81(?:0(?:0[7-9]|1\\d)|5\\d\\d))\\d{3}"], 0, ["85[0-5]\\d{5}", [8]], ["810(?:0[0-6]|[2-8]\\d)\\d{3}", [8]]]], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:16|[2-9]\\d{3})|(?:(?:[3-5][1-8]\\d|819)\\d|601[1-5])\\d)\\d{4}|(?:2|[3-5][1-8])1[67]\\d{3}|[3-5][1-8]16\\d\\d"], ["909[1-9]\\d{5}|9(?:0[1-8]|1[0-24-9]|4[03-57-9]|5\\d)\\d{6}", [9]], ["800\\d{6}", [9]], ["9(?:00|[78]\\d)\\d{6}", [9]], 0, 0, ["96\\d{7}", [9]], ["9090\\d{3}", [7]], ["6(?:02|5[0-4]|9[0-6])\\d{6}", [9]], ["8[5-9]\\d{7}", [9]]]], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, [["22[2-4][2-9]\\d{4}"], ["(?:25|3[0-5]|66|7[1-9]|8[08]|9[09])\\d{6}"]]], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1", 0, 0, [["0549(?:8[0157-9]|9\\d)\\d{4}", [10]], ["6[16]\\d{6}", [8]], 0, ["7[178]\\d{6}", [8]], 0, 0, 0, 0, ["5[158]\\d{6}", [8]]]], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]], 0, 0, 0, 0, 0, 0, [["3(?:0(?:1[0-2]|80)|282|3(?:8[1-9]|9[3-9])|611)\\d{5}"], ["7(?:(?:[06-8]\\d|[19]0|21)\\d|5(?:0[01]|[19]0|2[25]|3[356]|[4-7]\\d|8[35]))\\d{5}"], ["800\\d{6}"], ["88[4689]\\d{6}"], 0, 0, 0, 0, ["(?:3(?:392|9[01]\\d)\\d|93(?:3[13]0|929))\\d{4}"], ["81[02468]\\d{6}"]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0", 0, 0, 0, 0, 0, [["(?:1\\d|2[0-79]|3[0-46-8]|4[0-7]|5[57-9])\\d{5}|(?:[134]\\d|8[125])\\d{4}", [6, 7]], ["(?:(?:15|(?:3[59]|4[89]|6\\d|7[679]|8[08])\\d|9(?:0\\d|[2-9]))\\d|2(?:4\\d|8))\\d{5}|(?:[67]\\d\\d|904)\\d{5}", [7, 8, 9]]]], SR: ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-3]|3[0-7]|4\\d|5[2-58])\\d{4}", [6]], ["(?:6[08]|7[124-7]|8[1-9])\\d{5}", [7]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], 0, 0, 0, 0, ["56\\d{4}", [6]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["1[89]\\d{7}"], ["(?:12|9[1257-9])\\d{7}"]]], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]], 0, 0, 0, 0, 0, 0, [["22\\d{5}"], ["900[5-9]\\d{3}|9(?:0[1-9]|[89]\\d)\\d{4}"]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, [["2(?:79(?:0[0347-9]|[1-9]\\d)|89(?:0[024589]|[1-9]\\d))\\d{3}|2(?:[1-69]\\d|[78][0-8])\\d{5}", [8]], ["[67]\\d{7}", [8]], ["800\\d{8}|80[01]\\d{4}", [7, 11]], ["900\\d{4}(?:\\d{4})?", [7, 11]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721", [["7215(?:4[2-8]|8[239]|9[056])\\d{4}"], ["7215(?:1[02]|2\\d|5[034679]|8[014-8])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["21\\d{6,7}|(?:1(?:[14]\\d|[2356])|2[235]|3(?:[13]\\d|4)|4[134]|5[1-3])\\d{6}"], ["(?:50|9[1-9])\\d{7}", [9]]]], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]], 0, 0, 0, 0, 0, 0, [["[23][2-5]\\d{6}", [8]], ["7[5-9]\\d{6}", [8]], ["0800\\d{4}", [8]], ["900\\d{6}", [9]], 0, 0, 0, 0, ["70\\d{6}", [8]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8", [["8\\d{3}"]]], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649", [["649(?:266|712|9(?:4\\d|50))\\d{4}"], ["649(?:2(?:3[129]|4[1-79])|3\\d\\d|4[34][1-3])\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["649(?:71[01]|966)\\d{4}"]]], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, [["22(?:[37-9]0|5[0-5]|6[89])\\d{4}"], ["(?:30|[69]\\d|77|8[56])\\d{6}"]], "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]], 0, 0, 0, 0, 0, 0, [["2(?:2[2-7]|3[23]|4[45]|55|6[67]|77)\\d{5}"], ["(?:7[0-29]|9[0-36-9])\\d{6}"]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0", 0, 0, 0, 0, 0, [["(?:1[0689]|2\\d|3[2-9]|4[2-5]|5[2-6]|7[3-7])\\d{6}", [8]], ["67(?:1[0-8]|2[4-7])\\d{5}|(?:14|6[1-6]|[89]\\d)\\d{7}", [9]], ["(?:001800\\d|1800)\\d{6}", [10, 13]], ["1900\\d{6}", [10]], 0, 0, 0, 0, ["6[08]\\d{7}", [9]]]], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:3(?:1[3-5]|2[245]|3[12]|4[24-7]|5[25]|72)|4(?:46|74|87))\\d{6}"], ["(?:33[03-9]|4(?:1[18]|4[02-479])|81[1-9])\\d{6}|(?:[09]\\d|1[0-27-9]|2[0-27]|[34]0|5[05]|7[01578]|8[078])\\d{7}"]], "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7], 0, 0, 0, 0, 0, 0, 0, [["(?:2[2-4]|[34]\\d)\\d{2,5}"], ["7[2-4]\\d{2,5}"]]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["(?:2[1-5]|3[1-9]|4[1-4])\\d{5}", [7]], ["7[2-8]\\d{6}", [8]], ["80\\d{5}", [7]], ["90\\d{5}", [7]], ["70\\d{5}", [7]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, [["(?:1(?:2\\d|3[1-9])|2(?:22|4[0-35-8])|3(?:22|4[03-9])|4(?:22|3[128]|4\\d|6[15])|5(?:22|5[7-9]|6[014-689]))\\d{5}"], ["(?:6\\d|71)\\d{6}"]], "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]], 0, 0, 0, 0, 0, 0, [["81200\\d{3}|(?:3[0-2]|7\\d)\\d{6}"], ["3(?:001|[12]40)\\d{4}|(?:(?:[259]\\d|4[0-8])\\d|3(?:1[1-35]|6[0-4]|91))\\d{5}"], ["8010\\d{4}"], ["88\\d{6}"], 0, 0, 0, 0, 0, ["8[12]10\\d{4}"]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:2\\d|3[0-8]|4[0-4]|50|6[09]|7[0-24-69]|8[05])\\d{3}", [5]], ["(?:5(?:4[0-5]|5[4-6])|6(?:[09]\\d|3[02]|8[15-9])|(?:7\\d|8[46-9])\\d|999)\\d{4}", [7]], ["0800\\d{3}", [7]], 0, 0, 0, 0, 0, ["55[0-37-9]\\d{4}", [7]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["(?:2(?:[13][26]|[28][2468]|[45][268]|[67][246])|3(?:[13][28]|[24-6][2468]|[78][02468]|92)|4(?:[16][246]|[23578][2468]|4[26]))\\d{7}", [10]], ["561(?:011|61\\d)\\d{4}|5(?:0[15-7]|1[06]|24|[34]\\d|5[1-59]|9[46])\\d{7}", [10]], ["8(?:00\\d{7}(?:\\d{2,3})?|11\\d{7})", [10, 12, 13]], ["(?:8[89]8|900)\\d{7}", [10]], ["592(?:21[12]|461)\\d{4}", [10]], 0, ["444\\d{4}", [7]], ["512\\d{7}", [10]], ["850\\d{7}", [10]]]], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868", [["868(?:2(?:01|1[5-9]|[23]\\d|4[0-2])|6(?:0[7-9]|1[02-8]|2[1-9]|[3-69]\\d|7[0-79])|82[124])\\d{4}"], ["868(?:(?:2[5-9]|3\\d)\\d|4(?:3[0-6]|[6-9]\\d)|6(?:20|78|8\\d)|7(?:0[1-9]|1[02-9]|[2-9]\\d))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], ["868619\\d{4}"]]], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["2[02-9]\\d{3}", [5]], ["(?:7[01]\\d|90)\\d{4}", [6, 7]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2[2-8]\\d|370|55[01]|7[1-9])\\d{6}|4(?:(?:0(?:0[1-9]|[2-48]\\d)|1[023]\\d)\\d{4,5}|(?:[239]\\d\\d|4(?:0[56]|12|49))\\d{5})|6(?:[01]\\d{7}|4(?:0[56]|12|24|4[09])\\d{4,5})|8(?:(?:2(?:3\\d|4[0-269]|[578]0|66)|36[24-9]|90\\d\\d)\\d{4}|4(?:0[56]|12|24|4[09])\\d{4,5})|(?:2(?:2(?:0\\d\\d|4(?:0[68]|[249]0|3[0-467]|5[0-25-9]|6[0235689]))|(?:3(?:[09]\\d|1[0-4])|(?:4\\d|5[0-49]|6[0-29]|7[0-5])\\d)\\d)|(?:(?:3[2-9]|5[2-8]|6[0-35-79]|8[7-9])\\d\\d|4(?:2(?:[089]\\d|7[1-9])|(?:3[0-4]|[78]\\d|9[01])\\d))\\d)\\d{3}", [8, 9]], ["(?:40001[0-2]|9[0-8]\\d{4})\\d{3}", [9]], ["80[0-79]\\d{6}|800\\d{5}", [8, 9]], ["20(?:[013-9]\\d\\d|2)\\d{4}", [7, 9]], ["99\\d{7}", [9]], 0, ["50[0-46-9]\\d{6}", [9]], 0, ["7010(?:[0-2679]\\d|3[0-7]|8[0-5])\\d{5}|70\\d{8}", [10, 11]]], 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["2[2-8]\\d{7}"], ["(?:6[125-9]|7[13-9])\\d{7}"], ["80[08]\\d{6}"], ["90\\d{7}"], 0, 0, 0, 0, ["41\\d{7}"], ["8(?:40|6[01])\\d{6}"]]], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:3[1-8]|4[13-8]|5[1-7]|6[12459])\\d{7}", [9]], ["790\\d{6}|(?:39|50|6[36-8]|7[1-357]|9[1-9])\\d{7}", [9]], ["800[1-8]\\d{5,6}"], ["900[239]\\d{5,6}"], 0, 0, 0, 0, ["89[1-579]\\d{6}", [9]]], "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["20(?:(?:240|30[67])\\d|6(?:00[0-2]|30[0-4]))\\d{3}|(?:20(?:[017]\\d|2[5-9]|3[1-4]|5[0-4]|6[15-9])|[34]\\d{3})\\d{5}"], ["72[48]0\\d{5}|7(?:[014-8]\\d|2[067]|36|9[0-289])\\d{6}"], ["800[1-3]\\d{5}"], ["90[1-3]\\d{6}"]]], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, [["(?:1(?:770|9(?:20|[89]7))|(?:2\\d|4[2-7])\\d\\d)\\d{4}", [8]], ["9[1-9]\\d{6}", [8]], ["0004\\d{2,9}|(?:405|80[05])\\d{4}", [6, 7, 8, 9, 10, 11, 12, 13]], ["90[0-8]\\d{4}", [7]], 0, 0, ["21\\d{2,3}", [4, 5]]], "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:55\\d\\d|6(?:1(?:22|3[124]|4[1-4]|5[1-3578]|64)|2(?:22|3[0-57-9]|41)|5(?:22|3[3-7]|5[024-8])|[69]\\d\\d|7(?:[23]\\d|7[69]))|7(?:0(?:5[4-9]|6[0146]|7[124-6]|9[135-8])|[168]\\d\\d|2(?:22|3[13-57-9]|4[1-3579]|5[14])|3(?:2\\d|3[1578]|4[1-35-7]|5[1-57]|61)|4(?:2\\d|3[1-579]|7[1-79])|5(?:22|5[1-9]|6[1457])|9(?:22|5[1-9])))\\d{5}"], ["(?:(?:[25]0|33|8[78]|9[0-57-9])\\d{3}|6(?:1(?:2(?:2[01]|98)|35[0-4]|50\\d|61[23]|7(?:[01][017]|4\\d|55|9[5-9]))|2(?:(?:11|7\\d)\\d|2(?:[12]1|9[01379])|5(?:[126]\\d|3[0-4]))|5(?:19[01]|2(?:27|9[26])|(?:30|59|7\\d)\\d)|6(?:2(?:1[5-9]|2[0367]|38|41|52|60)|(?:3[79]|9[0-3])\\d|4(?:56|83)|7(?:[07]\\d|1[017]|3[07]|4[047]|5[057]|67|8[0178]|9[79]))|7(?:2(?:24|3[237]|4[5-9]|7[15-8])|5(?:7[12]|8[0589])|7(?:0\\d|[39][07])|9(?:0\\d|7[079])))|7(?:[07]\\d{3}|2(?:2(?:2[79]|95)|3(?:2[5-9]|6[0-6])|57\\d|7(?:0\\d|1[17]|2[27]|3[37]|44|5[057]|66|88))|3(?:2(?:1[0-6]|21|3[469]|7[159])|(?:33|9[4-6])\\d|5(?:0[0-4]|5[579]|9\\d)|7(?:[0-3579]\\d|4[0467]|6[67]|8[078]))|4(?:2(?:29|5[0257]|6[0-7]|7[1-57])|5(?:1[0-4]|8\\d|9[5-9])|7(?:0\\d|1[024589]|2[0-27]|3[0137]|[46][07]|5[01]|7[5-9]|9[079])|9(?:7[015-9]|[89]\\d))|5(?:112|2(?:0\\d|2[29]|[49]4)|3[1568]\\d|52[6-9]|7(?:0[01578]|1[017]|[23]7|4[047]|[5-7]\\d|8[78]|9[079]))|9(?:22[128]|3(?:2[0-4]|7\\d)|57[02569]|7(?:2[05-9]|3[37]|4\\d|60|7[2579]|87|9[07]))))\\d{4}"]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698", [["06698\\d{1,6}", [6, 7, 8, 9, 10, 11]], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784", [["784(?:266|3(?:6[6-9]|7\\d|8[0-6])|4(?:38|5[0-36-8]|8[0-8])|5(?:55|7[0-2]|93)|638|784)\\d{4}"], ["784(?:4(?:3[0-5]|5[45]|89|9[0-8])|5(?:2[6-9]|3[0-4])|720)\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["78451[0-2]\\d{4}"]]], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:12|3[457-9]|[467]\\d|[58][1-9]|9[1-6])|[4-6]00)\\d{7}"], ["4(?:1[24-8]|2[246])\\d{7}"], ["800\\d{7}"], ["90[01]\\d{7}"], 0, 0, ["501\\d{7}"]]], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284", [["284(?:229|4(?:22|9[45])|774|8(?:52|6[459]))\\d{4}"], ["284(?:245|3(?:0[0-3]|4[0-7]|68|9[34])|4(?:4[0-6]|68|9[69])|5(?:4[0-7]|68|9[69]))\\d{4}"], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340", [["340(?:2(?:0\\d|10|2[06-8]|4[49]|77)|3(?:32|44)|4(?:2[23]|44|7[34]|89)|5(?:1[34]|55)|6(?:2[56]|4[23]|77|9[023])|7(?:1[2-57-9]|2[57]|7\\d)|884|998)\\d{4}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0", 0, 0, 0, 0, 0, [["2(?:0[3-9]|1[0-689]|2[0-25-9]|[38][2-9]|4[2-8]|5[124-9]|6[0-39]|7[0-7]|9[0-4679])\\d{7}", [10]], ["(?:5(?:2[238]|59)|89[6-9]|99[013-9])\\d{6}|(?:3\\d|5[1689]|7[06-9]|8[1-8]|9[0-8])\\d{7}", [9]], ["1800\\d{4,6}|12(?:0[13]|28)\\d{4}", [8, 9, 10]], ["1900\\d{4,6}", [8, 9, 10]], 0, 0, ["(?:[17]99|80\\d)\\d{4}|69\\d{5,6}", [7, 8]], 0, ["672\\d{6}", [9]]]], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]], 0, 0, 0, 0, 0, 0, [["(?:38[0-8]|48[4-9])\\d\\d|(?:2[02-9]|3[4-7]|88)\\d{3}", [5]], ["(?:[58]\\d|7[013-7])\\d{5}", [7]], ["81[18]\\d\\d", [5]], 0, 0, 0, ["(?:3[03]|900\\d)\\d{3}"], 0, ["9(?:0[1-9]|1[01])\\d{4}", [7]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]], 0, 0, 0, 0, 0, 0, [["72\\d{4}", [6]], ["(?:72|8[23])\\d{4}", [6]], ["80[0-5]\\d{6}", [9]], 0, 0, ["[48]0\\d{4}", [6]], 0, 0, ["9[23]\\d{4}", [6]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]], 0, 0, 0, 0, 0, 0, [["6[1-9]\\d{3}|(?:[2-5]|60)\\d{4}", [5, 6]], ["(?:7[1-35-8]|8(?:[3-7]|9\\d{3}))\\d{5}", [7, 10]], ["800\\d{3}", [6]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0", 0, 0, 0, 0, 0, [["38\\d{6,10}|(?:2[89]|39)(?:0\\d{5,6}|[1-9]\\d{5})"], ["4[3-9]\\d{6}", [8]], ["800\\d{5}", [8]], ["900\\d{5}", [8]]]], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, [["78[0-7]\\d{4}|17\\d{6}|(?:[12][2-68]|3[2358]|4[2-58]|5[2-6]|6[3-58]|7[24-6])\\d{5}", [7, 8]], ["7[01378]\\d{7}", [9]]]], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:2(?:0330|4302)|52087)0\\d{3}|(?:1[0-8]|2[1-378]|3[1-69]|4\\d|5[1346-8])\\d{7}", [9]], ["(?:1(?:3492[0-25]|4495[0235]|549(?:20|5[01]))|4[34]492[01])\\d{3}|8[1-4]\\d{3,7}|(?:2[27]|47|54)4950\\d{3}|(?:1(?:049[2-4]|9[12]\\d\\d)|(?:50[0-2]|6\\d\\d|7(?:[0-46-9]\\d|5[0-4]))\\d\\d|8(?:5\\d{3}|7(?:08[67]|158|28[5-9]|310)))\\d{4}|(?:1[6-8]|28|3[2-69]|4[025689]|5[36-8])4920\\d{3}|(?:12|[2-5]1)492\\d{4}", [5, 6, 7, 8, 9]], ["80\\d{7}", [9]], ["(?:86[2-9]|9[0-2]\\d)\\d{6}", [9]], 0, 0, ["861\\d{6,7}", [9, 10]], 0, ["87(?:08[0-589]|15[0-79]|28[0-4]|31[1-9])\\d{4}|87(?:[02][0-79]|1[0-46-9]|3[02-9]|[4-9]\\d)\\d{5}", [9]], ["860\\d{6}", [9]]]], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["21[1-8]\\d{6}"], ["(?:[59][5-8]|7[5-9])\\d{7}"], ["800\\d{6}"], 0, 0, 0, 0, 0, ["63\\d{7}"]]], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:(?:3\\d|9)\\d|[4-8])|2(?:(?:(?:0(?:2[014]|5)|(?:2[0157]|31|84|9)\\d\\d|[56](?:[14]\\d\\d|20)|7(?:[089]|2[03]|[35]\\d\\d))\\d|4(?:2\\d\\d|8))\\d|1(?:2|[39]\\d{4}))|3(?:(?:123|(?:29\\d|92)\\d)\\d\\d|7(?:[19]|[56]\\d))|5(?:0|1[2-478]|26|[37]2|4(?:2\\d{3}|83)|5(?:25\\d\\d|[78])|[689]\\d)|6(?:(?:[16-8]21|28|52[013])\\d\\d|[39])|8(?:[1349]28|523)\\d\\d)\\d{3}|(?:4\\d\\d|9[2-9])\\d{4,5}|(?:(?:2(?:(?:(?:0|8[146])\\d|7[1-7])\\d|2(?:[278]\\d|92)|58(?:2\\d|3))|3(?:[26]|9\\d{3})|5(?:4\\d|5)\\d\\d)\\d|6(?:(?:(?:[0-246]|[78]\\d)\\d|37)\\d|5[2-8]))\\d\\d|(?:2(?:[569]\\d|8[2-57-9])|3(?:[013-59]\\d|8[37])|6[89]8)\\d{3}"], ["7(?:[1278]\\d|3[1-9])\\d{6}", [9]], ["80(?:[01]\\d|20|8[0-8])\\d{3}", [7]], 0, 0, 0, 0, 0, ["86(?:1[12]|22|30|44|55|77|8[368])\\d{6}", [10]]]] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function s0(e, t) {
  var d = Array.prototype.slice.call(t);
  return d.push(c0), e.apply(this, d);
}
function td(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var d = e[0].split("."), a = t[0].split("."), n = 0; n < 3; n++) {
    var r = Number(d[n]), o = Number(a[n]);
    if (r > o) return 1;
    if (o > r) return -1;
    if (!isNaN(r) && isNaN(o)) return 1;
    if (isNaN(r) && !isNaN(o)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
var u0 = {}.constructor;
function ve(e) {
  return e != null && e.constructor === u0;
}
function Pe(e) {
  "@babel/helpers - typeof";
  return Pe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Pe(e);
}
function gt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function m0(e, t) {
  for (var d = 0; d < t.length; d++) {
    var a = t[d];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, g0(a.key), a);
  }
}
function $t(e, t, d) {
  return t && m0(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function g0(e) {
  var t = $0(e, "string");
  return Pe(t) == "symbol" ? t : t + "";
}
function $0(e, t) {
  if (Pe(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, t);
    if (Pe(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var y0 = "1.2.0", E0 = "1.7.35", dd = " ext. ", N0 = /^\d+$/, k = /* @__PURE__ */ (function() {
  function e(t) {
    gt(this, e), Jd(t), this.metadata = t, qd.call(this, t);
  }
  return $t(e, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(d) {
        return d !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(d) {
      return this.metadata.countries[d];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(d) {
      return this.getCountryMetadata(d) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(d) {
      if (this.getCountryCodesForCallingCode(d))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[d])
          return !0;
      } else {
        var a = this.countryCallingCodes()[d];
        if (a && a.length === 1 && a[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(d) {
      return this.nonGeographic() ? !!this.nonGeographic()[d] : !this.getCountryCodesForCallingCode(d);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(d) {
      return this.selectNumberingPlan(d);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(d, a) {
      if (d && N0.test(d) && (a = d, d = null), d && d !== "001") {
        if (!this.hasCountry(d))
          throw new Error("Unknown country: ".concat(d));
        this.numberingPlan = new ad(this.getCountryMetadata(d), this);
      } else if (a) {
        if (!this.hasCallingCode(a))
          throw new Error("Unknown calling code: ".concat(a));
        this.numberingPlan = new ad(this.getNumberingPlanMetadata(a), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(d) {
      var a = this.countryCallingCodes()[d];
      if (a)
        return a.length === 1 && a[0].length === 3 ? void 0 : a;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(d) {
      var a = this.getCountryCodesForCallingCode(d);
      if (a)
        return a[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(d) {
      var a = this.getCountryCodeForCallingCode(d);
      if (a)
        return this.getCountryMetadata(a);
      if (this.nonGeographic()) {
        var n = this.nonGeographic()[d];
        if (n)
          return n;
      } else {
        var r = this.countryCallingCodes()[d];
        if (r && r.length === 1 && r[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(d) {
      return this.numberingPlan.type(d);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(d) {
      return this.selectNumberingPlan(d);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]);
})(), ad = /* @__PURE__ */ (function() {
  function e(t, d) {
    gt(this, e), this.globalMetadataObject = d, this.metadata = t, qd.call(this, d.metadata);
  }
  return $t(e, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(d) {
      return d[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var d = this, a = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return a.map(function(n) {
        return new f0(n, d);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(d) {
      return d[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(d) {
      if (this.hasTypes() && nd(this.types(), d))
        return new C0(nd(this.types(), d), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? dd : this.metadata[13] || dd;
    }
  }]);
})(), f0 = /* @__PURE__ */ (function() {
  function e(t, d) {
    gt(this, e), this._format = t, this.metadata = d;
  }
  return $t(e, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !p0.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]);
})(), p0 = /^\(?\$1\)?$/, C0 = /* @__PURE__ */ (function() {
  function e(t, d) {
    gt(this, e), this.type = t, this.metadata = d;
  }
  return $t(e, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
})();
function nd(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
function Jd(e) {
  if (!e)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!ve(e) || !ve(e.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(ve(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + I0(e) + ": " + e, "."));
}
var I0 = function(t) {
  return Pe(t);
};
function Gt(e, t) {
  if (t = new k(t), t.hasCountry(e))
    return t.selectNumberingPlan(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function A0(e, t) {
  return t.countries.hasOwnProperty(e);
}
function qd(e) {
  var t = e.version;
  typeof t == "number" ? (this.v1 = t === 1, this.v2 = t === 2, this.v3 = t === 3, this.v4 = t === 4) : t ? td(t, y0) === -1 ? this.v2 = !0 : td(t, E0) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function kt(e, t, d) {
  return T0(e, t, void 0, d);
}
function T0(e, t, d, a) {
  t && (a = new k(a.metadata), a.selectNumberingPlan(t));
  var n = a.type(d), r = n && n.possibleLengths() || a.possibleLengths();
  if (!r)
    return "IS_POSSIBLE";
  var o = e.length, l = r[0];
  return l === o ? "IS_POSSIBLE" : l > o ? "TOO_SHORT" : r[r.length - 1] < o ? "TOO_LONG" : r.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function h0(e, t, d) {
  if (t === void 0 && (t = {}), d = new k(d), t.v2) {
    if (!e.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    d.selectNumberingPlan(e.countryCallingCode);
  } else {
    if (!e.phone)
      return !1;
    if (e.country) {
      if (!d.hasCountry(e.country))
        throw new Error("Unknown country: ".concat(e.country));
      d.selectNumberingPlan(e.country);
    } else {
      if (!e.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      d.selectNumberingPlan(e.countryCallingCode);
    }
  }
  if (d.possibleLengths())
    return zd(e.phone || e.nationalNumber, e.country, d);
  if (e.countryCallingCode && d.isNonGeographicCallingCode(e.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function zd(e, t, d) {
  switch (kt(e, t, d)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function ie(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
function S0(e, t) {
  var d = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (d) return (d = d.call(e)).next.bind(d);
  if (Array.isArray(e) || (d = _0(e)) || t) {
    d && (e = d);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function _0(e, t) {
  if (e) {
    if (typeof e == "string") return rd(e, t);
    var d = {}.toString.call(e).slice(8, -1);
    return d === "Object" && e.constructor && (d = e.constructor.name), d === "Map" || d === "Set" ? Array.from(e) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? rd(e, t) : void 0;
  }
}
function rd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var d = 0, a = Array(t); d < t; d++) a[d] = e[d];
  return a;
}
var R0 = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Vt(e, t, d) {
  if (t = t || {}, !(!e.country && !e.countryCallingCode)) {
    d = new k(d), d.selectNumberingPlan(e.country, e.countryCallingCode);
    var a = t.v2 ? e.nationalNumber : e.phone;
    if (ie(a, d.nationalNumberPattern())) {
      if (Rt(a, "FIXED_LINE", d))
        return d.type("MOBILE") && d.type("MOBILE").pattern() === "" || !d.type("MOBILE") || Rt(a, "MOBILE", d) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var n = S0(R0), r; !(r = n()).done; ) {
        var o = r.value;
        if (Rt(a, o, d))
          return o;
      }
    }
  }
}
function Rt(e, t, d) {
  return t = d.type(t), !t || !t.pattern() || t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0 ? !1 : ie(e, t.pattern());
}
function F0(e, t, d) {
  if (t = t || {}, d = new k(d), d.selectNumberingPlan(e.country, e.countryCallingCode), d.hasTypes())
    return Vt(e, t, d.metadata) !== void 0;
  var a = t.v2 ? e.nationalNumber : e.phone;
  return ie(a, d.nationalNumberPattern());
}
function b0(e, t, d) {
  var a = new k(d), n = a.getCountryCodesForCallingCode(e);
  return n ? n.filter(function(r) {
    return L0(t, r, d);
  }) : [];
}
function L0(e, t, d) {
  var a = new k(d);
  return a.selectNumberingPlan(t), a.numberingPlan.possibleLengths().indexOf(e.length) >= 0;
}
var xt = 2, M0 = 17, D0 = 3, ee = "0-9０-９٠-٩۰-۹", v0 = "-‐-―−ー－", O0 = "／/", P0 = "．.", w0 = "  ­​⁠　", U0 = "()（）［］\\[\\]", B0 = "~⁓∼～", lt = "".concat(v0).concat(O0).concat(P0).concat(w0).concat(U0).concat(B0), Ht = "+＋", G0 = new RegExp("([" + ee + "])");
function k0(e, t, d, a) {
  if (t) {
    var n = new k(a);
    n.selectNumberingPlan(t, d);
    var r = new RegExp(n.IDDPrefix());
    if (e.search(r) === 0) {
      e = e.slice(e.match(r)[0].length);
      var o = e.match(G0);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return e;
    }
  }
}
function V0(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var d = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"), a = d.exec(e);
    if (a) {
      var n, r, o = a.length - 1, l = o > 0 && a[o];
      if (t.nationalPrefixTransformRule() && l)
        n = e.replace(d, t.nationalPrefixTransformRule()), o > 1 && (r = a[1]);
      else {
        var i = a[0];
        n = e.slice(i.length), l && (r = a[1]);
      }
      var c;
      if (l) {
        var s = e.indexOf(a[1]), u = e.slice(0, s);
        u === t.numberingPlan.nationalPrefix() && (c = t.numberingPlan.nationalPrefix());
      } else
        c = a[0];
      return {
        nationalNumber: n,
        nationalPrefix: c,
        carrierCode: r
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function x0(e, t) {
  var d = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (d) return (d = d.call(e)).next.bind(d);
  if (Array.isArray(e) || (d = H0(e)) || t) {
    d && (e = d);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function H0(e, t) {
  if (e) {
    if (typeof e == "string") return od(e, t);
    var d = {}.toString.call(e).slice(8, -1);
    return d === "Object" && e.constructor && (d = e.constructor.name), d === "Map" || d === "Set" ? Array.from(e) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? od(e, t) : void 0;
  }
}
function od(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var d = 0, a = Array(t); d < t; d++) a[d] = e[d];
  return a;
}
function W0(e, t) {
  var d = t.countries, a = t.metadata;
  a = new k(a);
  for (var n = x0(d), r; !(r = n()).done; ) {
    var o = r.value;
    if (a.selectNumberingPlan(o), a.leadingDigits()) {
      if (e && e.search(a.leadingDigits()) === 0)
        return o;
    } else if (Vt({
      phone: e,
      country: o
    }, void 0, a.metadata))
      return o;
  }
}
function Qd(e, t) {
  var d = t.nationalNumber, a = t.metadata, n = a.getCountryCodesForCallingCode(e);
  if (n)
    return n.length === 1 ? n[0] : W0(d, {
      countries: n,
      metadata: a.metadata
    });
}
function Dt(e, t, d) {
  var a = V0(e, d), n = a.carrierCode, r = a.nationalNumber;
  if (r !== e) {
    if (!K0(e, r, d))
      return {
        nationalNumber: e
      };
    if (d.numberingPlan.possibleLengths() && (t || (t = Qd(d.numberingPlan.callingCode(), {
      nationalNumber: r,
      metadata: d
    })), !j0(r, t, d)))
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: n
  };
}
function K0(e, t, d) {
  return !(ie(e, d.nationalNumberPattern()) && !ie(t, d.nationalNumberPattern()));
}
function j0(e, t, d) {
  switch (kt(e, t, d)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function Y0(e, t, d, a, n) {
  var r = d ? Gt(d, n) : a;
  if (e.indexOf(r) === 0) {
    n = new k(n), n.selectNumberingPlan(d, r);
    var o = e.slice(r.length), l = Dt(o, t, n), i = l.nationalNumber, c = Dt(e, t, n), s = c.nationalNumber;
    if (!ie(s, n.nationalNumberPattern()) && ie(i, n.nationalNumberPattern()) || kt(s, t, n) === "TOO_LONG")
      return {
        countryCallingCode: r,
        number: o
      };
  }
  return {
    number: e
  };
}
function Xd(e, t, d, a, n) {
  if (!e)
    return {};
  var r;
  if (e[0] !== "+") {
    var o = k0(e, d, a, n);
    if (o && o !== e)
      r = !0, e = "+" + o;
    else {
      if (d || a) {
        var l = Y0(e, t, d, a, n), i = l.countryCallingCode, c = l.number;
        if (i)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: i,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: e
      };
    }
  }
  if (e[1] === "0")
    return {};
  n = new k(n);
  for (var s = 2; s - 1 <= D0 && s <= e.length; ) {
    var u = e.slice(1, s);
    if (n.hasCallingCode(u))
      return n.selectNumberingPlan(u), {
        countryCallingCodeSource: r ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: u,
        number: e.slice(s)
      };
    s++;
  }
  return {};
}
function Z0(e) {
  return e.replace(new RegExp("[".concat(lt, "]+"), "g"), " ").trim();
}
var J0 = /(\$\d)/;
function q0(e, t, d) {
  var a = d.useInternationalFormat, n = d.withNationalPrefix, r = e.replace(new RegExp(t.pattern()), a ? t.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    n && t.nationalPrefixFormattingRule() ? t.format().replace(J0, t.nationalPrefixFormattingRule()) : t.format()
  ));
  return a ? Z0(r) : r;
}
var z0 = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Q0(e, t, d) {
  var a = new k(d);
  if (a.selectNumberingPlan(e, t), a.defaultIDDPrefix())
    return a.defaultIDDPrefix();
  if (z0.test(a.IDDPrefix()))
    return a.IDDPrefix();
}
var X0 = ";ext=", Le = function(t) {
  return "([".concat(ee, "]{1,").concat(t, "})");
};
function ea(e) {
  var t = "20", d = "15", a = "9", n = "6", r = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", l = "#?", i = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", s = "[- ]+", u = "[  \\t]*", m = "(?:,{2}|;)", g = X0 + Le(t), E = r + i + o + Le(t) + l, y = r + c + o + Le(a) + l, N = s + Le(n) + "#", T = u + m + o + Le(d) + l, O = u + "(?:,)+" + o + Le(a) + l;
  return g + "|" + E + "|" + y + "|" + N + "|" + T + "|" + O;
}
var er = "[" + ee + "]{" + xt + "}", tr = "[" + Ht + "]{0,1}(?:[" + lt + "]*[" + ee + "]){3,}[" + lt + ee + "]*", dr = new RegExp("^[" + Ht + "]{0,1}(?:[" + lt + "]*[" + ee + "]){1,2}$", "i"), ar = tr + // Phone number extensions
"(?:" + ea() + ")?", nr = new RegExp(
  // Either a short two-digit-only phone number
  "^" + er + "$|^" + ar + "$",
  "i"
);
function rr(e) {
  return e.length >= xt && nr.test(e);
}
function or(e) {
  return dr.test(e);
}
function lr(e) {
  var t = e.number, d = e.ext;
  if (!t)
    return "";
  if (t[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(t).concat(d ? ";ext=" + d : "");
}
var ld = {
  formatExtension: function(t, d, a) {
    return "".concat(t).concat(a.ext()).concat(d);
  }
};
function ir(e, t, d, a) {
  if (d ? d = ur({}, ld, d) : d = ld, a = new k(a), e.country && e.country !== "001") {
    if (!a.hasCountry(e.country))
      throw new Error("Unknown country: ".concat(e.country));
    a.selectNumberingPlan(e.country);
  } else if (e.countryCallingCode)
    a.selectNumberingPlan(e.countryCallingCode);
  else return e.phone || "";
  var n = a.countryCallingCode(), r = d.v2 ? e.nationalNumber : e.phone, o;
  switch (t) {
    case "NATIONAL":
      return r ? (o = it(r, e.carrierCode, "NATIONAL", a, d), Ft(o, e.ext, a, d.formatExtension)) : "";
    case "INTERNATIONAL":
      return r ? (o = it(r, null, "INTERNATIONAL", a, d), o = "+".concat(n, " ").concat(o), Ft(o, e.ext, a, d.formatExtension)) : "+".concat(n);
    case "E.164":
      return "+".concat(n).concat(r);
    case "RFC3966":
      return lr({
        number: "+".concat(n).concat(r),
        ext: e.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!d.fromCountry)
        return;
      var l = sr(r, e.carrierCode, n, d.fromCountry, a);
      return Ft(l, e.ext, a, d.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function it(e, t, d, a, n) {
  var r = cr(a.formats(), e);
  return r ? q0(e, r, {
    useInternationalFormat: d === "INTERNATIONAL",
    withNationalPrefix: !(r.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && n && n.nationalPrefix === !1)
  }) : e;
}
function cr(e, t) {
  return mr(e, function(d) {
    if (d.leadingDigitsPatterns().length > 0) {
      var a = d.leadingDigitsPatterns()[d.leadingDigitsPatterns().length - 1];
      if (t.search(a) !== 0)
        return !1;
    }
    return ie(t, d.pattern());
  });
}
function Ft(e, t, d, a) {
  return t ? a(e, t, d) : e;
}
function sr(e, t, d, a, n) {
  var r = Gt(a, n.metadata);
  if (r === d) {
    var o = it(e, t, "NATIONAL", n);
    return d === "1" ? d + " " + o : o;
  }
  var l = Q0(a, void 0, n.metadata);
  if (l)
    return "".concat(l, " ").concat(d, " ").concat(it(e, null, "INTERNATIONAL", n));
}
function ur() {
  for (var e = 1, t = arguments.length, d = new Array(t), a = 0; a < t; a++)
    d[a] = arguments[a];
  for (; e < d.length; ) {
    if (d[e])
      for (var n in d[e])
        d[0][n] = d[e][n];
    e++;
  }
  return d[0];
}
function mr(e, t) {
  for (var d = 0; d < e.length; ) {
    if (t(e[d]))
      return e[d];
    d++;
  }
}
function We(e) {
  "@babel/helpers - typeof";
  return We = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, We(e);
}
function id(e, t) {
  var d = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), d.push.apply(d, a);
  }
  return d;
}
function cd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var d = arguments[t] != null ? arguments[t] : {};
    t % 2 ? id(Object(d), !0).forEach(function(a) {
      gr(e, a, d[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(d)) : id(Object(d)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(d, a));
    });
  }
  return e;
}
function gr(e, t, d) {
  return (t = ta(t)) in e ? Object.defineProperty(e, t, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = d, e;
}
function $r(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function yr(e, t) {
  for (var d = 0; d < t.length; d++) {
    var a = t[d];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, ta(a.key), a);
  }
}
function Er(e, t, d) {
  return t && yr(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ta(e) {
  var t = Nr(e, "string");
  return We(t) == "symbol" ? t : t + "";
}
function Nr(e, t) {
  if (We(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, t);
    if (We(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var fr = /* @__PURE__ */ (function() {
  function e(t, d, a) {
    if ($r(this, e), !t)
      throw new TypeError("First argument is required");
    if (typeof t != "string")
      throw new TypeError("First argument must be a string");
    if (t[0] === "+" && !d)
      throw new TypeError("`metadata` argument not passed");
    if (ve(d) && ve(d.countries)) {
      a = d;
      var n = t;
      if (!Ir.test(n))
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      var r = Xd(n, void 0, void 0, void 0, a), o = r.countryCallingCode, l = r.number;
      if (d = l, t = o, !d)
        throw new Error("Invalid `number` argument passed: too short");
    }
    if (!d)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof d != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    Jd(a);
    var i = Cr(t, a), c = i.country, s = i.countryCallingCode;
    this.country = c, this.countryCallingCode = s, this.nationalNumber = d, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return a;
    };
  }
  return Er(e, [{
    key: "setExt",
    value: function(d) {
      this.ext = d;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : b0(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return h0(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return F0(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var d = new k(this.getMetadata());
      return d.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(d) {
      return this.number === d.number && this.ext === d.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return Vt(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(d, a) {
      return ir(this, d, a ? cd(cd({}, a), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(d) {
      return this.format("NATIONAL", d);
    }
  }, {
    key: "formatInternational",
    value: function(d) {
      return this.format("INTERNATIONAL", d);
    }
  }, {
    key: "getURI",
    value: function(d) {
      return this.format("RFC3966", d);
    }
  }]);
})(), pr = function(t) {
  return /^[A-Z]{2}$/.test(t);
};
function Cr(e, t) {
  var d, a, n = new k(t);
  return pr(e) ? (d = e, n.selectNumberingPlan(d), a = n.countryCallingCode()) : a = e, {
    country: d,
    countryCallingCode: a
  };
}
var Ir = /^\+\d+$/;
function vt(e) {
  "@babel/helpers - typeof";
  return vt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, vt(e);
}
function Ar(e, t, d) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Tr(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function hr(e, t, d) {
  return t = je(t), Sr(e, Wt() ? Reflect.construct(t, d || [], je(e).constructor) : t.apply(e, d));
}
function Sr(e, t) {
  if (t && (vt(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return _r(e);
}
function _r(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Rr(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ke(e, t);
}
function Ot(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ot = function(a) {
    if (a === null || !br(a)) return a;
    if (typeof a != "function") throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(a)) return t.get(a);
      t.set(a, n);
    }
    function n() {
      return Fr(a, arguments, je(this).constructor);
    }
    return n.prototype = Object.create(a.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), Ke(n, a);
  }, Ot(e);
}
function Fr(e, t, d) {
  if (Wt()) return Reflect.construct.apply(null, arguments);
  var a = [null];
  a.push.apply(a, t);
  var n = new (e.bind.apply(e, a))();
  return d && Ke(n, d.prototype), n;
}
function Wt() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wt = function() {
    return !!e;
  })();
}
function br(e) {
  try {
    return Function.toString.call(e).indexOf("[native code]") !== -1;
  } catch {
    return typeof e == "function";
  }
}
function Ke(e, t) {
  return Ke = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(d, a) {
    return d.__proto__ = a, d;
  }, Ke(e, t);
}
function je(e) {
  return je = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, je(e);
}
var oe = /* @__PURE__ */ (function(e) {
  function t(d) {
    var a;
    return Tr(this, t), a = hr(this, t, [d]), Object.setPrototypeOf(a, t.prototype), a.name = a.constructor.name, a;
  }
  return Rr(t, e), Ar(t);
})(/* @__PURE__ */ Ot(Error)), sd = new RegExp("(?:" + ea() + ")$", "i");
function Lr(e) {
  var t = e.search(sd);
  if (t < 0)
    return {};
  for (var d = e.slice(0, t), a = e.match(sd), n = 1; n < a.length; ) {
    if (a[n])
      return {
        number: d,
        ext: a[n]
      };
    n++;
  }
}
var Mr = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function Dr(e) {
  return Mr[e];
}
function vr(e, t) {
  var d = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (d) return (d = d.call(e)).next.bind(d);
  if (Array.isArray(e) || (d = Or(e)) || t) {
    d && (e = d);
    var a = 0;
    return function() {
      return a >= e.length ? { done: !0 } : { done: !1, value: e[a++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Or(e, t) {
  if (e) {
    if (typeof e == "string") return ud(e, t);
    var d = {}.toString.call(e).slice(8, -1);
    return d === "Object" && e.constructor && (d = e.constructor.name), d === "Map" || d === "Set" ? Array.from(e) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? ud(e, t) : void 0;
  }
}
function ud(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var d = 0, a = Array(t); d < t; d++) a[d] = e[d];
  return a;
}
function md(e) {
  for (var t = "", d = vr(e.split("")), a; !(a = d()).done; ) {
    var n = a.value;
    t += Pr(n, t) || "";
  }
  return t;
}
function Pr(e, t, d) {
  return e === "+" ? t ? void 0 : "+" : Dr(e);
}
var da = "+", wr = "[\\-\\.\\(\\)]?", gd = "([" + ee + "]|" + wr + ")", Ur = "^\\" + da + gd + "*[" + ee + "]" + gd + "*$", Br = new RegExp(Ur, "g"), Pt = ee, Gr = "[" + Pt + "]+((\\-)*[" + Pt + "])*", kr = "a-zA-Z", Vr = "[" + kr + "]+((\\-)*[" + Pt + "])*", xr = "^(" + Gr + "\\.)*" + Vr + "\\.?$", Hr = new RegExp(xr, "g"), $d = "tel:", wt = ";phone-context=", Wr = ";isub=";
function Kr(e) {
  var t = e.indexOf(wt);
  if (t < 0)
    return null;
  var d = t + wt.length;
  if (d >= e.length)
    return "";
  var a = e.indexOf(";", d);
  return a >= 0 ? e.substring(d, a) : e.substring(d);
}
function jr(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Br.test(e) || Hr.test(e);
}
function Yr(e, t) {
  var d = t.extractFormattedPhoneNumber, a = Kr(e);
  if (!jr(a))
    throw new oe("NOT_A_NUMBER");
  var n;
  if (a === null)
    n = d(e) || "";
  else {
    n = "", a.charAt(0) === da && (n += a);
    var r = e.indexOf($d), o;
    r >= 0 ? o = r + $d.length : o = 0;
    var l = e.indexOf(wt);
    n += e.substring(o, l);
  }
  var i = n.indexOf(Wr);
  if (i > 0 && (n = n.substring(0, i)), n !== "")
    return n;
}
var Zr = 250, Jr = new RegExp("[" + Ht + ee + "]"), qr = new RegExp("[^" + ee + "#]+$");
function zr(e, t, d) {
  if (t = t || {}, d = new k(d), t.defaultCountry && !d.hasCountry(t.defaultCountry))
    throw t.v2 ? new oe("INVALID_COUNTRY") : new Error("Unknown country: ".concat(t.defaultCountry));
  var a = Xr(e, t.v2, t.extract), n = a.number, r = a.ext, o = a.error;
  if (!n) {
    if (t.v2)
      throw o === "TOO_SHORT" ? new oe("TOO_SHORT") : new oe("NOT_A_NUMBER");
    return {};
  }
  var l = to(n, t.defaultCountry, t.defaultCallingCode, d), i = l.country, c = l.nationalNumber, s = l.countryCallingCode, u = l.countryCallingCodeSource, m = l.carrierCode;
  if (!d.hasSelectedNumberingPlan()) {
    if (t.v2)
      throw new oe("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < xt) {
    if (t.v2)
      throw new oe("TOO_SHORT");
    return {};
  }
  if (c.length > M0) {
    if (t.v2)
      throw new oe("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var g = new fr(s, c, d.metadata);
    return i && (g.country = i), m && (g.carrierCode = m), r && (g.ext = r), g.__countryCallingCodeSource = u, g;
  }
  var E = (t.extended ? d.hasSelectedNumberingPlan() : i) ? ie(c, d.nationalNumberPattern()) : !1;
  return t.extended ? {
    country: i,
    countryCallingCode: s,
    carrierCode: m,
    valid: E,
    possible: E ? !0 : !!(t.extended === !0 && d.possibleLengths() && zd(c, i, d)),
    phone: c,
    ext: r
  } : E ? eo(i, c, r) : {};
}
function Qr(e, t, d) {
  if (e) {
    if (e.length > Zr) {
      if (d)
        throw new oe("TOO_LONG");
      return;
    }
    if (t === !1)
      return e;
    var a = e.search(Jr);
    if (!(a < 0))
      return e.slice(a).replace(qr, "");
  }
}
function Xr(e, t, d) {
  var a = Yr(e, {
    extractFormattedPhoneNumber: function(o) {
      return Qr(o, d, t);
    }
  });
  if (!a)
    return {};
  if (!rr(a))
    return or(a) ? {
      error: "TOO_SHORT"
    } : {};
  var n = Lr(a);
  return n.ext ? n : {
    number: a
  };
}
function eo(e, t, d) {
  var a = {
    country: e,
    phone: t
  };
  return d && (a.ext = d), a;
}
function to(e, t, d, a) {
  var n = Xd(md(e), void 0, t, d, a.metadata), r = n.countryCallingCodeSource, o = n.countryCallingCode, l = n.number, i;
  if (o)
    a.selectNumberingPlan(o);
  else if (l && (t || d))
    a.selectNumberingPlan(t, d), t && (i = t), o = d || Gt(t, a.metadata);
  else return {};
  if (!l)
    return {
      countryCallingCodeSource: r,
      countryCallingCode: o
    };
  var c = Dt(md(l), i, a), s = c.nationalNumber, u = c.carrierCode, m = Qd(o, {
    nationalNumber: s,
    metadata: a
  });
  return m && (i = m, m === "001" || a.selectNumberingPlan(i)), {
    country: i,
    countryCallingCode: o,
    countryCallingCodeSource: r,
    nationalNumber: s,
    carrierCode: u
  };
}
function Ye(e) {
  "@babel/helpers - typeof";
  return Ye = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ye(e);
}
function yd(e, t) {
  var d = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), d.push.apply(d, a);
  }
  return d;
}
function Ed(e) {
  for (var t = 1; t < arguments.length; t++) {
    var d = arguments[t] != null ? arguments[t] : {};
    t % 2 ? yd(Object(d), !0).forEach(function(a) {
      ao(e, a, d[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(d)) : yd(Object(d)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(d, a));
    });
  }
  return e;
}
function ao(e, t, d) {
  return (t = no(t)) in e ? Object.defineProperty(e, t, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = d, e;
}
function no(e) {
  var t = ro(e, "string");
  return Ye(t) == "symbol" ? t : t + "";
}
function ro(e, t) {
  if (Ye(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, t);
    if (Ye(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function oo(e, t, d) {
  return zr(e, Ed(Ed({}, t), {}, {
    v2: !0
  }), d);
}
function Ze(e) {
  "@babel/helpers - typeof";
  return Ze = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Ze(e);
}
function Nd(e, t) {
  var d = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), d.push.apply(d, a);
  }
  return d;
}
function lo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var d = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nd(Object(d), !0).forEach(function(a) {
      io(e, a, d[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(d)) : Nd(Object(d)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(d, a));
    });
  }
  return e;
}
function io(e, t, d) {
  return (t = co(t)) in e ? Object.defineProperty(e, t, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = d, e;
}
function co(e) {
  var t = so(e, "string");
  return Ze(t) == "symbol" ? t : t + "";
}
function so(e, t) {
  if (Ze(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, t);
    if (Ze(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function uo(e, t) {
  return yo(e) || $o(e, t) || go(e, t) || mo();
}
function mo() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function go(e, t) {
  if (e) {
    if (typeof e == "string") return fd(e, t);
    var d = {}.toString.call(e).slice(8, -1);
    return d === "Object" && e.constructor && (d = e.constructor.name), d === "Map" || d === "Set" ? Array.from(e) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? fd(e, t) : void 0;
  }
}
function fd(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var d = 0, a = Array(t); d < t; d++) a[d] = e[d];
  return a;
}
function $o(e, t) {
  var d = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (d != null) {
    var a, n, r, o, l = [], i = !0, c = !1;
    try {
      if (r = (d = d.call(e)).next, t !== 0) for (; !(i = (a = r.call(d)).done) && (l.push(a.value), l.length !== t); i = !0) ;
    } catch (s) {
      c = !0, n = s;
    } finally {
      try {
        if (!i && d.return != null && (o = d.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw n;
      }
    }
    return l;
  }
}
function yo(e) {
  if (Array.isArray(e)) return e;
}
function Eo(e) {
  var t = Array.prototype.slice.call(e), d = uo(t, 4), a = d[0], n = d[1], r = d[2], o = d[3], l, i, c;
  if (typeof a == "string")
    l = a;
  else throw new TypeError("A text for parsing must be a string.");
  if (!n || typeof n == "string")
    o ? (i = r, c = o) : (i = void 0, c = r), n && (i = lo({
      defaultCountry: n
    }, i));
  else if (ve(n))
    r ? (i = n, c = r) : c = n;
  else throw new Error("Invalid second argument: ".concat(n));
  return {
    text: l,
    options: i,
    metadata: c
  };
}
function Je(e) {
  "@babel/helpers - typeof";
  return Je = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Je(e);
}
function pd(e, t) {
  var d = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), d.push.apply(d, a);
  }
  return d;
}
function Cd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var d = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pd(Object(d), !0).forEach(function(a) {
      No(e, a, d[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(d)) : pd(Object(d)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(d, a));
    });
  }
  return e;
}
function No(e, t, d) {
  return (t = fo(t)) in e ? Object.defineProperty(e, t, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = d, e;
}
function fo(e) {
  var t = po(e, "string");
  return Je(t) == "symbol" ? t : t + "";
}
function po(e, t) {
  if (Je(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, t);
    if (Je(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Co(e, t, d) {
  t && t.defaultCountry && !A0(t.defaultCountry, d) && (t = Cd(Cd({}, t), {}, {
    defaultCountry: void 0
  }));
  try {
    return oo(e, t, d);
  } catch (a) {
    if (!(a instanceof oe)) throw a;
  }
}
function qe(e) {
  "@babel/helpers - typeof";
  return qe = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, qe(e);
}
function Id(e, t) {
  var d = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), d.push.apply(d, a);
  }
  return d;
}
function Ad(e) {
  for (var t = 1; t < arguments.length; t++) {
    var d = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Id(Object(d), !0).forEach(function(a) {
      Io(e, a, d[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(d)) : Id(Object(d)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(d, a));
    });
  }
  return e;
}
function Io(e, t, d) {
  return (t = Ao(t)) in e ? Object.defineProperty(e, t, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = d, e;
}
function Ao(e) {
  var t = To(e, "string");
  return qe(t) == "symbol" ? t : t + "";
}
function To(e, t) {
  if (qe(e) != "object" || !e) return e;
  var d = e[Symbol.toPrimitive];
  if (d !== void 0) {
    var a = d.call(e, t);
    if (qe(a) != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function ho() {
  var e = Eo(arguments), t = e.text, d = e.options, a = e.metadata;
  d = Ad(Ad({}, d), {}, {
    extract: !1
  });
  var n = Co(t, d, a);
  return n && n.isValid() || !1;
}
function So() {
  return s0(ho, arguments);
}
const bl = (e) => So(e), _o = (e) => e === 1 ? "1 month" : `${e} months`, Ll = _o(tn), Td = (e) => A.duration(e, "minutes").format(
  `h [hours]${e % 60 > 0 ? " m [minutes]" : ""}`
), aa = ({ time: e, duration: t }, d, a, n, r, o = !1) => {
  const l = A(d).tz(a).set({
    hour: e / 60,
    minute: e % 60,
    second: 0,
    millisecond: 0
  }).toDate(), i = A(d).tz(a).set({
    hour: (e + t) / 60,
    minute: (e + t) % 60,
    second: 0,
    millisecond: 0
  }).toDate(), c = le(
    l,
    a,
    o
  ), s = le(
    i,
    a,
    o
  ), u = `${c} - ${s}${n}`;
  return r ? `<strong>${u} (your time slot)</strong>` : u;
}, na = (e, t, d, a, n) => {
  const r = (n?.compositeFilter?.groups?.length ?? 0) > 0;
  if (!e.length && !r)
    return "<ul><li>Break</li></ul>";
  if (t === -1)
    return `<ul>${(r ? e.length > 0 ? [
      ...e.map(({ firstName: s, lastName: u, title: m }) => {
        const g = a ? s.trim() : `${s} ${u}`.trim(), E = m ? ` (${m})` : "";
        return `<li>${g}${E}</li>`;
      }),
      "<li>and others</li>"
    ] : [
      "<li>- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later.</li>"
    ] : e.map(({ firstName: s, lastName: u, title: m }) => {
      const g = a ? s.trim() : `${s} ${u}`.trim(), E = m ? ` (${m})` : "";
      return `<li>${g}${E}</li>`;
    })).join("")}</ul>`;
  const o = r ? e.length > 0 ? `${e.map(
    ({ firstName: c, lastName: s }) => a ? c.trim() : `${c} ${s}`.trim()
  ).join(", ")}, and others` : "- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later." : e.map(
    ({ firstName: c, lastName: s }) => a ? c.trim() : `${c} ${s}`.trim()
  ).join(", "), l = "Interviewer: ";
  return `<ul><li>${t === d ? `<strong>${l}</strong>` : l}${o}</li></ul>`;
}, ra = (e, t, d, a, n) => d === -1 ? "" : [
  { type: "conferencing", label: "Type:" },
  { type: "room", label: "Location:" },
  { type: "other", label: "Conferencing:" },
  {
    type: "other",
    label: "Scorecard:",
    isSkill: !0,
    show: n ?? !0
  },
  {
    type: "comment",
    label: "",
    isSkill: !0,
    show: n ?? !0
  }
].map(
  ({ type: o, label: l, isSkill: i, show: c = !0 }) => oa(
    i ? t : e,
    o,
    d,
    a,
    l,
    c
  )
).join(""), oa = (e, t, d, a, n, r) => {
  const o = e.filter(({ type: s }) => r ? t === "other" ? !["conferencing", "room", "comment"].includes(s) : s === t : !1), l = a && n.length > 0 ? `<strong>${n}</strong>` : n, i = o.map(({ name: s }) => s).sort((s, u) => s.localeCompare(u)).join(", "), c = `${l} ${i}`.trim();
  return o.length > 0 ? `<ul><li>${c}</li></ul>` : "";
}, hd = (e, t, d, a, n, r, o, l = !1) => e.length ? `<div style="margin-bottom:16px"><table border="1"><thead style="text-align:center">
  <tr><th colSpan="3">Interview Schedule</th></tr><tr><th>Time</th><th>Duration</th><th>Interviewers</th></tr></thead>
  <tbody>${e.map(
  ({
    time: c,
    duration: s,
    interviewers: u,
    interviewersFilter: m,
    conferencing: g,
    skills: E
  }, y) => {
    const N = e.length > 1 && y === n;
    return `<tr><td>${aa(
      { time: c, duration: s },
      t,
      d,
      a,
      N,
      l
    )}
        </td>
        <td>${N ? `<strong>${Td(s)}</strong>` : Td(s)}</td>
        <td>${na(
      u,
      n,
      y,
      r,
      m
    )}
          ${ra(
      g,
      E,
      n,
      N,
      o
    )}
        </td>
      </tr>`;
  }
).join("")} </tbody></table></div>` : "", nt = (e, t, d, a, n, r, o, l = !1) => e.length ? `<ul>${e.map(
  ({
    time: c,
    duration: s,
    interviewers: u,
    interviewersFilter: m,
    conferencing: g,
    skills: E
  }, y) => {
    const N = e.length > 1 && y === n;
    return `<li>${aa(
      { time: c, duration: s },
      t,
      d,
      a,
      N,
      l
    )}${na(
      u,
      n,
      y,
      r,
      m
    )}${ra(
      g,
      E,
      n,
      N,
      o
    )}
      </li>`;
  }
).join("")}</ul>` : "";
Ut(A);
const Ro = (e, t, d) => {
  const a = A.tz(d).utcOffset(), n = A(e).subtract(a, "minutes").valueOf(), r = A(n).add(t, "minutes").tz(d);
  return we(r.toDate(), d);
}, Fo = (e) => A.duration(e, "minutes").format(
  `h [hours]${e % 60 > 0 ? " m [minutes]" : ""}`
), Sd = (e, t) => e.map(({ firstName: d, lastName: a, title: n }) => {
  const o = (t ? d : `${d} ${a}`).trim(), l = n ? ` (${n})` : "";
  return `<li>${o}${l}</li>`;
}), _d = (e, t) => e.map(({ firstName: d, lastName: a, title: n }) => (t ? d : `${d} ${a}`).trim()), bo = (e, t, d, a = [], n) => {
  const r = (n?.compositeFilter?.groups?.length ?? 0) > 0;
  if (a.length === 0 && !r)
    return "<ul><li>Break</li></ul>";
  const l = "Interviewers: ", i = t ? `<strong>${l}</strong>` : l;
  if (e) {
    const u = r ? a.length > 0 ? [
      ...Sd(a, d),
      "<li>and others</li>"
    ] : [
      "<li>- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later.</li>"
    ] : Sd(a, d);
    return `<ul><li>${i}<ul>${u.join(
      ""
    )}</ul></li></ul>`;
  }
  const s = (r ? a.length > 0 ? [
    ..._d(a, d),
    "and others"
  ] : [
    "- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later."
  ] : _d(a, d)).join(", ");
  return `<ul><li>${i}${s}</li></ul>`;
}, Lo = ({
  conferencing: e,
  skills: t,
  isCurrentSlot: d,
  isCandidate: a,
  showScorecardQuestionnaires: n
}) => (a ? [
  { type: "conferencing", label: "" },
  { type: "room", label: "Location:" }
] : [
  { type: "conferencing", label: "" },
  { type: "room", label: "Location:" },
  { type: "other", label: "Conferencing:" },
  {
    type: "other",
    label: "Scorecard:",
    isSkill: !0,
    show: n
  },
  {
    type: "comment",
    label: "",
    isSkill: !0,
    show: n
  }
]).map(
  ({ type: o, label: l, isSkill: i = !1, show: c = !0 }) => oa(
    i ? t : e,
    o,
    null,
    // Is not used in the function
    d,
    l,
    c
  )
).join(""), Rd = ({
  start: e,
  timeOffset: t,
  timeZone: d,
  is24HourFormat: a = !1
}) => le(
  A(e).tz(d).set({
    hour: t / 60,
    minute: t % 60,
    second: 0,
    millisecond: 0
  }).toDate(),
  d,
  a
), Mo = (e) => e ? e.replace(/_/gi, " ") : "", Do = ({
  start: e,
  timeZone: t,
  timeOffset: d,
  duration: a,
  isCurrentSlot: n,
  isCandidate: r,
  is24HourFormat: o = !1
}) => {
  const l = Rd({
    start: e,
    timeOffset: d,
    timeZone: t,
    is24HourFormat: o
  }), i = Rd({
    start: e,
    timeOffset: d + a,
    timeZone: t,
    is24HourFormat: o
  }), c = Mo(t), s = `${l} - ${i} ( ${c} )`;
  return n ? `<strong>${r ? s : `${s} (your time slot)`}</strong>` : s;
}, vo = ({
  start: e,
  timeZone: t,
  isCurrentInterview: d,
  onlyAttendeeFirstNames: a,
  isTable: n
}, r, o, l, i = !1) => (c, s) => {
  const u = r === -1, m = d && (s === r || u), g = Do({
    start: e,
    timeZone: t,
    timeOffset: c.time,
    duration: c.duration,
    isCurrentSlot: m,
    isCandidate: u,
    is24HourFormat: i
  }), E = bo(
    u,
    m,
    a,
    c.interviewers,
    c?.interviewersFilter
  ), y = Lo({
    conferencing: c.conferencing,
    skills: c.skills,
    isCurrentSlot: m,
    isCandidate: u,
    showScorecardQuestionnaires: l
  });
  if (n) {
    const N = Fo(c.duration), T = m ? `<strong>${N}</strong>` : N;
    return `<tr style="border: 1px solid black;"><td style="border: 1px solid black">${o}${m ? "<strong>, </strong>" : ", "}${g}</td><td style="border: 1px solid black">${T}</td><td style="border: 1px solid black">${E}${y}</td></tr>`;
  }
  return `<li>${g}${E}${y}</li>`;
}, Oo = (e, t, d, a, n = !1) => (r) => {
  const { events: o, start: l, timeZone: i, isCurrentInterview: c } = r, s = o[0].time, u = Ro(
    l,
    s,
    i
  ), m = c ? `<strong>${u}</strong>` : u, g = o.map(
    (E, y) => vo(
      {
        ...za(r, ["id", "events"]),
        onlyAttendeeFirstNames: t,
        isTable: d
      },
      e,
      m,
      a,
      n
    )(E, y)
  );
  return d ? g.join("") : `<li style="margin-bottom: 16px">${m}<ul>${g.join(
    ""
  )}</ul></li>`;
}, Po = (e, t = !0) => {
  const { id: d, start: a, timeZone: n, interviews: r } = e, o = [
    "interviewers",
    "interviewersFilter",
    "conferencing",
    "duration",
    "time",
    "skills"
  ], l = r.map(
    (i) => qa(i, o)
  );
  return {
    id: d,
    start: a,
    timeZone: n,
    events: l,
    isCurrentInterview: t
  };
}, Me = ({
  interview: e,
  otherInterviews: t,
  slotIndex: d,
  onlyAttendeeFirstNames: a = !1,
  isTable: n = !1,
  showScorecardQuestionnaires: r = !0,
  is24HourFormat: o = !1
}) => {
  const c = [
    Po(e),
    ...t
  ].sort((s, u) => s.start - u.start).map(
    Oo(
      d,
      a,
      n,
      r,
      o
    )
  );
  return n ? `<table border="1" style="border: 1px solid black"><thead style="text-align:center">
	  <th style="border: 1px solid black" colSpan="3">Interview Schedule</th><tr><th style="border: 1px solid black">Time</th><th style="border: 1px solid black">Duration</th><th style="border: 1px solid black">Interviewers</th></tr></thead>
	  <tbody>${c.join("")}</tbody></table>` : `<ul style="list-style-type: none">${c.join("")}</ul>`;
}, wo = (e) => (t) => {
  const {
    interviewers: d = [],
    interviewersFilter: a,
    conferencing: n = [],
    duration: r,
    skills: o = [],
    time: l,
    conferencingOptions: i
  } = t;
  return {
    interviewers: d,
    interviewersFilter: a,
    conferencing: n,
    duration: r,
    skills: o,
    time: l,
    ...e && { conferencingOptions: i }
  };
}, Uo = (e) => (t) => {
  const { id: d, start: a, timeZone: n, interviews: r = [] } = t, o = r.map(
    wo(e)
  );
  return {
    id: d,
    start: a,
    timeZone: n,
    isCurrentInterview: !1,
    events: o
  };
}, Ml = (e, t, d = !1) => (e?.filter(({ id: n }) => n !== t) ?? []).map(
  Uo(d)
), la = (e, t) => {
  const d = e?.flatMap(
    ({ interviewersFilter: i }) => i?.compositeFilter?.groups?.length > 0
  )?.some(Boolean), a = e?.flatMap(
    ({ interviewers: i }) => i?.map(({ firstName: c, lastName: s, title: u }) => ({
      firstName: c,
      lastName: s,
      title: u
    })) ?? []
  ), n = d ? a.length > 0 ? `${[
    ...new Set(
      a.map(
        ({ firstName: i }) => i?.trim()
      )
    )
  ].join(", ")}, ${t?.andOthers ?? "and others"}` : t?.stillFinalizing ?? "- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later." : [
    ...new Set(
      a.map(
        ({ firstName: i }) => i?.trim()
      )
    )
  ].join(", ").replace(/,(?=[^,]+$)/, " and") ?? "", r = d ? a.length > 0 ? `${[
    ...new Set(
      a.map(
        ({ firstName: i, lastName: c, title: s }) => `${i ?? ""} ${c ?? ""}`.trim() + (s ? ` (${s})` : "")
      )
    )
  ].join(", ")}, ${t?.andOthers ?? "and others"}` : t?.stillFinalizing ?? "- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later." : [
    ...new Set(
      a.map(
        ({ firstName: i, lastName: c, title: s }) => `${i ?? ""} ${c ?? ""}`.trim() + (s ? ` (${s})` : "")
      )
    )
  ].reduce((i, c, s, { length: u }) => s === 0 || u === 1 ? c : s === u - 1 ? `${i} and ${c}` : `${i}, ${c}`, ""), o = d ? a.length > 0 ? `${[
    ...new Set(
      a.map(
        ({ firstName: i, lastName: c }) => `${i ?? ""} ${c ?? ""}`.trim()
      )
    )
  ].join(", ")}, ${t?.andOthers ?? "and others"}` : t?.stillFinalizing ?? "- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later." : [
    ...new Set(
      a.map(
        ({ firstName: i, lastName: c }) => `${i ?? ""} ${c ?? ""}`.trim()
      )
    )
  ].reduce((i, c, s, { length: u }) => s === 0 || u === 1 ? c : s === u - 1 ? `${i} and ${c}` : `${i}, ${c}`, ""), l = d ? a.length > 0 ? [
    ...new Set(
      a.map(
        ({ firstName: i, lastName: c, title: s }) => `<li><strong>${i ?? ""} ${c ?? ""}</strong>${s ? ` (${s})` : ""}</li>`
      )
    ),
    `<li><strong>${t?.andOthers ?? "and others"}</strong></li>`
  ] : [
    `<li>${t?.stillFinalizing ?? "- We're finalizing your interview details based on team availability. Interviewer names will be confirmed later."}</li>`
  ] : [
    ...new Set(
      a.map(
        ({ firstName: i, lastName: c, title: s }) => `<li><strong>${i ?? ""} ${c ?? ""}</strong>${s ? ` (${s})` : ""}</li>`
      )
    )
  ];
  return {
    interviewerFirstNames: n,
    interviewerFullNames: r,
    interviewerFullNamesWithoutTitles: o,
    interviewersListItems: l
  };
}, Bo = {
  GOOGLE: "google",
  ZOOM: "zoom",
  WORKDAY: "workday",
  OFFICE365: "office365",
  WEBEX: "webex",
  MSTEAMS: "msteams",
  ROOSTER: "rooster",
  SMS: "sms",
  MEET: "googleMeet",
  EIGHTBYEIGHT: "eightbyeight"
}, Go = ({
  start: e,
  time: t,
  duration: d,
  timeZone: a
}) => {
  const n = e + t * 6e4 - A.tz(a).utcOffset() * 6e4, r = A.tz(n, a), o = A.utc(e).subtract(r.utcOffset(), "minutes").valueOf() + t * 6e4, l = o + d * 6e4, i = A.tz(o, a).format("YYYY[-]MM[-]DD[T]HH[:]mm:ss"), c = A.tz(l, a).format("YYYY[-]MM[-]DD[T]HH[:]mm:ss");
  return {
    interviewSlotStartInMillis: o,
    interviewSlotEndInMillis: l,
    interviewSlotStartFormatted: i,
    interviewSlotEndFormatted: c
  };
}, ko = (e, t) => {
  const d = e.start;
  if (e.interviews.length === 0)
    return A(d).tz(t).startOf("day").toDate();
  const n = e.interviews.map((l) => {
    const { time: i, duration: c } = l;
    return Go({
      start: d,
      time: i,
      duration: c,
      timeZone: t
    });
  }).map(
    (l) => l.interviewSlotStartInMillis
  ), r = Math.min(...n);
  return A(r).tz(t).startOf("day").toDate();
};
Ut(A);
const ia = (e) => e.split(".")[0] ?? "", ca = 700, Vo = (e) => e ? `https://${ia(e)}.webex.com` : "https://[Your Webex Domain].webex.com", Kt = (e, t) => e.length > t ? Qa(e, { length: t }) : e, Fd = (e, t, d) => {
  if (!e)
    return "";
  switch (e) {
    case "zoom":
      return "https://zoom.us/[Meeting ID]";
    case "webex":
      return `${t}/${d}/j.php?MTID=[Meeting Specific Code]`;
    case "msteams":
      return "https://teams.microsoft.com/l/meetup-join/[Meeting Specific Code]";
    case "google":
      return "https://meet.google.com/[Conference ID]";
    case "eightbyeight":
      return "https://8x8.vc/8x8/[Conference ID]";
    default:
      return "";
  }
}, xo = (e) => `<ul>${Object.entries(e).map(
  ([a, { domain: n }]) => `<li>${a === Bo.WEBEX ? Fd(
    a,
    Vo(n),
    ia(n)
  ) : Fd(a)}</li>`
).join("").trim()}</ul>`, ze = (e, t) => `${e ? `+${e.replace(/D/g, "")} ` : ""}${t}`, Te = (e) => e ? ` (${e.replace(/_/gi, " ")})` : "", yt = (e, t, d) => A(t).tz(d).set({
  hour: e[0].time / 60,
  minute: e[0].time % 60,
  second: 0,
  millisecond: 0
}).toDate(), Oe = (e, t, d, a, n = !1) => {
  if (!e || !e.length)
    return "";
  const r = Te(d), o = yt(
    e,
    t,
    d
  );
  return `${we(o, d, {
    includeTime: !a,
    is24HourFormat: n
  })}${r}`;
}, ct = (e, t, d, a) => {
  if (!e || !e.length)
    return "";
  const n = A().tz(d).format("z"), r = yt(
    e,
    t,
    d
  ), o = yn(r, d), l = a ? Gd(r, d) : $n(r, d);
  return a ? `${o}, ${l} (${n})` : `${o}, ${l}`;
}, st = (e, t, d, a = !1) => e?.length ? bt(
  yt(e, t, d),
  d,
  a
) : "", sa = (e, t, d) => e?.length ? kd(
  yt(e, t, d),
  d
) : "", Qe = (e) => {
  const [t] = e?.split(" ") ?? [e];
  return t;
}, ut = (e) => {
  const [, ...t] = e?.split(" ") ?? [e];
  return t?.join(" ");
}, ua = (e, t) => {
  const d = {
    location: "[Interview Location]",
    locationAddress: "[Interview Location Address]"
  };
  if (!e || !t)
    return d;
  const a = e?.find(
    ({ key: g }) => g === t
  );
  if (!a)
    return d;
  const {
    name: n,
    address: r,
    addressFormatted: o,
    municipality: l,
    country: i,
    phoneCode: c,
    phoneNumber: s,
    postalCode: u
  } = a, m = o ?? `${r}<br/>
  ${l}, ${i} - ${u.replace(/ /g, "")}<br/>
  (+${c}) ${s}`;
  return { location: n, locationAddress: m };
}, ma = `<ul>
  <li>Day, MMM dd, yyyy 0-12 AM - 0-12 PM</li>
</ul>`, Dl = ({
  inputText: e,
  sender: t,
  interview: d,
  interviewNumber: a,
  timeZone: n,
  interviewSlots: r,
  interviewStartDate: o,
  conference: l,
  workdayLocations: i,
  client: c,
  userSignature: s = "{{MY_FULL_NAME}}<br>{{MY_EMAIL_ADDRESS}}",
  customFieldNames: u = [],
  showScorecardQuestionnaires: m = !0,
  isAutobook: g = void 0,
  preserveNewlines: E = !1
}) => {
  if (!e)
    return "";
  const y = Te(n), { customFields: N = [], customOrganizations: T = [] } = d?.job?.customData ?? {}, O = N.reduce((f, I) => (f[I.label] = I.value, f), {}), M = T.reduce(
    (f, I) => (I.label && (f[`${I.label}_id`] = I.id, f[`${I.label}_name`] = I.name, f[`${I.label}_code`] = I.code, f[`${I.label}_orgType`] = I.orgType, f[`${I.label}_subType`] = I.subType, f[`${I.label}_wid`] = I.wid), f),
    {}
  ), _ = { ...O, ...M }, U = Oe(
    r,
    o,
    n,
    !1
  ), D = Oe(
    r,
    o,
    n,
    !1,
    !0
  ), H = ct(
    r,
    o,
    n,
    !1
  ), de = st(
    r,
    o,
    n
  ), x = st(
    r,
    o,
    n,
    !0
  ), B = sa(
    r,
    o,
    n
  ), G = Oe(
    r,
    o,
    n,
    !0
  ), j = ct(
    r,
    o,
    n,
    !0
  ), W = r?.reduce((f, { duration: I }) => f + +I, 0) || 0, Y = d.recruiters?.map(({ firstName: f, lastName: I }) => `${f} ${I}`.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", ae = d.hiringManagers?.map(({ firstName: f, lastName: I }) => `${f} ${I}`.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", ce = d.recruiters?.map(({ email: f }) => f.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", se = d.hiringManagers?.map(({ email: f }) => f.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", {
    interviewerFirstNames: Z,
    interviewerFullNames: J,
    interviewerFullNamesWithoutTitles: he,
    interviewersListItems: L
  } = la(r), {
    firstName: ne,
    lastName: Ee,
    name: te,
    email: ue
  } = t ?? { firstName: "", lastName: "", name: "", email: "" }, {
    firstName: q,
    lastName: z,
    name: re,
    email: me,
    countryCode: ge = "",
    telephone: Ne = ""
  } = d?.candidate ?? {
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    countryCode: "",
    telephone: ""
  }, { location: fe, locationAddress: pe } = ua(
    i,
    d.clientLocation
  ), K = `https://firebasestorage.googleapis.com/v0/b/${S(
    "REACT_APP_STORAGE_BUCKET"
  )}/o/public%2Flogos%2F${c}?alt=media`, Se = s === null ? "{{MY_FULL_NAME}}<br>{{MY_EMAIL_ADDRESS}}" : s.replace(/{{LOCATION}}/gi, fe).replace(/{{LOCATION_ADDRESS}}/gi, pe).replace(
    /{{LOGO_ORIGINAL}}/gi,
    `<img src='${K}' width='100%' />`
  ).replace(
    /{{LOGO_SMALL}}/gi,
    `<img height='10%' width='10%' src='${K}'  />`
  ).replace(
    /{{LOGO_MEDIUM}}/gi,
    `<img height='50%' width='50%' src='${K}' />`
  );
  let $e = e;
  return Object.keys(_).length !== 0 ? $e = u.reduce((f, I) => {
    const { name: Q, placeholder: p } = I, C = (typeof _[Q] == "string" ? _[Q].trim() : _[Q]) || "No Value Provided";
    return f.replace(
      new RegExp(p, "gi"),
      Array.isArray(C) ? JSON.stringify(C, null, 2) : C
    );
  }, e) : $e = u.reduce((f, I) => {
    const { columnHeadingOverride: Q, placeholder: p } = I;
    return f.replace(
      new RegExp(p, "gi"),
      `[${Q}]`
    );
  }, e), $e.replace(/{{INTERVIEW_START_DATE_TIME_SMS}}/gi, H).replace(/{{INTERVIEW_START_DATE_SMS}}/gi, j).replace(/{{INTERVIEW_SCHEDULE_START_TIME}}/gi, U).replace(
    /{{INTERVIEW_SCHEDULE_START_TIME_24HR}}/gi,
    D
  ).replace(/{{INTERVIEW_START_TIME}}/gi, de).replace(/{{INTERVIEW_START_TIME_24HR}}/gi, x).replace(/{{INTERVIEW_START_TIME_SMS}}/gi, B).replace(/{{MEETING_SCHEDULE_START_TIME}}/gi, U).replace(/{{MEETING_START_TIME}}/gi, de).replace(/{{MEETING_START_TIME_24HR}}/gi, x).replace(/{{MEETING_START_TIME_SMS}}/gi, B).replace(
    /{{MEETING_SCHEDULE_START_TIME_SMS}}/gi,
    H
  ).replace(/{{MEETING_START_DATE_SMS}}/gi, j).replace(/{{INTERVIEW_START_DATE}}/gi, G).replace(/{{MEETING_START_DATE}}/gi, G).replace(
    /{{INTERVIEW_DURATION}}/gi,
    A.duration(W, "minutes").format(
      `h [hours]${W % 60 > 0 ? " m [minutes]" : ""}`
    )
  ).replace(
    /{{MEETING_DURATION}}/gi,
    A.duration(W, "minutes").format(
      `h [hours]${W % 60 > 0 ? " m [minutes]" : ""}`
    )
  ).replace(/{{INTERVIEWER_FIRST_NAMES}}/gi, Z).replace(/{{HOST_FIRST_NAMES}}/gi, Z).replace(/{{RECRUITERS}}/gi, Y).replace(/{{HIRING_MANAGERS}}/gi, ae).replace(/{{RECRUITER_EMAILS}}/gi, ce).replace(/{{HIRING_MANAGER_EMAILS}}/gi, se).replace(/{{INTERVIEWER_FULL_NAMES}}/gi, J).replace(/{{HOST_FULL_NAMES}}/gi, J).replace(
    /{{INTERVIEWERS_WITHOUT_TITLES}}/gi,
    he
  ).replace(
    /{{INTERVIEWERS_NUMBERED_LIST}}/gi,
    `<ol>${L.join(`
`)}</ol>`
  ).replace(
    /{{INTERVIEWERS_BULLETED_LIST}}/gi,
    `<ul>${L.join(`
`)}</ul>`
  ).replace(/{{LOCATION}}/gi, fe).replace(/{{LOCATION_ADDRESS}}/gi, pe).replace(
    /{{INTERVIEW_SCHEDULE_TABLE}}/gi,
    hd(
      r,
      o,
      n,
      y,
      a,
      !1,
      m
    )
  ).replace(
    /{{INTERVIEW_SCHEDULE_TABLE_24HR}}/gi,
    hd(
      r,
      o,
      n,
      y,
      a,
      !1,
      m,
      !0
    )
  ).replace(
    /{{INTERVIEW_SCHEDULE}}/gi,
    nt(
      r,
      o,
      n,
      y,
      a,
      !1,
      m
    )
  ).replace(
    /{{INTERVIEW_SCHEDULE_24HR}}/gi,
    nt(
      r,
      o,
      n,
      y,
      a,
      !1,
      m,
      !0
    )
  ).replace(
    /{{INTERVIEW_SCHEDULE_INTERVIEWER_FIRST_NAMES}}/gi,
    nt(
      r,
      o,
      n,
      y,
      a,
      !0,
      m
    )
  ).replace(
    /{{INTERVIEW_SCHEDULE_INTERVIEWER_FIRST_NAMES_24HR}}/gi,
    nt(
      r,
      o,
      n,
      y,
      a,
      !0,
      m,
      !0
    )
  ).replace(/{{MY_SIGNATURE}}/gi, Se).replace(
    /{{MY_FIRST_NAME}}/gi,
    ne || Qe(te)
  ).replace(
    /{{MY_LAST_NAME}}/gi,
    Ee || ut(te)
  ).replace(/{{MY_FULL_NAME}}/gi, te).replace(/{{MY_EMAIL_ADDRESS}}/gi, ue).replace(
    /{{CANDIDATE_FIRST_NAME}}/gi,
    ye(q ?? "")
  ).replace(
    /{{CANDIDATE_LAST_NAME}}/gi,
    ye(z ?? "")
  ).replace(
    /{{CANDIDATE_FULL_NAME}}/gi,
    ye(
      re ?? `${q} ${z}`
    )
  ).replace(
    /{{ATTENDEE_FULL_NAME}}/gi,
    ye(
      re ?? `${q} ${z}`
    )
  ).replace(/{{CANDIDATE_EMAIL}}/gi, me).replace(/{{ATTENDEE_EMAIL}}/gi, me).replace(
    /{{CANDIDATE_PHONE}}/gi,
    ze(ge, Ne)
  ).replace(
    /{{ATTENDEE_PHONE}}/gi,
    ze(ge, Ne)
  ).replace(/{{JOB_NAME}}/gi, d?.job?.title ?? "").replace(/{{JOB_DESCRIPTION}}/gi, d?.job?.description?.html ?? "").replace(
    /{{ADDITIONAL_JOB_DESCRIPTION}}/gi,
    d?.job?.additionalJobDescription ? Kt(
      d?.job?.additionalJobDescription,
      ca
    ) : "No Additional Job Description Available"
  ).replace(
    /{{JOB_DESCRIPTION_SUMMARY}}/gi,
    d?.job?.jobDescriptionSummary ?? "No Job Description Summary Available"
  ).replace(/{{JOB_REQ_ID}}/gi, d?.job?.requisitionID ?? "").replace(
    /{{JOB_APPLICATION_LINK}}/gi,
    "https://[Workday URL]/d/inst/[Job Application ID]/rel-task/2998$20485.htmld"
  ).replace(
    /{{INTERVIEW_TYPE}}/gi,
    xe(
      r.flatMap(
        ({ conferencing: f }) => f.filter(({ type: I }) => I === "conferencing").map(({ name: I }) => I)
      )
    ).join("/")
  ).replace(/{{LOGO_ORIGINAL}}/gi, `<img src='${K}' width='100%' />`).replace(
    /{{LOGO_SMALL}}/gi,
    `<img height='10%' width='10%' src='${K}'  />`
  ).replace(
    /{{LOGO_MEDIUM}}/gi,
    `<img height='50%' width='50%' src='${K}' />`
  ).replace(
    /{{SCORECARD_LINK}}/gi,
    `${ot()}/link/scorecard/[Interview ID]`
  ).replace(
    /{{INTERVIEWER_INBOX_ONLY}}/gi,
    `${ot()}/link/scorecard/[Interview ID]`
  ).replace(
    /{{SCORECARD}}/gi,
    xe(
      r.flatMap(
        ({ skills: f }) => f.filter(
          ({ type: I }) => ["competency", "questionnaire"].includes(I)
        ).map(({ name: I }) => I)
      )
    ).sort((f, I) => f.localeCompare(I)).join(", ")
  ).replace(
    /{{VIDEO_CONFERENCE_LINK}}/gi,
    l && Object.keys(l).length ? xo(l) : "No Video Conference Available"
  ).replace(/{{CANDIDATE_REFERENCE_ID}}/gi, "[Candidate Reference ID]").replace(/{{JOB_REFERENCE_ID}}/gi, "[Job Reference ID]").replace(
    /{{AVAILABILITY_LINK}}/gi,
    (() => {
      const f = Hd();
      return typeof f == "string" ? `${f}/candidate/availability/[Unique ID]` : `${g === !0 ? f?.candidateAutobook : g === !1 ? f?.candidateAvailability : f?.genericExternalAppUrl}/candidate/availability/[Unique ID]`;
    })()
  ).replace(/{{SELECTED_TIMES}}/gi, ma).replace(/{{SELECTED_TIME_ZONE}}/gi, "[Selected Time Zone]").replace(
    /{{INTERVIEWER_PREFERENCES_LINK}}/gi,
    "[AUTO GENERATED INTERVIEWER PREFERENCES LINK]"
  ).replace(
    /{{INTERVIEWER_PORTAL_BUTTON}}/gi,
    "[AUTO GENERATED INTERVIEWER PORTAL BUTTON]"
  ).replace(/{{PERSONAL_MEETING_LINK}}/gi, "[PERSONAL MEETING LINK]").replace(/{{HACKERRANK_INTERVIEW_LINK}}/gi, "[HACKERRANK INTERVIEW LINK]").replace(/\n/gi, E ? `
` : "");
}, Ho = (e, t) => e.some((d) => d.type === t), Wo = (e) => ["zoom", "webex", "msteams", "google", "eightbyeight"].some(
  (t) => Ho(e, t)
), Ko = (e) => !e || !e.length ? !1 : e.some(
  (d) => Wo(d.conferencing)
), vl = ({
  inputText: e,
  interview: t,
  eventSlotIndex: d,
  otherInterviews: a,
  jobApplication: n,
  sender: r,
  workdayLocations: o,
  client: l,
  userSignature: i = "{{MY_FULL_NAME}}<br>{{MY_EMAIL_ADDRESS}}",
  showScorecardQuestionnaires: c,
  customFieldNames: s = [],
  isAutobook: u = void 0,
  preserveNewlines: m = !1
}) => {
  if (!e || !t)
    return "";
  const { timeZone: g, interviews: E } = t, y = ko(t, g), N = Ko(E);
  Te(g);
  const T = Oe(
    E,
    y,
    g,
    !1
  ), O = Oe(
    E,
    y,
    g,
    !1,
    !0
  ), M = ct(
    E,
    y,
    g,
    !1
  ), _ = st(
    E,
    y,
    g
  ), U = st(
    E,
    y,
    g,
    !0
  ), D = sa(
    E,
    y,
    g
  ), { customFields: H = [], customOrganizations: de = [] } = n?.job?.customData ?? {}, x = H.reduce((p, C) => (p[C.label] = C.value, p), {}), B = de.reduce(
    (p, C) => (C.label && (p[`${C.label}_id`] = C.id, p[`${C.label}_name`] = C.name, p[`${C.label}_code`] = C.code, p[`${C.label}_orgType`] = C.orgType, p[`${C.label}_subType`] = C.subType, p[`${C.label}_wid`] = C.wid), p),
    {}
  ), G = { ...x, ...B }, j = Oe(
    E,
    y,
    g,
    !0
  ), W = ct(
    E,
    y,
    g,
    !0
  ), Y = E?.reduce(
    (p, { duration: C }) => p + +C,
    0
  ) || 0, ae = a?.flatMap((p) => p.events) ?? [], ce = [...E || [], ...ae], se = t.recruiters?.map(({ firstName: p, lastName: C }) => `${p} ${C}`.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", Z = t.hiringManagers?.map(({ firstName: p, lastName: C }) => `${p} ${C}`.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", J = t.recruiters?.map(({ email: p }) => p.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", he = t.hiringManagers?.map(({ email: p }) => p.trim())?.join(", ")?.replace(/,(?=[^,]+$)/, " and") ?? "", {
    interviewerFirstNames: L,
    interviewerFullNames: ne,
    interviewerFullNamesWithoutTitles: Ee,
    interviewersListItems: te
  } = la(ce), {
    firstName: ue,
    lastName: q,
    name: z,
    email: re
  } = r ?? { firstName: "", lastName: "", name: "", email: "" }, {
    firstName: me,
    lastName: ge,
    name: Ne,
    email: fe,
    countryCode: pe = "",
    telephone: K = ""
  } = t?.candidate ?? {
    firstName: "",
    lastName: "",
    name: "",
    email: "",
    countryCode: "",
    telephone: ""
  }, { location: Se, locationAddress: $e } = ua(
    o,
    t.clientLocation
  ), f = `https://firebasestorage.googleapis.com/v0/b/${S(
    "REACT_APP_STORAGE_BUCKET"
  )}/o/public%2Flogos%2F${l}?alt=media`, I = i === null ? "{{MY_FULL_NAME}}<br>{{MY_EMAIL_ADDRESS}}" : i.replace(/{{LOCATION}}/gi, Se).replace(/{{LOCATION_ADDRESS}}/gi, $e).replace(
    /{{LOGO_ORIGINAL}}/gi,
    `<img src='${f}' width='100%' />`
  ).replace(
    /{{LOGO_SMALL}}/gi,
    `<img height='10%' width='10%' src='${f}'  />`
  ).replace(
    /{{LOGO_MEDIUM}}/gi,
    `<img height='50%' width='50%' src='${f}' />`
  );
  let Q = e;
  return Object.keys(G).length !== 0 ? Q = s.reduce((p, C) => {
    const { name: Ce, placeholder: Be } = C, Ge = (typeof G[Ce] == "string" ? G[Ce].trim() : G[Ce]) || "No Value Provided";
    return p.replace(
      new RegExp(Be, "gi"),
      Array.isArray(Ge) ? JSON.stringify(Ge, null, 2) : Ge
    );
  }, e) : Q = s.reduce((p, C) => {
    const { columnHeadingOverride: Ce, placeholder: Be } = C;
    return p.replace(
      new RegExp(Be, "gi"),
      `[${Ce}]`
    );
  }, e), Q.replace(/{{INTERVIEW_START_DATE_TIME_SMS}}/gi, M).replace(/{{INTERVIEW_START_DATE_SMS}}/gi, W).replace(/{{INTERVIEW_SCHEDULE_START_TIME}}/gi, T).replace(
    /{{INTERVIEW_SCHEDULE_START_TIME_24HR}}/gi,
    O
  ).replace(/{{INTERVIEW_START_TIME}}/gi, _).replace(/{{INTERVIEW_START_TIME_24HR}}/gi, U).replace(/{{INTERVIEW_START_TIME_SMS}}/gi, D).replace(/{{MEETING_SCHEDULE_START_TIME}}/gi, T).replace(/{{MEETING_START_TIME}}/gi, _).replace(/{{MEETING_START_TIME_24HR}}/gi, U).replace(/{{MEETING_START_TIME_SMS}}/gi, D).replace(
    /{{MEETING_SCHEDULE_START_TIME_SMS}}/gi,
    M
  ).replace(/{{MEETING_START_DATE_SMS}}/gi, W).replace(/{{INTERVIEW_START_DATE}}/gi, j).replace(/{{MEETING_START_DATE}}/gi, j).replace(
    /{{INTERVIEW_DURATION}}/gi,
    A.duration(Y, "minutes").format(
      `h [hours]${Y % 60 > 0 ? " m [minutes]" : ""}`
    )
  ).replace(
    /{{MEETING_DURATION}}/gi,
    A.duration(Y, "minutes").format(
      `h [hours]${Y % 60 > 0 ? " m [minutes]" : ""}`
    )
  ).replace(/{{INTERVIEWER_FIRST_NAMES}}/gi, L).replace(/{{HOST_FIRST_NAMES}}/gi, L).replace(/{{RECRUITERS}}/gi, se).replace(/{{HIRING_MANAGERS}}/gi, Z).replace(/{{RECRUITER_EMAILS}}/gi, J).replace(/{{HIRING_MANAGER_EMAILS}}/gi, he).replace(/{{INTERVIEWER_FULL_NAMES}}/gi, ne).replace(/{{HOST_FULL_NAMES}}/gi, ne).replace(
    /{{INTERVIEWERS_WITHOUT_TITLES}}/gi,
    Ee
  ).replace(
    /{{INTERVIEWERS_NUMBERED_LIST}}/gi,
    `<ol>${te.join(`
`)}</ol>`
  ).replace(
    /{{INTERVIEWERS_BULLETED_LIST}}/gi,
    `<ul>${te.join(`
`)}</ul>`
  ).replace(/{{LOCATION}}/gi, Se).replace(/{{LOCATION_ADDRESS}}/gi, $e).replace(
    /{{INTERVIEW_SCHEDULE_TABLE}}/gi,
    Me({
      interview: t,
      otherInterviews: a,
      slotIndex: d,
      isTable: !0,
      showScorecardQuestionnaires: c
    })
  ).replace(
    /{{INTERVIEW_SCHEDULE_TABLE_24HR}}/gi,
    Me({
      interview: t,
      otherInterviews: a,
      slotIndex: d,
      isTable: !0,
      showScorecardQuestionnaires: c,
      is24HourFormat: !0
    })
  ).replace(
    /{{INTERVIEW_SCHEDULE}}/gi,
    Me({
      interview: t,
      otherInterviews: a,
      slotIndex: d,
      showScorecardQuestionnaires: c
    })
  ).replace(
    /{{INTERVIEW_SCHEDULE_24HR}}/gi,
    Me({
      interview: t,
      otherInterviews: a,
      slotIndex: d,
      showScorecardQuestionnaires: c,
      is24HourFormat: !0
    })
  ).replace(
    /{{INTERVIEW_SCHEDULE_INTERVIEWER_FIRST_NAMES}}/gi,
    Me({
      interview: t,
      otherInterviews: a,
      slotIndex: d,
      onlyAttendeeFirstNames: !0,
      showScorecardQuestionnaires: c
    })
  ).replace(
    /{{INTERVIEW_SCHEDULE_INTERVIEWER_FIRST_NAMES_24HR}}/gi,
    Me({
      interview: t,
      otherInterviews: a,
      slotIndex: d,
      onlyAttendeeFirstNames: !0,
      showScorecardQuestionnaires: c,
      is24HourFormat: !0
    })
  ).replace(/{{MY_SIGNATURE}}/gi, I).replace(
    /{{MY_FIRST_NAME}}/gi,
    ue || Qe(z)
  ).replace(
    /{{MY_LAST_NAME}}/gi,
    q || ut(z)
  ).replace(/{{MY_FULL_NAME}}/gi, z).replace(/{{MY_EMAIL_ADDRESS}}/gi, re).replace(
    /{{CANDIDATE_FIRST_NAME}}/gi,
    ye(me ?? "")
  ).replace(
    /{{CANDIDATE_LAST_NAME}}/gi,
    ye(ge ?? "")
  ).replace(
    /{{CANDIDATE_FULL_NAME}}/gi,
    ye(
      Ne ?? `${me} ${ge}`
    )
  ).replace(
    /{{ATTENDEE_FULL_NAME}}/gi,
    ye(
      Ne ?? `${me} ${ge}`
    )
  ).replace(/{{CANDIDATE_EMAIL}}/gi, fe).replace(/{{ATTENDEE_EMAIL}}/gi, fe).replace(
    /{{CANDIDATE_PHONE}}/gi,
    ze(pe, K)
  ).replace(
    /{{ATTENDEE_PHONE}}/gi,
    ze(pe, K)
  ).replace(
    /{{JOB_NAME}}/gi,
    (n?.job.title || t?.job?.title) ?? ""
  ).replace(
    /{{JOB_DESCRIPTION}}/gi,
    (n?.job?.description?.html || t?.job?.description?.html) ?? ""
  ).replace(
    /{{ADDITIONAL_JOB_DESCRIPTION}}/gi,
    n?.job?.additionalJobDescription || t?.job?.additionalJobDescription ? Kt(
      n?.job?.additionalJobDescription || t?.job?.additionalJobDescription,
      ca
    ) : "No Additional Job Description Available"
  ).replace(
    /{{JOB_DESCRIPTION_SUMMARY}}/gi,
    (n?.job?.jobDescriptionSummary || t?.job?.jobDescriptionSummary) ?? "No Job Description Summary Available"
  ).replace(
    /{{JOB_REQ_ID}}/gi,
    (n?.job?.requisitionID || t?.job?.requisitionID) ?? ""
  ).replace(
    /{{JOB_APPLICATION_LINK}}/gi,
    "https://[Workday URL]/d/inst/[Job Application ID]/rel-task/2998$20485.htmld"
  ).replace(
    /{{INTERVIEW_TYPE}}/gi,
    xe(
      E?.flatMap(
        ({ conferencing: p }) => (p || []).filter(({ type: C }) => C === "conferencing").map(({ name: C }) => C)
      ) || []
    ).join("/")
  ).replace(/{{LOGO_ORIGINAL}}/gi, `<img src='${f}' width='100%' />`).replace(
    /{{LOGO_SMALL}}/gi,
    `<img height='10%' width='10%' src='${f}'  />`
  ).replace(
    /{{LOGO_MEDIUM}}/gi,
    `<img height='50%' width='50%' src='${f}' />`
  ).replace(
    /{{SCORECARD_LINK}}/gi,
    `${ot()}/link/scorecard/[Interview ID]`
  ).replace(
    /{{INTERVIEWER_INBOX_ONLY}}/gi,
    `${ot()}/link/scorecard/[Interview ID]`
  ).replace(
    /{{SCORECARD}}/gi,
    xe(
      E?.flatMap(
        ({ skills: p }) => (p || []).filter(
          ({ type: C }) => ["competency", "questionnaire"].includes(C)
        ).map(({ name: C }) => C)
      ) || []
    ).sort((p, C) => p.localeCompare(C)).join(", ") || "NA"
  ).replace(
    /{{VIDEO_CONFERENCE_LINK}}/gi,
    N ? "[[Video Conference link will be inserted here]]" : "No Video Conference Available"
  ).replace(/{{CANDIDATE_REFERENCE_ID}}/gi, "[Candidate Reference ID]").replace(/{{JOB_REFERENCE_ID}}/gi, "[Job Reference ID]").replace(
    /{{AVAILABILITY_LINK}}/gi,
    (() => {
      const p = Hd();
      return typeof p == "string" ? `${p}/candidate/availability/[Unique ID]` : `${u === !0 ? p?.candidateAutobook : u === !1 ? p?.candidateAvailability : p?.genericExternalAppUrl}/candidate/availability/[Unique ID]`;
    })()
  ).replace(/{{SELECTED_TIMES}}/gi, ma).replace(/{{SELECTED_TIME_ZONE}}/gi, t.timeZone).replace(
    /{{INTERVIEWER_PREFERENCES_LINK}}/gi,
    "[AUTO GENERATED INTERVIEWER PREFERENCES LINK]"
  ).replace(
    /{{INTERVIEWER_PORTAL_BUTTON}}/gi,
    "[AUTO GENERATED INTERVIEWER PORTAL BUTTON]"
  ).replace(/{{PERSONAL_MEETING_LINK}}/gi, "[PERSONAL MEETING LINK]").replace(/{{HACKERRANK_INTERVIEW_LINK}}/gi, "[HACKERRANK INTERVIEW LINK]").replace(/\n/gi, m ? `
` : "");
};
Ut(A);
const jo = 500, X = {
  // Brief Information (Available for all sources)
  BRIEF: [
    // "{{BRIEF_TITLE}}",
    // "{{BRIEF_DESCRIPTION}}",
    "{{BRIEF_START_TIME}}",
    "{{BRIEF_START_TIME_24HR}}",
    "{{BRIEF_START_TIME_SMS}}",
    "{{BRIEF_TIME}}",
    "{{BRIEF_TIME_24HR}}",
    "{{BRIEF_TIME_SMS}}",
    "{{BRIEF_START_DATE}}",
    "{{BRIEF_START_DATE_SMS}}",
    "{{BRIEF_END_TIME}}",
    "{{BRIEF_END_TIME_24HR}}",
    "{{BRIEF_DURATION}}",
    "{{BRIEF_TIME_ZONE}}",
    "{{BRIEF_SCHEDULE}}",
    "{{BRIEF_SCHEDULE_24HR}}",
    "{{BRIEF_SCHEDULE_TABLE}}",
    "{{BRIEF_SCHEDULE_TABLE_24HR}}",
    "{{BRIEF_SCHEDULE_ATTENDEE_FIRST_NAMES}}",
    "{{BRIEF_SCHEDULE_ATTENDEE_FIRST_NAMES_24HR}}",
    "{{INTERVIEW_TYPE}}",
    "{{INTERVIEWER_PORTAL_BUTTON}}",
    "{{JOB_APPLICATION_LINK}}"
  ],
  // Candidate Information (Singular - first candidate)
  CANDIDATE_SINGULAR: [
    "{{CANDIDATE_FIRST_NAME}}",
    "{{CANDIDATE_LAST_NAME}}",
    "{{CANDIDATE_FULL_NAME}}",
    "{{CANDIDATE_EMAIL}}",
    "{{CANDIDATE_PHONE}}"
  ],
  // Candidate Information (Plural - all candidates)
  CANDIDATE_PLURAL: [
    "{{CANDIDATES_FULL_NAMES}}",
    "{{CANDIDATES_EMAILS}}",
    "{{CANDIDATES_BULLETED_LIST}}",
    "{{CANDIDATES_NUMBERED_LIST}}",
    "{{ALL_CANDIDATES_BRIEFS}}"
  ],
  // Attendee Information (Brief participants)
  ATTENDEE: [
    "{{ATTENDEE_FIRST_NAMES}}",
    "{{ATTENDEE_FULL_NAMES}}",
    "{{ATTENDEES_WITHOUT_TITLES}}",
    "{{ATTENDEES_BULLETED_LIST}}",
    "{{ATTENDEES_NUMBERED_LIST}}"
  ],
  // Job Information (Requires jobApp or jobReq)
  JOB: [
    "{{JOB_NAME}}",
    "{{JOB_DESCRIPTION}}",
    "{{ADDITIONAL_JOB_DESCRIPTION}}",
    "{{JOB_DESCRIPTION_SUMMARY}}",
    "{{JOB_REQ_ID}}",
    "{{HIRING_MANAGERS}}",
    "{{HIRING_MANAGER_EMAILS}}",
    "{{RECRUITERS}}",
    "{{RECRUITER_EMAILS}}"
  ],
  // Sender/User Information (Available for all sources)
  SENDER: [
    "{{MY_FIRST_NAME}}",
    "{{MY_LAST_NAME}}",
    "{{MY_FULL_NAME}}",
    "{{MY_EMAIL_ADDRESS}}",
    "{{MY_SIGNATURE}}"
  ],
  // Location & Meeting (Available for all sources)
  LOCATION: [
    "{{LOCATION}}",
    "{{LOCATION_ADDRESS}}",
    "{{VIDEO_CONFERENCE_LINK}}"
  ],
  // Branding (Available for all sources)
  BRANDING: ["{{LOGO_ORIGINAL}}", "{{LOGO_SMALL}}", "{{LOGO_MEDIUM}}"],
  // Custom Fields (Only available for MANUAL source with jobApp)
  CUSTOM_FIELDS: [
    "{{CUSTOM_FIELD_*}}"
    // Dynamic placeholder
  ]
}, Ol = (e) => {
  const t = [
    ...X.BRIEF,
    ...X.ATTENDEE,
    ...X.SENDER,
    ...X.LOCATION,
    ...X.BRANDING
  ];
  switch (e) {
    case "MANUAL":
      return [
        ...t,
        ...X.CANDIDATE_SINGULAR,
        ...X.JOB,
        ...X.CUSTOM_FIELDS
      ];
    case "REQUISITION_HUB":
      return [
        ...t,
        ...X.CANDIDATE_PLURAL,
        ...X.JOB
      ];
    case "INTERVIEWER_SCREEN":
      return t;
    default:
      return t;
  }
}, Pl = () => Object.entries(X).filter(([e]) => e !== "CUSTOM_FIELDS").flatMap(([, e]) => e), Yo = (e) => {
  const t = {
    location: "[Brief Location]",
    locationAddress: "[Brief Location Address]"
  };
  if (!e)
    return t;
  const {
    name: d,
    address: a,
    addressFormatted: n,
    municipality: r,
    country: o,
    countryRegion: l,
    phoneCode: i,
    phoneNumber: c,
    postalCode: s
  } = e, m = n ?? `${a || ""}<br/>
  ${r || ""}, ${o || l || ""} - ${s?.replace(/ /g, "") || ""}<br/>
  (+${i || ""}) ${c || ""}`;
  return { location: d, locationAddress: m };
}, Ve = (e, t, d = !0, a = !1) => {
  if (!e)
    return "";
  const n = Te(t);
  return `${we(e, t, {
    includeTime: !d,
    is24HourFormat: a
  })}${n}`;
}, bd = (e, t, d = !0) => e ? we(e, t, {
  includeTime: !d,
  includeTimezoneAbbr: !0
}) : "", Zo = (e) => {
  if (!e || !e.length)
    return {
      attendeeFirstNames: "[Attendee First Names]",
      attendeeFullNames: "[Attendee Full Names]",
      attendeeFullNamesWithoutTitles: "[Attendee Full Names]",
      attendeesListItems: []
    };
  const t = e.filter(
    (o) => !o.isOptional
  );
  if (!t.length)
    return {
      attendeeFirstNames: "[Attendee First Names]",
      attendeeFullNames: "[Attendee Full Names]",
      attendeeFullNamesWithoutTitles: "[Attendee Full Names]",
      attendeesListItems: []
    };
  const d = t.map(({ firstName: o, name: l }) => o || Qe(l)).join(", ").replace(/,(?=[^,]+$)/, " and"), a = t.map(
    ({ name: o, firstName: l, lastName: i, title: c }) => o || c ? `${l} ${i} - ${c}`.trim() : `${l} ${i}`.trim()
  ).join(", ").replace(/,(?=[^,]+$)/, " and"), n = t.map(
    ({ name: o, firstName: l, lastName: i }) => o || `${l} ${i}`.trim()
  ).join(", ").replace(/,(?=[^,]+$)/, " and"), r = t.map(
    ({ name: o, firstName: l, lastName: i, title: c }) => {
      const s = o || `${l} ${i}`.trim();
      return `<li>${c ? `${s} - ${c}` : s}</li>`;
    }
  );
  return {
    attendeeFirstNames: d,
    attendeeFullNames: a,
    attendeeFullNamesWithoutTitles: n,
    attendeesListItems: r
  };
}, Jo = (e) => {
  if (!e || !e.length)
    return {
      candidateFirstName: "[Candidate First Name]",
      candidateLastName: "[Candidate Last Name]",
      candidateFullName: "[Candidate Name]",
      candidateEmail: "[Candidate Email]",
      candidatePhone: "[Candidate Phone]",
      candidatesFullNames: "[Candidate Names]",
      candidatesEmails: "[Candidate Emails]",
      candidatesListItems: []
    };
  const t = e[0], d = t?.firstName || "[Candidate First Name]", a = t?.lastName || "[Candidate Last Name]", n = t?.name || `${t?.firstName} ${t?.lastName}`.trim() || "[Candidate Name]", r = t?.email || "[Candidate Email]", o = t?.telephone ? ze(
    t?.countryCode || "",
    t?.telephone
  ) : "[Candidate Phone]", l = e.map(
    ({ name: s, firstName: u, lastName: m }) => s || `${u} ${m}`.trim()
  ).join(", ").replace(/,(?=[^,]+$)/, " and"), i = e.map(({ email: s }) => s).join(", ").replace(/,(?=[^,]+$)/, " and"), c = e.map(
    ({ name: s, firstName: u, lastName: m }) => `<li>${s || `${u} ${m}`.trim()}</li>`
  );
  return {
    candidateFirstName: d,
    candidateLastName: a,
    candidateFullName: n,
    candidateEmail: r,
    candidatePhone: o,
    candidatesFullNames: l,
    candidatesEmails: i,
    candidatesListItems: c
  };
}, qo = (e) => {
  if (!e?.hiringManagers)
    return { names: "[Hiring Managers]", emails: "[Hiring Manager Emails]" };
  const t = Array.isArray(e.hiringManagers) ? e.hiringManagers : [];
  if (!t.length)
    return { names: "[Hiring Managers]", emails: "[Hiring Manager Emails]" };
  const d = t.map(
    ({ firstName: n, lastName: r, name: o }) => o || `${n} ${r}`.trim()
  ).join(", ").replace(/,(?=[^,]+$)/, " and"), a = t.map(({ email: n }) => n).join(", ").replace(/,(?=[^,]+$)/, " and");
  return { names: d, emails: a };
}, zo = (e) => {
  if (!e?.recruiters)
    return { names: "[Recruiters]", emails: "[Recruiter Emails]" };
  const t = Array.isArray(e.recruiters) ? e.recruiters : [];
  if (!t.length)
    return { names: "[Recruiters]", emails: "[Recruiter Emails]" };
  const d = t.map(
    ({ firstName: n, lastName: r, name: o }) => o || `${n} ${r}`.trim()
  ).join(", ").replace(/,(?=[^,]+$)/, " and"), a = t.map(({ email: n }) => n).join(", ").replace(/,(?=[^,]+$)/, " and");
  return { names: d, emails: a };
}, Qo = (e) => e ? Object.entries(e).reduce(
  (t, [d, a]) => {
    if (!a)
      return t;
    const n = Array.isArray(a) ? a : [a];
    if (!n?.[0])
      return t;
    const r = n.map((o) => {
      if (o?.deleted)
        return null;
      const { joinURL: l, meetingPassword: i, password: c, meetingKey: s, meetingID: u } = o, m = {
        conferenceType: d,
        joinURL: l
      };
      return ["zoom", "webex"].includes(d) && (m.password = i ?? c ?? "", s != null && (m.meetingKey = s)), d === "msteams" && (m.displayName = "Teams Meeting Link", m.meetingCode = o?.meetingCode ? o.meetingCode.toString().replace(/\d{3}(?=.)/g, "$& ") : "", m.password = o?.password ?? ""), d === "google" && (m.displayName = "Google Meet", o?.conferenceId && (m.meetingCode = o.conferenceId)), m;
    }).filter(Boolean);
    return t.concat(r);
  },
  []
) : [], Xo = (e) => e.length ? `<ul>${e.map(
  ({ joinURL: d, password: a, displayName: n, meetingCode: r, meetingKey: o }) => {
    const l = a ? a.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;") : "", i = r || o ? `<strong>Meeting ID</strong>: ${r || o}` : "", c = l ? `(Password: <strong>${l}</strong>)` : "";
    if ((r || o) && l) {
      const s = `(${i}, <strong>Password</strong>: ${l})`;
      return `<li><a href="${d}">${n ?? d}</a></li> ${s}`;
    }
    return `<li><a href="${d}">${n ?? d}</a></li> ${c} ${i}`.trim();
  }
).join("").trim()}</ul>` : "", e2 = (e, t, d = !1) => {
  if (d)
    return "[[Video Conference link will be inserted here]]";
  if (t) {
    const n = Qo(
      t
    );
    if (n.length > 0)
      return Xo(n);
  }
  if (e && e.length > 0) {
    const n = e.filter(
      (r) => r.value && r.value !== ""
    );
    return n.length > 0 ? `<ul>${n.map(
      (o) => `<li><a href="${o.value}">${o.name || o.value}</a></li>`
    ).join("")}</ul>` : "[[Video Conference link will be inserted here]]";
  }
  return "No Video Conference Available";
}, ga = (e, t, d = !1) => t ? e ? t : d ? `<a href='${t}'>${t}</a>` : `<a href='${t}' target='_blank' rel='noopener noreferrer'>${t}</a>` : "https://[Workday URL]/d/inst/[Job Application ID]/rel-task/2998$20485.htmld", Ld = (e, t, d, a) => {
  const n = d ?? "", r = a ?? "";
  let o = e;
  return o = o.replace(
    new RegExp(`href="\\{\\{${t}\\}\\}"`, "gi"),
    () => `href="${n}"`
  ), o = o.replace(
    new RegExp(`href='\\{\\{${t}\\}\\}'`, "gi"),
    () => `href='${n}'`
  ), o = o.replace(
    new RegExp(`href=\\{\\{${t}\\}\\}`, "gi"),
    () => `href="${n}"`
  ), o = o.replace(
    new RegExp(`>\\s*\\{\\{${t}\\}\\}\\s*</a>`, "gi"),
    () => `>${n}</a>`
  ), o = o.replace(
    new RegExp(`\\{\\{${t}\\}\\}`, "gi"),
    () => r
  ), o;
}, $a = (e, t) => !e?.app_url || !e?.tenant || !t ? "" : `${e.app_url}/${e.tenant}/d/inst/${t}/rel-task/2998$20485.htmld`, t2 = (e, t) => {
  if (!e || e.length === 0)
    return "";
  const d = e.filter(
    (l) => l && (l.name || l.firstName || l.lastName)
  );
  if (d.length === 0)
    return "";
  const a = "border-collapse: collapse; width: 100%; font-family: Arial, sans-serif; font-size: 14px; border: 1px solid #dddddd;", n = "background-color: #f2f2f2; font-weight: bold; padding: 12px; text-align: left; border: 1px solid #dddddd;", r = "padding: 12px; border: 1px solid #dddddd; vertical-align: top;", o = d.map((l) => {
    const i = l.name || `${l.firstName || ""} ${l.lastName || ""}`.trim() || l.email || "Unknown Candidate", c = l.applicationWID, s = $a(t, c), u = ga(!1, s, !1);
    return `
    <tr>
      <td style="${r}">${i}</td>
      <td style="${r}">${u}</td>
    </tr>`;
  }).join("");
  return `
<table style="${a}">
  <thead>
    <tr>
      <th style="${n}">Candidate Name</th>
      <th style="${n}">Workday Job Application Link</th>
    </tr>
  </thead>
  <tbody>${o}
  </tbody>
</table>`;
}, ya = (e) => {
  if (!e || e.length === 0)
    return "";
  const t = e.filter((a) => a.type === "conferencing" && a.name).map((a) => a.name);
  return Array.from(new Set(t)).join("/");
}, Ea = (e, t) => {
  if (!e || e.length === 0)
    return "";
  const d = e.filter(
    (n) => !n.isOptional
  );
  return d.length ? `<ul>${d.map(
    ({ firstName: n, lastName: r, title: o }) => {
      const l = t ? n.trim() : `${n} ${r}`.trim(), i = o ? ` (${o})` : "";
      return `<li>${l}${i}</li>`;
    }
  ).join("")}</ul>` : "";
}, Na = (e) => {
  if (!e || e.length === 0)
    return "";
  const t = [], d = ya(e);
  d && t.push(`<li>Type: ${d}</li>`);
  const a = e.filter((r) => r.type === "room" && r.name).map((r) => r.name);
  a.length > 0 && t.push(`<li>Location: ${a.join(", ")}</li>`);
  const n = e.filter(
    (r) => !["conferencing", "room", "comment"].includes(r.type) && r.name
  ).map((r) => r.name);
  return n.length > 0 && t.push(`<li>Conferencing: ${n.join(", ")}</li>`), t.length > 0 ? `<ul>${t.join("")}</ul>` : "";
}, rt = (e, t, d, a, n, r, o, l) => {
  const i = Te(d), c = we(e, d), s = le(e, d, o), u = le(t, d, o), m = `${s} - ${u}${i}`, g = "Attendees: ", E = Ea(a, r), y = Na(n), N = l ? `<li>Notes: ${l}</li>` : "";
  return `<ul><li>${c}<ul><li>${m}<ul><li>${g}${E}</li></ul>${y}${N}</li></ul></li></ul>`;
}, Md = (e, t, d, a, n, r, o, l, i) => {
  const c = Te(a), s = we(e, a), u = le(e, a, l), m = le(t, a, l), g = `${u} - ${m}${c}`, E = A.duration(d, "minutes").format(`h [hours]${d % 60 > 0 ? " m [minutes]" : ""}`), y = "Attendees: ", N = Ea(n, o), T = Na(r), O = i ? `<ul><li>Notes: ${i}</li></ul>` : "";
  return `<table border="1" style="border: 1px solid black"><thead style="text-align:center">
    <th style="border: 1px solid black" colSpan="4">Brief Schedule</th><tr><th style="border: 1px solid black">Date</th><th style="border: 1px solid black">Time</th><th style="border: 1px solid black">Duration</th><th style="border: 1px solid black">Attendees</th></tr></thead>
    <tbody><tr style="border: 1px solid black;"><td style="border: 1px solid black">${s}</td><td style="border: 1px solid black">${g}</td><td style="border: 1px solid black">${E}</td><td style="border: 1px solid black"><ul><li>${y}${N}</li></ul>${T}${O}</td></tr></tbody></table>`;
}, wl = ({
  inputText: e,
  scheduledEvent: t,
  jobApplication: d,
  sender: a,
  workdayLocation: n,
  client: r,
  userSignature: o,
  customFieldNames: l = [],
  isPreview: i = !1,
  workday: c,
  isSMS: s = !1,
  isHtml: u = !0,
  preserveNewlines: m = !1
}) => {
  if (!e || !t)
    return "";
  const {
    title: g,
    description: E,
    startTime: y,
    endTime: N,
    timeZone: T,
    attendees: O = [],
    candidate: M = [],
    jobReq: _,
    requisitionId: U,
    conferencing: D = [],
    source: H,
    jobApp: de,
    notes: x
  } = t, B = O.filter(
    (It) => !It.isOptional
  ), G = A(N).diff(A(y), "minutes"), j = Ve(
    y,
    T,
    !1,
    !1
  ), W = Ve(
    y,
    T,
    !1,
    !0
  ), Y = bd(
    y,
    T,
    !1
  ), ae = bt(y, T), ce = bt(
    y,
    T,
    !0
  ), se = kd(
    y,
    T
  ), Z = Ve(
    y,
    T,
    !0,
    !1
  ), J = bd(y, T, !0), he = Ve(N, T, !1, !1), L = Ve(
    N,
    T,
    !1,
    !0
  ), ne = Te(T), {
    attendeeFirstNames: Ee,
    attendeeFullNames: te,
    attendeeFullNamesWithoutTitles: ue,
    attendeesListItems: q
  } = Zo(B), {
    candidateFirstName: z,
    candidateLastName: re,
    candidateFullName: me,
    candidateEmail: ge,
    candidatePhone: Ne,
    candidatesFullNames: fe,
    candidatesEmails: pe,
    candidatesListItems: K
  } = Jo(M), Se = t2(
    M || [],
    c
  ), $e = d?.job?.title || _?.title || "[Job Name]", f = d?.job?.description?.html || _?.description?.html || "[Job Description]", I = d?.job?.additionalJobDescription || _?.additionalJobDescription ? Kt(
    d?.job?.additionalJobDescription || _?.additionalJobDescription,
    jo
  ) : "No Additional Job Description Available", Q = d?.job?.jobDescriptionSummary || _?.jobDescriptionSummary || "No Job Description Summary Available", p = U || d?.job?.requisitionID || "[Job Requisition ID]", { names: C, emails: Ce } = qo(_), { names: Be, emails: Ge } = zo(_), {
    firstName: Nt,
    lastName: ft,
    name: _e,
    email: Zt
  } = a ?? { firstName: "", lastName: "", name: "", email: "" }, { location: Jt, locationAddress: qt } = Yo(n), Re = `https://firebasestorage.googleapis.com/v0/b/${S(
    "REACT_APP_STORAGE_BUCKET"
  )}/o/public%2Flogos%2F${r}?alt=media`, Fa = (o || "{{MY_FULL_NAME}}<br>{{MY_EMAIL_ADDRESS}}").replace(
    /{{MY_FIRST_NAME}}/gi,
    Nt || Qe(_e) || "[My First Name]"
  ).replace(
    /{{MY_LAST_NAME}}/gi,
    ft || ut(_e) || "[My Last Name]"
  ).replace(
    /{{MY_FULL_NAME}}/gi,
    _e || `${Nt} ${ft}`.trim() || "[My Full Name]"
  ).replace(/{{MY_EMAIL_ADDRESS}}/gi, Zt || "[My Email Address]").replace(/{{LOCATION}}/gi, Jt).replace(/{{LOCATION_ADDRESS}}/gi, qt).replace(/{{LOGO_ORIGINAL}}/gi, `<img src='${Re}' width='100%' />`).replace(
    /{{LOGO_SMALL}}/gi,
    `<img height='10%' width='10%' src='${Re}'  />`
  ).replace(
    /{{LOGO_MEDIUM}}/gi,
    `<img height='50%' width='50%' src='${Re}' />`
  );
  let pt = e;
  if (H === "MANUAL" && d) {
    const { customFields: It = [], customOrganizations: Ga = [] } = d?.job?.customData ?? {}, ka = It.reduce((V, v) => (V[v.label] = v.value, V), {}), Va = Ga.reduce(
      (V, v) => (v.label && (V[`${v.label}_id`] = v.id, V[`${v.label}_name`] = v.name, V[`${v.label}_code`] = v.code, V[`${v.label}_orgType`] = v.orgType, V[`${v.label}_subType`] = v.subType, V[`${v.label}_wid`] = v.wid), V),
      {}
    ), tt = { ...ka, ...Va };
    Object.keys(tt).length !== 0 ? pt = l.reduce((V, v) => {
      const { name: ke, placeholder: At } = v, Tt = (typeof tt[ke] == "string" ? tt[ke].trim() : tt[ke]) || "No Value Provided";
      return V.replace(
        new RegExp(At, "gi"),
        Array.isArray(Tt) ? JSON.stringify(Tt, null, 2) : Tt
      );
    }, e) : pt = l.reduce((V, v) => {
      const { columnHeadingOverride: ke, placeholder: At } = v;
      return V.replace(
        new RegExp(At, "gi"),
        `[${ke}]`
      );
    }, e);
  }
  const Ct = e2(
    D,
    t.videoConferencingDetails,
    i
  ), ba = rt(
    y,
    N,
    T,
    B,
    D,
    !1,
    !1,
    x
  ), La = rt(
    y,
    N,
    T,
    B,
    D,
    !1,
    !0,
    x
  ), Ma = Md(
    y,
    N,
    G,
    T,
    B,
    D,
    !1,
    !1,
    x
  ), Da = Md(
    y,
    N,
    G,
    T,
    B,
    D,
    !1,
    !0,
    x
  ), va = rt(
    y,
    N,
    T,
    B,
    D,
    !0,
    !1,
    x
  ), Oa = rt(
    y,
    N,
    T,
    B,
    D,
    !0,
    !0,
    x
  ), Pa = ya(D) || "[Interview Type]", zt = $a(
    c,
    de?.wid
  ), wa = "[AUTO GENERATED INTERVIEWER PORTAL BUTTON]", Ua = Ld(
    pt,
    "JOB_APPLICATION_LINK",
    zt,
    ga(s, zt)
  ).replace(/{{BRIEF_START_TIME}}/gi, j).replace(/{{BRIEF_START_TIME_24HR}}/gi, W).replace(/{{BRIEF_START_TIME_SMS}}/gi, Y).replace(/{{BRIEF_TIME}}/gi, ae).replace(/{{BRIEF_TIME_24HR}}/gi, ce).replace(/{{BRIEF_TIME_SMS}}/gi, se).replace(/{{BRIEF_START_DATE}}/gi, Z).replace(/{{BRIEF_START_DATE_SMS}}/gi, J).replace(/{{BRIEF_END_TIME}}/gi, he).replace(/{{BRIEF_END_TIME_24HR}}/gi, L).replace(
    /{{BRIEF_DURATION}}/gi,
    A.duration(G, "minutes").format(
      `h [hours]${G % 60 > 0 ? " m [minutes]" : ""}`
    )
  ).replace(/{{BRIEF_TIME_ZONE}}/gi, ne).replace(/{{BRIEF_SCHEDULE}}/gi, ba).replace(/{{BRIEF_SCHEDULE_24HR}}/gi, La).replace(/{{BRIEF_SCHEDULE_TABLE}}/gi, Ma).replace(/{{BRIEF_SCHEDULE_TABLE_24HR}}/gi, Da).replace(
    /{{BRIEF_SCHEDULE_ATTENDEE_FIRST_NAMES}}/gi,
    va
  ).replace(
    /{{BRIEF_SCHEDULE_ATTENDEE_FIRST_NAMES_24HR}}/gi,
    Oa
  ).replace(/{{INTERVIEW_TYPE}}/gi, Pa).replace(/{{CANDIDATE_FIRST_NAME}}/gi, z).replace(/{{CANDIDATE_LAST_NAME}}/gi, re).replace(/{{CANDIDATE_FULL_NAME}}/gi, me).replace(/{{CANDIDATE_EMAIL}}/gi, ge).replace(/{{CANDIDATE_PHONE}}/gi, Ne).replace(/{{CANDIDATES_FULL_NAMES}}/gi, fe).replace(/{{CANDIDATES_EMAILS}}/gi, pe).replace(
    /{{CANDIDATES_BULLETED_LIST}}/gi,
    `<ul>${K.join(`
`)}</ul>`
  ).replace(
    /{{CANDIDATES_NUMBERED_LIST}}/gi,
    `<ol>${K.join(`
`)}</ol>`
  ).replace(/{{ALL_CANDIDATES_BRIEFS}}/gi, Se).replace(/{{ATTENDEE_FIRST_NAMES}}/gi, Ee).replace(/{{ATTENDEE_FULL_NAMES}}/gi, te).replace(/{{ATTENDEES_WITHOUT_TITLES}}/gi, ue).replace(
    /{{ATTENDEES_BULLETED_LIST}}/gi,
    `<ul>${q.join(`
`)}</ul>`
  ).replace(
    /{{ATTENDEES_NUMBERED_LIST}}/gi,
    `<ol>${q.join(`
`)}</ol>`
  ).replace(/{{JOB_NAME}}/gi, $e).replace(/{{JOB_DESCRIPTION}}/gi, f).replace(/{{ADDITIONAL_JOB_DESCRIPTION}}/gi, I).replace(/{{JOB_DESCRIPTION_SUMMARY}}/gi, Q).replace(/{{JOB_REQ_ID}}/gi, p).replace(/{{HIRING_MANAGERS}}/gi, C).replace(/{{HIRING_MANAGER_EMAILS}}/gi, Ce).replace(/{{RECRUITERS}}/gi, Be).replace(/{{RECRUITER_EMAILS}}/gi, Ge).replace(
    /{{MY_FIRST_NAME}}/gi,
    Nt || Qe(_e)
  ).replace(
    /{{MY_LAST_NAME}}/gi,
    ft || ut(_e)
  ).replace(/{{MY_FULL_NAME}}/gi, _e).replace(/{{MY_EMAIL_ADDRESS}}/gi, Zt).replace(/{{MY_SIGNATURE}}/gi, Fa).replace(/{{LOCATION}}/gi, Jt).replace(/{{LOCATION_ADDRESS}}/gi, qt).replace(/{{LOGO_ORIGINAL}}/gi, `<img src='${Re}' width='100%' />`).replace(
    /{{LOGO_SMALL}}/gi,
    `<img height='10%' width='10%' src='${Re}'  />`
  ).replace(
    /{{LOGO_MEDIUM}}/gi,
    `<img height='50%' width='50%' src='${Re}' />`
  ).replace(/\n/gi, m ? `
` : ""), Ba = Ct.match(/href="([^"]+)"/)?.[1] ?? Ct;
  let et = Ld(
    Ua,
    "VIDEO_CONFERENCE_LINK",
    Ba,
    Ct
  );
  return et = et.replace(
    /href=(["'])https?:\/\/(https?:\/\/)/gi,
    "href=$1$2"
  ), i ? et.replace(
    /{{INTERVIEWER_PORTAL_BUTTON}}/gi,
    wa
  ) : et;
}, Ul = () => A.tz.guess(), P = (e) => {
  switch (e) {
    case R.ROOSTERLINKS_PROSPECT:
      return "RoosterLinks Prospect";
    case R.ROOSTERLINKS_MEETING:
      return "RoosterLinks Meeting";
    case R.MANUAL_SCHEDULING:
      return "Manual Scheduling";
    case R.WD_INIT_AUTOBOOK:
      return "Workday Initiated Autobook";
    case R.WD_INIT_AVAILABILITY:
      return "Workday Initiated Availability";
    case R.AUTOBOOK:
      return "Autobook Interview";
    case R.AVAILABILITY:
      return "Availability Requested";
    case R.QUICK_INTERVIEW:
      return "Quick Interview";
    case h.AUTOBOOK_REQUESTED:
      return "Autobook Requested";
    case h.AVAILABILITY_REQUESTED:
      return "Availability Requested";
    case h.AVAILABILITY_RECEIVED:
      return "Availability Received";
    case h.INTERVIEW:
      return "Interview";
    default:
      return e;
  }
}, Bl = (e, t, d, a) => {
  if (!e && !t)
    return { code: null, name: "" };
  const n = e;
  if (Xa(R)?.some((r) => r === n)) {
    if (R.QUICK_INTERVIEW === n && t === "cancelled")
      return {
        code: n,
        name: P(n)
      };
    if ([
      R.MANUAL_SCHEDULING,
      R.WD_INIT_AUTOBOOK,
      R.AUTOBOOK
    ].some((r) => r === n)) {
      if (t === "saved" && d && d >= 1440)
        return {
          code: h.AUTOBOOK_REQUESTED,
          name: P(
            h.AUTOBOOK_REQUESTED
          )
        };
      if (t === "cancelled" && d && d >= 1440 && (n === R.AUTOBOOK || n === R.WD_INIT_AUTOBOOK))
        return {
          code: h.AVAILABILITY_REQUESTED,
          name: P(
            h.AVAILABILITY_REQUESTED
          )
        };
      if (n === R.AUTOBOOK || n === R.WD_INIT_AUTOBOOK)
        return {
          code: R.AUTOBOOK,
          name: P(
            R.AUTOBOOK
          )
        };
    }
    if ([
      R.AVAILABILITY,
      R.WD_INIT_AVAILABILITY
    ].some((r) => r === n)) {
      if (t === h.AVAILABILITY_REQUESTED)
        return {
          code: h.AVAILABILITY_REQUESTED,
          name: P(
            h.AVAILABILITY_REQUESTED
          )
        };
      if (t === h.AVAILABILITY_RECEIVED)
        return {
          code: h.AVAILABILITY_RECEIVED,
          name: P(
            h.AVAILABILITY_RECEIVED
          )
        };
      if (t === "cancelled")
        return d && d >= 1440 ? {
          code: h.AVAILABILITY_REQUESTED,
          name: P(
            h.AVAILABILITY_REQUESTED
          )
        } : {
          code: h.INTERVIEW,
          name: P(
            h.INTERVIEW
          )
        };
    }
    return R.QUICK_INTERVIEW === n && t !== "cancelled" ? {
      code: n,
      name: P(n)
    } : [
      R.ROOSTERLINKS_PROSPECT,
      R.ROOSTERLINKS_MEETING
    ].some((r) => r === n) ? {
      code: n,
      name: P(n)
    } : {
      code: h.INTERVIEW,
      name: P(
        h.INTERVIEW
      )
    };
  }
  switch (t) {
    case "saved":
      return d && d >= 1440 ? {
        code: h.AUTOBOOK_REQUESTED,
        name: P(
          h.AUTOBOOK_REQUESTED
        )
      } : {
        code: R.QUICK_INTERVIEW,
        name: P(
          R.QUICK_INTERVIEW
        )
      };
    case h.AVAILABILITY_REQUESTED:
      return {
        code: h.AVAILABILITY_REQUESTED,
        name: P(
          h.AVAILABILITY_REQUESTED
        )
      };
    case h.AVAILABILITY_RECEIVED:
      return {
        code: h.AVAILABILITY_RECEIVED,
        name: P(
          h.AVAILABILITY_RECEIVED
        )
      };
    case "cancelled":
      return a ? d && d >= 1440 ? {
        code: h.AVAILABILITY_REQUESTED,
        name: P(
          h.AVAILABILITY_REQUESTED
        )
      } : {
        code: h.INTERVIEW,
        name: P(
          h.INTERVIEW
        )
      } : {
        code: R.QUICK_INTERVIEW,
        name: P(
          R.QUICK_INTERVIEW
        )
      };
    default:
      return {
        code: h.INTERVIEW,
        name: P(
          h.INTERVIEW
        )
      };
  }
}, Gl = 5, kl = {
  $schema: "http://adaptivecards.io/schemas/adaptive-card.json",
  type: "AdaptiveCard",
  version: "1.5",
  body: [
    {
      type: "ColumnSet",
      columns: [
        {
          type: "Column",
          width: "auto",
          items: [
            {
              type: "Image",
              url: "${logoImage}",
              altText: "${logoImageAlt}",
              size: "Large",
              horizontalAlignment: "Left"
            }
          ],
          horizontalAlignment: "Left",
          minHeight: "6px",
          style: "default",
          verticalContentAlignment: "Top"
        }
      ]
    },
    {
      type: "TextBlock",
      text: "${statusTitle}",
      size: "Large",
      weight: "Bolder",
      wrap: !0,
      style: "heading"
    },
    {
      type: "TextBlock",
      text: "${summary}",
      isSubtle: !0,
      wrap: !0
    },
    {
      type: "ColumnSet",
      columns: [
        {
          type: "Column",
          width: "auto",
          items: [
            {
              type: "TextBlock",
              text: "${candidateHeading}:  ",
              size: "Medium",
              weight: "Bolder",
              wrap: !0
            }
          ],
          spacing: "Large",
          horizontalAlignment: "Left",
          verticalContentAlignment: "Center"
        },
        {
          type: "Column",
          width: "auto",
          items: [
            {
              type: "TextBlock",
              text: "${candidateName}",
              size: "Medium"
            }
          ],
          verticalContentAlignment: "Center"
        }
      ]
    },
    {
      type: "TextBlock",
      text: "Date:",
      weight: "Bolder",
      wrap: !0,
      size: "Medium"
    },
    {
      type: "TextBlock",
      text: "${formatDateTime(start.dateTime, 'ddd, MMM D, h:mm A ')} (${start.displayTimeZone})  - ${formatDateTime(end.dateTime, 'ddd, MMM D, h:mm A')} (${end.displayTimeZone})",
      isSubtle: !0,
      spacing: "None",
      wrap: !0
    }
  ],
  actions: [
    {
      type: "Action.Submit",
      title: "Accept",
      msTeams: {
        feedback: {
          hide: !0
        }
      },
      data: {
        link: "${acceptLink}",
        status: "accepted",
        summary: "${summary}",
        candidateName: "${candidateName}",
        start: "${start}",
        end: "${end}",
        acceptLink: "${acceptLink}",
        declineLink: "${declineLink}",
        tentativeLink: "${tentativeLink}",
        eventId: "${eventId}",
        shortSummary: "${shortSummary}",
        interviewDocId: "${interviewDocId}",
        client: "${client}",
        applicationId: "${applicationId}",
        email: "${email}",
        environment: "${environment}"
      }
    },
    {
      type: "Action.Submit",
      title: "Decline",
      msTeams: {
        feedback: {
          hide: !0
        }
      },
      data: {
        link: "${declineLink}",
        status: "declined",
        summary: "${summary}",
        candidateName: "${candidateName}",
        start: "${start}",
        end: "${end}",
        acceptLink: "${acceptLink}",
        declineLink: "${declineLink}",
        tentativeLink: "${tentativeLink}",
        eventId: "${eventId}",
        shortSummary: "${shortSummary}",
        interviewDocId: "${interviewDocId}",
        client: "${client}",
        applicationId: "${applicationId}",
        email: "${email}",
        environment: "${environment}"
      }
    },
    {
      type: "Action.Submit",
      title: "Tentative",
      msTeams: {
        feedback: {
          hide: !0
        }
      },
      data: {
        link: "${tentativeLink}",
        status: "tentative",
        summary: "${summary}",
        candidateName: "${candidateName}",
        start: "${start}",
        end: "${end}",
        acceptLink: "${acceptLink}",
        declineLink: "${declineLink}",
        tentativeLink: "${tentativeLink}",
        eventId: "${eventId}",
        shortSummary: "${shortSummary}",
        interviewDocId: "${interviewDocId}",
        client: "${client}",
        applicationId: "${applicationId}",
        email: "${email}",
        environment: "${environment}"
      }
    }
  ]
}, fa = (e, t) => e && t ? t.toLowerCase().includes(e.toLowerCase()) ? t : `${en(e)} / ${t}` : "", d2 = (e) => xe(
  e?.filter(({ stage: t, step: d } = { stage: "", step: "" }) => t && d)?.map(
    ({ stage: t, step: d } = { stage: "", step: "" }) => fa(t, d)
  )
), a2 = (e, t) => !(t?.length > 0 && t.includes(e)), n2 = ({
  start: e,
  time: t,
  duration: d,
  timeZone: a
}) => {
  const n = e + t * 6e4 - A.tz(a).utcOffset() * 6e4, r = A.tz(n, a), o = A.utc(e).subtract(r.utcOffset(), "minutes").valueOf() + t * 6e4, l = o + d * 6e4, i = A.tz(o, a).format("YYYY[-]MM[-]DD[T]HH[:]mm:ss"), c = A.tz(l, a).format("YYYY[-]MM[-]DD[T]HH[:]mm:ss");
  return {
    interviewSlotStartInMillis: o,
    interviewSlotEndInMillis: l,
    interviewSlotStartFormatted: i,
    interviewSlotEndFormatted: c
  };
}, pa = (e) => {
  const t = e?.status;
  return t === "availability_requested" || t === "availability_received";
}, Et = (e) => {
  const t = Ae(e);
  return e?.status === "saved" && (t[0]?.duration ?? 0) >= 1440;
}, jt = (e) => {
  const d = Ae(e)[0]?.duration ?? 0;
  return e?.status === "saved" && d < 1440;
}, r2 = (e) => {
  const t = e?.status;
  return (t === "sent" || t === "sending") && !Et(e) && !jt(e) && !pa(e);
}, Dd = (e) => pa(e) ? 4 : Et(e) ? 3 : r2(e) ? 2 : jt(e) ? 1 : 0, Ae = (e) => e?.slots ?? e?.interviews ?? [], Ca = (e, t) => {
  const d = Ae(e), a = Ae(t), n = e?.start + (d[0]?.time ?? 0) * 6e4, r = t?.start + (a[0]?.time ?? 0) * 6e4;
  return n === r ? Dd(t) - Dd(e) : r - n;
}, o2 = (e) => {
  const d = (e?.slots ?? e?.interviews ?? [])?.slice(-1)[0];
  return n2({
    start: e?.start ?? 0,
    time: d?.time ?? 0,
    duration: d?.duration ?? 0,
    timeZone: e?.timeZone ?? ""
  }).interviewSlotEndInMillis;
}, De = (e) => o2(e) < Date.now(), Ia = (e) => e?.status === "cancelled", vd = (e) => e?.status === "draft" ? "Draft" : De(e) || Ia(e) ? "Completed" : "In Progress", l2 = (e = []) => {
  const t = e.filter(
    (r) => r?.status !== "draft"
  ), n = [...t.some(
    (r) => Et(r) && !De(r) && !Ia(r)
  ) ? t.filter(
    (r) => r?.status !== "cancelled" && r?.status !== "cancelling"
  ) : t].sort(Ca).filter((r) => Ae(r).length > 0);
  return n.length ? n[0] : null;
}, Vl = (e = []) => {
  e = e.map((u) => (u.interviews = u.slots, u));
  const t = (u) => u.status === "saved" && u?.interviews?.[0]?.duration >= 1440, d = e.filter(
    (u) => t(u) && !De(u)
  ), a = e.filter(
    (u) => t(u) && De(u)
  ), n = e.filter(
    (u) => u.status === "availability_requested" && !De(u)
  ), r = e.filter(
    (u) => u.status === "availability_requested" && De(u)
  ), o = e.filter(
    (u) => vd(u) === "In Progress" && u.status !== "availability_requested" && !t(u)
  ), l = e.filter(
    (u) => vd(u) === "Completed" && u.status !== "availability_requested" && !t(u)
  );
  let i = o;
  o.length === 0 && (i = d), o.length === 0 && d.length === 0 && (i = n);
  let c = l;
  l.length === 0 && (c = a), l.length === 0 && a.length === 0 && (c = r);
  const s = ((i.length > 0 ? i : c) ?? []).sort(Ca).filter(({ slots: u = [] }) => u.length > 0);
  return s.length ? s[0] : null;
}, xl = (e, t = { applicationStage: "", applicationStep: "" }) => {
  const { applicationStage: d, applicationStep: a } = t, n = a2(
    fa(d, a),
    d2(e ?? [])
  );
  let r = 0, o = 0, l = 0, i = 0, c = 0, s = 0, u = 0, m = 0, g = 0, E = 0, y = 0, N = 0, T = 0, O = 0, M = "gray", _ = "gray", U = !1, D = !1, H = !1, de = !1, x = !1, B = !1, G = !1, j = !1, W = !1, Y = !1, ae = !1, ce = !1, se = !1, Z = !1, J = !1;
  if (e?.length > 0) {
    let L = l2(e);
    if (L) {
      const ne = Ae(L), Ee = L?.start + (ne[0]?.time ?? 0) * 6e4 + (ne[0]?.duration ?? 0) * 6e4, te = (/* @__PURE__ */ new Date()).getTime(), ue = Ee < te;
      U = Et(L);
      const q = jt(L);
      if (D = L.status === "availability_requested", H = L.status === "availability_received", Z = D && ue, J = U && ue, M = U && !J || q ? "purple" : D && !Z ? "orangered" : H ? "sienna" : "gray", _ = U && !J || q ? "purple" : D && !Z ? "orangered" : H ? "sienna" : "gray", L && L.status) {
        switch (r++, L.status) {
          case "cancelled": {
            o++;
            break;
          }
          case "cancelling": {
            o++;
            break;
          }
          case "sending": {
            l++;
            break;
          }
          case "sent": {
            l++;
            break;
          }
        }
        if (!L.status || L.status !== "cancelled") {
          switch (L?.candidate?.responseStatus) {
            case "needsAction": {
              y++;
              break;
            }
            case "tentative": {
              N++;
              break;
            }
            case "accepted": {
              T++;
              break;
            }
            case "declined": {
              O++;
              break;
            }
            default:
              L?.candidate?.status === "sent" || L?.candidate?.status === "sending" ? E++ : g++;
          }
          Ae(L).forEach((z) => {
            z.interviewers?.forEach((re) => {
              if (m++, re.responseStatus)
                switch (re.responseStatus) {
                  case "needsAction": {
                    i++;
                    break;
                  }
                  case "tentative": {
                    c++;
                    break;
                  }
                  case "accepted": {
                    s++;
                    break;
                  }
                  case "declined": {
                    u++;
                    break;
                  }
                }
            });
          });
        }
      }
      r > 0 && o === r ? (M = "#990000", _ = "#990000", j = !0, W = !0) : l > 0 && !n && (s === m ? (M = "green", de = !0) : u === m ? (M = "#990000", j = !0) : i === m ? (M = "#1b74bc", B = !0) : c === m ? (M = "#8B6D00", ce = !0) : s > 0 ? (M = "#00B7B7", Y = !0) : (M = "#1b74bc", B = !0), E > 0 ? g > 0 ? (_ = "#6699cc", ae = !0) : (_ = "#1b74bc", G = !0) : T === l ? (_ = "green", x = !0) : O === l ? (_ = "#990000", W = !0) : y === l ? (_ = "#1b74bc", G = !0) : N === l ? (_ = "#8B6D00", se = !0) : T > 0 && (_ = "#6699cc", ae = !0));
    }
    L?.status === "failed" && (_ = "red", M = "red");
  }
  return {
    stepNotScheduled: n,
    color: {
      interviewers: M,
      candidate: _
    },
    availability: {
      requested: D,
      received: H,
      expired: Z
    },
    autobook: {
      requested: U,
      expired: J
    },
    awaitingReply: {
      interviewers: B,
      candidate: G
    },
    acceptedBy: {
      interviewers: de,
      candidate: x
    },
    declinedBy: {
      interviewers: j,
      candidate: W
    },
    tentativeBy: {
      interviewers: ce,
      candidate: se
    },
    mixedResponses: {
      interviewers: Y,
      candidate: ae
    },
    noAction: {
      interviewers: M === "gray" || n,
      candidate: _ === "gray" || n
    }
  };
}, i2 = (e) => A.utc().clone().tz(e).utcOffset().valueOf() ?? 0, Hl = (e) => {
  if (!e || !e.interviews || !e.start || typeof e.start != "number")
    return null;
  const t = e.interviews ?? [], d = [...t].sort(
    (u, m) => u.time - m.time
  ), a = t.reduce(
    (u, m) => u + m.duration,
    0
  ), n = d?.[0];
  if (!n)
    return null;
  const { start: r, timeZone: o, clientTimeZoneOffset: l } = e ?? {}, i = i2(o);
  let c = A(+r + +n.time * 6e4).utc().add(-i, "minutes"), s = A(+r + +n.time * 6e4 + a * 6e4).utc().add(-i, "minutes");
  return l !== void 0 && (c = c.utcOffset(l, !0), s = s.utcOffset(l, !0)), {
    startTime: c.valueOf(),
    endTime: s.valueOf()
  };
}, Wl = (e) => {
  try {
    const { status: t, start: d, interviews: a } = e, n = (/* @__PURE__ */ new Date()).getTime(), r = (U, D, H) => U + D * 6e4 + H * 6e4 < n, o = (U) => t === U;
    let l = o("saved"), i = o("availability_requested"), c = o("availability_received");
    const s = a?.[0] ?? { time: 0, duration: 0 };
    let u = i && r(d, s.time, s.duration), m = l && r(d, s.time, s.duration);
    const g = Aa(a), E = g.needsAction > 0, y = g.accepted === g.total, N = g.declined > 0, T = g.tentative === g.total, O = c2(g), M = g.total > 0 && g.needsAction === g.total;
    let _ = s2(e);
    return {
      availability: {
        requested: i,
        received: c,
        expired: u
      },
      autobook: { requested: l, expired: m },
      awaitingReply: {
        interviewers: E,
        candidate: e.candidate?.responseStatus === "needsAction"
      },
      acceptedBy: {
        interviewers: y,
        candidate: e.candidate?.responseStatus === "accepted"
      },
      declinedBy: {
        interviewers: N,
        candidate: e.candidate?.responseStatus === "declined"
      },
      tentativeBy: {
        interviewers: T,
        candidate: e.candidate?.responseStatus === "tentative"
      },
      mixedResponses: { interviewers: O },
      noAction: {
        candidate: !e.candidate?.status || e.candidate?.status !== "sent"
      },
      displayColor: _
    };
  } catch {
    return {};
  }
}, c2 = ({
  accepted: e,
  declined: t,
  tentative: d,
  needsAction: a,
  total: n
}) => (e > 0 || t > 0 || d > 0 || a > 0) && n !== e && n !== t && n !== d && n !== a, Aa = (e) => {
  const t = {
    total: 0,
    needsAction: 0,
    accepted: 0,
    declined: 0,
    tentative: 0
  };
  return e?.forEach((d) => {
    d.interviewers.forEach((a) => {
      t.total++, t[a.responseStatus]++;
    });
  }), t;
}, s2 = (e) => {
  const { responseStatus: t } = e?.candidate || {}, d = Aa(e?.interviews || []);
  return d.declined > 0 || t === "declined" ? "red" : d.tentative > 0 || t === "tentative" ? "yellow" : d.accepted === d.total && t === "accepted" ? "green" : d.needsAction === d.total && t === "needsAction" ? "blue" : t && (d.accepted > 0 || d.needsAction > 0) ? "teal" : "gray";
}, Kl = {
  ALERTS: "alerts",
  APPLICATIONS: "applications",
  AVAILABILITY: "availability",
  AUTOBOOK_PROFILES: "autobook-profiles",
  CLIENTS: "clients",
  CLOUDTASKS: "cloud-tasks",
  COMMUNICATION: "communication",
  CONFERENCING: "conferencing",
  DEFAULT: "default",
  DEPARTMENTS: "departments",
  EMAILS: "emails",
  EVENTS: "events",
  GRANTS: "grants",
  HISTORY: "history",
  INSIGHTS: "insights",
  INTERVIEW: "interview",
  INTERVIEWS: "interviews",
  INTERVIEW_STAGES: "interview-stages",
  INTERVIEW_TYPES: "interview-types",
  LOADS: "loads",
  MAPPINGS: "mappings",
  NOTIFICATIONS: "notifications",
  PREFERENCES: "preferences",
  SAMLTOKENS: "saml-tokens",
  SKILLS: "skills",
  SMS: "sms",
  WHATSAPP: "whatsapp",
  SMSSTEPS: "sms-steps",
  WHATSAPPSTEPS: "whatsapp-steps",
  SUBSCRIPTIONS: "subscriptions",
  USERS: "users",
  WORKERS: "workers",
  DOMAINS: "domains",
  EMAILTEMPLATES: "email-templates",
  ROOMSLOCATIONS: "rooms-locations",
  WORKDAY_DATA: "workday-data",
  ROLES: "roles",
  LOCATIONS: "locations",
  REMINDERS: "reminders",
  WORKERS_ATTRIBUTES: "workers-attributes",
  WORKERS_PREFERENCES: "workers-preferences",
  WORKDAY: "workday",
  SYSTEM: "system",
  CANDIDATES: "candidates",
  SCHEDULERSROLES: "schedulers-roles",
  USER_GRANT_MAP: "user-grant-map",
  PERSONAL_MEETING_PROFILES: "personal-meeting-profiles",
  PRISM: "prism",
  JOBDESCRIPTIONS: "job-descriptions",
  AUTOMATION: "automation",
  REPORT_DOWNLOAD_HISTORY: "report-history",
  SERVICECENTERWORKERS: "service-center-workers",
  STANDALONE_USERS_LOADS: "standalone-users-loads"
}, u2 = "interview", Ta = "roosterLinks", jl = (e) => {
  const { categories: t } = e;
  return !t || t?.length === 0 || t?.includes(u2);
}, Yl = (e) => {
  const { categories: t } = e;
  return t && t?.length > 0 && t?.includes(Ta);
}, Zl = (e, t) => {
  const { categories: d } = e;
  return d && d?.length > 0 && d?.includes(Ta) ? e.audience === t : !1;
}, m2 = {
  "Europe/Kyiv": "Europe/Kiev"
}, Jl = (e) => m2[e] ?? e, ql = (e) => {
  const t = ha(e);
  if (e?.proxy && e?.proxyUserEmail) {
    const d = [e.proxyUserEmail];
    return e.proxyUserEmailAliases && d.push(
      ...e.proxyUserEmailAliases.split(",").map((a) => a.trim()).filter(Boolean)
    ), {
      targetEmails: t,
      adminEmails: d,
      ...typeof e.proxyUserId == "string" && e.proxyUserId ? { adminAuthUid: e.proxyUserId } : {}
    };
  }
  return { targetEmails: t };
}, ha = (e) => {
  let t = [e.email];
  if (e.emailAliases) {
    const d = Array.isArray(e.emailAliases) ? e.emailAliases : e.emailAliases.split(",").map((a) => a.trim()).filter(Boolean);
    t = t.concat(
      d.map((a) => a.trim()).filter(Boolean)
    );
  }
  return t;
}, zl = (e) => {
  if (e.proxy && e.proxyUserEmail) {
    const t = [e.proxyUserEmail];
    return e.proxyUserEmailAliases && t.push(
      ...e.proxyUserEmailAliases.split(",").map((d) => d.trim()).filter(Boolean)
    ), t;
  }
  return ha(e);
}, Ql = (e, t, d) => {
  if (!e) return !1;
  const { targetEmails: a, adminEmails: n } = d;
  return !!(!(a.length > 0 && a.some((o) => t.includes(o))) || n && n.length > 0 && !n.some(
    (l) => t.includes(l)
  ));
}, Xl = (e, t) => {
  if (!t?.proxy)
    return e;
  const { proxyUserId: d, ...a } = e;
  return {
    ...a,
    proxy: t.proxy,
    proxyUserEmail: t.proxyUserEmail,
    proxyUserEmailAliases: t.proxyUserEmailAliases,
    ...t.proxyUserId ? { proxyUserId: t.proxyUserId } : {}
  };
}, Sa = [
  {
    alias: "key",
    purpose: "the unique Workday ID each worker is stored and de-duplicated under"
  },
  { alias: "firstName", purpose: "the first half of every worker's name" },
  { alias: "lastName", purpose: "the second half of every worker's name" },
  {
    alias: "email",
    purpose: "how interviewers are matched, invited and notified"
  }
], _a = [
  { alias: "telephone", purpose: "the worker's contact phone number" },
  { alias: "title", purpose: "the worker's job title" },
  { alias: "department", purpose: "the department shown against the worker" },
  {
    alias: "departmentWID",
    purpose: "the department's Workday ID, used to filter by department"
  }
], g2 = /'(?:''|[^'])*'|\/\*[\s\S]*?\*\/|--[^\n]*/g, Xe = (e) => e.replace(
  g2,
  (t) => t.startsWith("'") ? "x".repeat(t.length) : " ".repeat(t.length)
), Ra = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), Yt = (e, t) => new RegExp(`\\bas\\s+${Ra(t)}\\b`, "i").test(e), $2 = (e) => {
  const t = Xe(e);
  return Sa.filter(
    ({ alias: d }) => !Yt(t, d)
  ).map(({ alias: d }) => d);
}, y2 = (e) => {
  const t = Xe(e);
  return _a.filter(
    ({ alias: d }) => !Yt(t, d)
  ).map(({ alias: d }) => d);
}, E2 = /ORDER\s+BY\s+([\w.]+)\s+ASC\b/i, N2 = (e) => Xe(e).match(E2)?.[1] ?? null, f2 = [
  /\bactiveStatus\s*=\s*true\b/i,
  /\bcurrentlyActive\s*=\s*true\b/i,
  /\bterminated\s*=\s*false\b/i
], p2 = [
  /\bdataSourceFilter\s*=\s*allActiveWorkers\b/i,
  /\bincludeTerminatedWorkers\s*=\s*false\b/i
], C2 = (e) => {
  const t = Xe(e);
  return f2.some((d) => d.test(t)) || p2.some((d) => d.test(t));
}, I2 = [
  "MISSING_KEYWORD",
  "MISSING_REQUIRED_ALIAS",
  "MISSING_ORDER_BY",
  "ORDER_BY_NOT_KEY"
], A2 = ["SELECT", "FROM", "WHERE"], Od = (e) => [...Sa, ..._a].find(
  (t) => t.alias === e
)?.purpose ?? "", T2 = (e) => {
  const t = [], d = [];
  if (!e.trim())
    return { errors: t, warnings: d, isValid: !0 };
  const a = Xe(e), n = A2.filter(
    (o) => !new RegExp(`\\b${o}\\b`, "i").test(a)
  );
  n.length && t.push({
    code: "MISSING_KEYWORD",
    message: `This does not look like a WQL query — no ${n.join(", ")} clause. Start from the default shown alongside and edit it.`
  });
  for (const o of $2(e))
    t.push({
      code: "MISSING_REQUIRED_ALIAS",
      alias: o,
      message: `The query must still project \`as ${o}\` — it is ${Od(o)}. You can change which Workday field feeds it, but not remove or rename it.`
    });
  const r = N2(e);
  r ? Yt(a, "key") && (new RegExp(`\\b${Ra(r)}\\s+as\\s+key\\b`, "i").test(
    a
  ) || t.push({
    code: "ORDER_BY_NOT_KEY",
    message: `Pages are ordered by \`${r}\`, but that is not the field projected \`as key\`. Both must name the same column, or workers can be read twice and others missed.`
  })) : t.push({
    code: "MISSING_ORDER_BY",
    message: "The query must end with `ORDER BY <column> ASC`. Workers are read a page at a time, and without a fixed order the pages overlap or skip people."
  }), C2(e) || t.push({
    code: "MISSING_ACTIVE_FILTER",
    message: "The query does not limit the load to active workers. Add `activeStatus = true` (or `currentlyActive = true` / `terminated = false`) to the WHERE clause, or `includeTerminatedWorkers=false` to the FROM clause. Without it, people who have left are loaded every run and can never be removed."
  });
  for (const o of y2(e))
    d.push({
      code: "MISSING_OPTIONAL_ALIAS",
      alias: o,
      message: `Nothing is projected \`as ${o}\`, so ${Od(o)} will be blank for every worker.`
    });
  return { errors: t, warnings: d, isValid: t.length === 0 };
}, ei = (e) => T2(e).errors.filter(
  ({ code: t }) => I2.includes(t)
), ti = [
  "SELECT",
  [
    "workdayID as key",
    "preferredName_FirstName as firstName",
    "preferredName_LastName as lastName",
    "email_PrimaryWork as email",
    "primaryWorkMobilePhone as telephone",
    "businessTitle as title",
    "supervisoryOrganization as department",
    "supervisoryOrganization_ID as departmentWID"
  ].join(", "),
  "FROM workersForHCMReporting(dataSourceFilter=allWorkers, includeTerminatedWorkers=true)",
  // No delta predicate: what Rooster stores is meant to BE the active
  // workforce, and every run reads all of it so departures are removed on the
  // same load that finds them. A predicate here would only be stripped again
  // before the query is sent.
  "WHERE activeStatus = true",
  "ORDER BY workdayID ASC"
].join(" "), h2 = (e) => e?.trim().toLowerCase() ?? "", di = (e) => {
  for (const t of [e.key, e.workerId, e.wid]) {
    const d = h2(t);
    if (d) return d;
  }
  return "";
}, ai = {
  lastUsed: "",
  duration: 15,
  interviewersAndRoles: [],
  interviewersFilter: {
    requiredInterviewers: [],
    compositeFilter: {
      id: "root",
      operation: "AND",
      groups: [],
      isRoot: !0
    }
  },
  requiredInterviewersCount: 1,
  skills: [],
  conferencing: [],
  availabilityEmailTemplate: null,
  interviewerEmailTemplate: null,
  candidateEmailTemplate: null,
  candidateSchedule: !0,
  candidateReschedule: !0,
  candidateCancel: !0,
  allowOverbooking: !0,
  onlyConsiderRoosterBlocks: !1,
  autoResendOnDecline: !1,
  autoResendEmailTemplate: null,
  defaultAvailabilityDays: 14,
  slotStartIncrement: 30,
  metadata: {
    lockedFields: []
  }
}, ni = {
  lastUsed: "",
  dontScheduleBeforeMinutes: 540,
  dontScheduleAfterMinutes: 1020,
  dontScheduleTimeZone: "",
  defaultAvailabilityDays: 14,
  customAvailabilityURL: "",
  dontScheduleWithinMinutes: 1440,
  dontScheduleBeyondMinutes: 504 * 60,
  availabilityEmailTemplate: null,
  metadata: {
    lockedFields: []
  },
  duration: 30
}, ri = (e, t = "", d = "", a) => t?.length === 0 && d?.length === 0 ? !1 : e.some((n) => {
  const r = n.profileName.toLowerCase() === t.toLocaleLowerCase(), o = n.stepText?.length > 0 && n.stepText.toLowerCase() === d.toLocaleLowerCase(), l = n.id !== a;
  return (r || o) && l;
}), Pd = (e) => {
  const t = { ...e };
  return (e.totalInterviewSlots !== void 0 && e.totalInterviewSlots !== null || e.availableDaysRequired !== void 0 && e.availableDaysRequired !== null || e.minSlotsAcrossDays !== void 0 && e.minSlotsAcrossDays !== null) && (t.totalInterviewSlots = Math.max(1, e.totalInterviewSlots ?? 1), t.availableDaysRequired = Math.max(1, e.availableDaysRequired ?? 1), t.minSlotsAcrossDays = Math.max(1, e.minSlotsAcrossDays ?? 1)), t;
}, oi = (e) => {
  if (!e) return e;
  const t = e.availableDaysRequired || e.minSlotsAcrossDays, d = e.totalInterviewSlots === void 0 || e.totalInterviewSlots === null;
  if (t && d) {
    const n = { ...e }, r = e.availableDaysRequired, o = e.minSlotsAcrossDays;
    r && o ? n.totalInterviewSlots = o * r : o ? n.totalInterviewSlots = o : r && (n.totalInterviewSlots = r);
    const l = Pd({
      totalInterviewSlots: n.totalInterviewSlots,
      availableDaysRequired: n.availableDaysRequired,
      minSlotsAcrossDays: n.minSlotsAcrossDays
    });
    return { ...n, ...l };
  }
  const a = Pd({
    totalInterviewSlots: e.totalInterviewSlots,
    availableDaysRequired: e.availableDaysRequired,
    minSlotsAcrossDays: e.minSlotsAcrossDays
  });
  return a.totalInterviewSlots !== e.totalInterviewSlots || a.availableDaysRequired !== e.availableDaysRequired || a.minSlotsAcrossDays !== e.minSlotsAcrossDays ? { ...e, ...a } : e;
};
export {
  Cl as ALLOW_CREATE_WORKFLOW_ROLES_LABEL_VALUES,
  kl as AcceptDeclineAdaptiveCard,
  X as BRIEF_TEMPLATE_VARIABLES,
  fl as CANDIDATE,
  l0 as COUNTRY_CALLING_CODE_TO_ISO_3166_CODE,
  Rn as DANGEROUS_CSS_PATTERN,
  Ln as DEFAULT_AVAILABILITY_RECURRING_FROM,
  Mn as DEFAULT_AVAILABILITY_RECURRING_TO,
  Hn as DEFAULT_LINK_MESSAGING_SETTINGS,
  Z1 as DEFAULT_TIMEZONE,
  be as DEFAULT_WEBEX_PASSWORD_REQUIREMENTS,
  h1 as ENVIRONMENT_MAP,
  at as HIERARCHY,
  Nl as INTERVIEWER,
  wn as INTERVIEWER_PREFERENCES_ADDITIONAL_INFO,
  vn as INTERVIEWER_PREFERENCES_BUFFER_AFTER,
  Dn as INTERVIEWER_PREFERENCES_BUFFER_BEFORE,
  On as INTERVIEWER_PREFERENCES_BUFFER_RESTRICT_SCHEDULE_BEFORE,
  q1 as INTERVIEWER_PREFERENCES_DAILY_MAX_INTERVIEWS,
  Pn as INTERVIEWER_PREFERENCES_TIME_INCREMENT,
  J1 as INTERVIEWER_PREFERENCES_WEEKLY_MAX_INTERVIEWS,
  u2 as INTERVIEWTEMPLATE,
  ht as LIST_OF_COMMON_DOMAINS_REQUIRING_ADDITIONAL_EMAIL_INVITE,
  En as LIST_OF_GOOGLE_DOMAINS_REQUIRING_ADDITIONAL_EMAIL_INVITE,
  Nn as LIST_OF_OFFICE365_DOMAINS_REQUIRING_ADDITIONAL_EMAIL_INVITE,
  e0 as MEETING_SCHEDULER,
  Ll as MIN_RETENTION_LABEL,
  ll as NEW_RECIPIENT_COMPLIANCE_SMS,
  _a as OPTIONAL_WORKER_ALIASES,
  $1 as PRIMARY_DATE_FORMAT,
  N1 as PRIMARY_DATE_FORMAT_WEEKDAY,
  y1 as PRIMARY_DATE_TIME_FORMAT,
  E1 as PRIMARY_TIME_FORMAT,
  Sa as REQUIRED_WORKER_ALIASES,
  $ as ROLES,
  pl as ROLES_LABEL_VALUES,
  Ta as ROOSTERLINKSTEMPLATE,
  fn as ROOSTER_DOMAIN_MAP,
  pn as ROOSTER_LOCAL_URL_MAP,
  I2 as SAVE_BLOCKING_ISSUE_CODES,
  Qn as SCHEDULER,
  Xn as SCHEDULER_ONLY,
  zn as SCHEDULING_ADMIN,
  Bo as SERVICE_PROVIDER,
  t0 as SOURCER,
  El as SUPER_ADMIN,
  Kl as TABLES,
  qn as TENANT_ADMIN,
  T1 as URL_SHORTENER_ENVIRONMENT_MAP,
  Zd as WEBEX_FORBIDDEN_CHARS,
  ti as WORKERS_WQL,
  K1 as addAltToImages,
  oi as applyAvailabilityProfileBackwardCompatibility,
  k1 as booleanToNumber,
  U2 as calculateLatestRequestDate,
  i2 as calculateTimeDifference,
  $l as callMongoSyncAPI,
  f1 as checkIfDomainIsRestricted,
  al as checkIsRoosterLinksInitiatedFromRequestType,
  sl as checkSmsAccountIsActive,
  j1 as cleanHTML,
  nl as computeInterviewSlotStart,
  P as convertRequestTypeCodeToHumanReadableText,
  w2 as convertToCompositeGroup,
  Ud as countTotalItems,
  ai as defaultAutobookProfile,
  ni as defaultAvailabilityProfile,
  _l as defaultPermissions,
  Rl as e164FormatPhoneNumber,
  C1 as encodeDisplayName,
  _n as envToBackendUrlMap,
  b as environment,
  o0 as extractRolesArray,
  dl as filterDocsForWhichCandidateInviteCanBeSent,
  y2 as findMissingOptionalAliases,
  $2 as findMissingRequiredAliases,
  N2 as findOrderByAscColumn,
  ei as findSaveBlockingWorkerIssues,
  e1 as formatDay,
  Gd as formatDisplayDate,
  He as formatDisplayDateTime,
  gn as formatDisplayDateTimeRange,
  Z2 as formatDisplayDateTimeRangeWithTimezone,
  a1 as formatDisplayDateTimeRangeWithTimezoneAsLocal,
  k2 as formatDisplayDateTimeSeconds,
  $n as formatDisplayDateTimeWithTimezone,
  d1 as formatDisplayDateTimeWithTimezoneAsLocal,
  q2 as formatDisplayDateTimeWithWeekday,
  Q2 as formatDisplayDateTimeWithWeekdayAndTimezone,
  Y2 as formatDisplayDateWithTimezone,
  J2 as formatDisplayDateWithWeekday,
  z2 as formatDisplayDateWithWeekdayAndTimezone,
  le as formatDisplayTime,
  kd as formatDisplayTimeWithTimezone,
  bt as formatDisplayTimeWithZoneName,
  V2 as formatDisplayWithDuration,
  W2 as formatEndTime,
  j2 as formatEndTimeForRange,
  we as formatEventDateTime,
  X2 as formatMonth,
  _o as formatMonthCount,
  I1 as formatRecipientName,
  x2 as formatStartAndEndTimes,
  H2 as formatStartTime,
  c1 as formatWeekRange,
  t1 as formatWeekdayFull,
  yn as formatWeekdayShort,
  P1 as functionsBasePath,
  w1 as functionsBasePathWithoutLB,
  ol as gateLinkSendOption,
  Bn as generateDefaultAdditionalInterviewPreferences,
  kn as generateDefaultAvailabilityPreferences,
  z1 as generateDefaultInterviewPreferences,
  Gn as generateDefaultReccurringAvailability,
  P2 as generateFilterPreview,
  la as generateInterviewerDisplayData,
  Y1 as generateLocaleTitleFromCode,
  Zn as generatePasswordFromRequirements,
  Jn as generatePasswordFromRequirementsForWebex,
  cl as getActiveMessagingService,
  oa as getAdditionalFormattedConferencingList,
  Pl as getAllBriefPlaceholders,
  Ol as getAvailablePlaceholdersBySource,
  B1 as getBaseRedirectUrl,
  Jl as getCanonicalTimezoneName,
  ql as getConfidentialEmailSets,
  i1 as getCurrentISOWeekKey,
  Ul as getCurrentTimeZone,
  m1 as getCurrentTimestamp,
  g1 as getCurrentWeekBoundaries,
  _1 as getDataHandlerApiUrl,
  r1 as getDateKeyInTimezone,
  s1 as getDateRangeFromNow,
  p1 as getEmailDomain,
  zl as getEmailsForConfidentialCheck,
  S as getEnvVariable,
  tl as getEventId,
  Vn as getFiltereredInterviewsByAssociatedEventId,
  fa as getFormattedApplicationStep,
  d2 as getFormattedApplicationSteps,
  nt as getFormattedInterviewSchedule,
  hd as getFormattedInterviewScheduleTable,
  Me as getFormattedMultiDayInterviewSchedule,
  Vd as getISOWeekBoundaries,
  l1 as getISOWeekKey,
  s2 as getInterviewColor,
  o2 as getInterviewEndTimeInMillis,
  n2 as getInterviewSlotTimeBounds,
  Wl as getInterviewStatusMap,
  Hl as getInterviewTimeBoundsInUTC,
  l2 as getInterviewToDisplayStatusFor,
  Vl as getInterviewToDisplayStatusForV2,
  Wn as getLinkMessagingKey,
  bn as getLocaleFromCode,
  Bd as getNestedGroupTypes,
  Xt as getOperationDisplayText,
  Ml as getOtherInterviewsMetadataForLineup,
  jd as getPasswordSchema,
  il as getPhoneNumbersForActiveSmsMessagingService,
  S1 as getReactAppUrl,
  Bl as getRequestType,
  B2 as getResolvedAutomationRules,
  Aa as getResponseCounters,
  Hd as getRoosterExternalAppUrl,
  ot as getServerUrl,
  xn as getSlotEventId,
  di as getStableWorkerId,
  ko as getStartDateForInterview,
  u1 as getTimestampInTimezone,
  n1 as getTimezoneOrDefault,
  wd as getTypeDisplayName,
  ha as getUserEmails,
  C2 as hasActiveWorkerRestriction,
  hl as hasClaimRole,
  rn as hasItemTypeInInterviewersFilter,
  Al as hasMeetingSchedulerRole,
  Tl as hasNonRoosterLinksRole,
  ed as hasRole,
  Il as hasSourcerRole,
  d0 as hasTenantAdminRole,
  Sl as hasUserAccessToViewAllCandidates,
  Yn as hasWebexForbiddenChars,
  Fl as inferCountryCallingCode,
  x1 as isAnalyticsPostgresEnabled,
  Ql as isConfidentialAndUnauthorized,
  F1 as isDevelopment,
  ri as isDuplicateStepTextOrProfileName,
  b1 as isHotfix,
  L1 as isHotfixAutomation,
  Cn as isImpl,
  In as isImplEurope,
  jl as isInterviewEmailTemplate,
  xd as isKognitivDomain,
  Sn as isLoadBalanced,
  mt as isLocalhost,
  c2 as isMixedResponses,
  V1 as isPostgresEnabled,
  D1 as isPreview,
  An as isPreviewEurope,
  hn as isProduction,
  R1 as isQA,
  M1 as isQAautomation,
  Yd as isReplacePatternPresent,
  Zl as isRoosterLinksAudienceEmailTemplate,
  Yl as isRoosterLinksEmailTemplate,
  K2 as isSameDay,
  o1 as isSameDayInTimezone,
  v1 as isSandbox,
  Tn as isStaging,
  a2 as isStepNotScheduled,
  gl as isValidEmailFormat,
  yl as isValidWebexPassword,
  Wd as localFunctionsBaseUrl,
  Xe as maskWqlLiteralsAndComments,
  G1 as mergeIntervals,
  Xl as mergeProxyContext,
  A1 as normalizeEmail,
  Kn as omitByRecursively,
  H1 as pickMostRecentDoc,
  X1 as prepareInterviewGroups,
  el as prepareMultidayInterviewCancellationDateString,
  U1 as regionId,
  Dl as replaceTemplateVariables,
  wl as replaceTemplateVariablesForBriefs,
  vl as replaceTemplateVariablesV2,
  O1 as requiresStaticIP,
  rl as resolveLinkMessagingSettings,
  Gl as rolesToInterviewerResolveLimit,
  W1 as sanitizeCssStyle,
  G2 as sanitizeCsvRecord,
  mn as sanitizeCsvValue,
  ml as sanitizeEmailAddress,
  ye as sanitizePlainText,
  Q1 as selectInterviewForReminders,
  xl as statusColumns,
  Pd as validateAndNormalizeAvailabilityParams,
  bl as validatePhoneNumber,
  T2 as validateWorkersWql,
  ul as wait,
  Un as wdays
};
//# sourceMappingURL=utils.es.js.map
